// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   KnowledgeGraphNew.css
   Styles for Steps 5–7: Community Navigation, Search & Discovery,
   User Items Intelligence (Document DNA, Network, Timeline, Bridge)
   ============================================================================= */

/* ── Shared Skeleton Animation ─────────────────────────────────────────────── */
@keyframes shimmer {
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
}
.skeleton-line {
  height: 14px;
  border-radius: 6px;
  background: linear-gradient(90deg,
    var(--bg-tertiary) 25%,
    var(--border-color) 50%,
    var(--bg-tertiary) 75%);
  background-size: 600px 100%;
  animation: shimmer 1.4s infinite linear;
  margin-bottom: 8px;
}
.skeleton-title { height: 18px; width: 60%; }
.skeleton-bar   { height: 8px;  width: 100%; }
.skeleton-short { height: 12px; width: 40%; }

/* ── Rating badges (shared) ─────────────────────────────────────────────────── */
.community-rating-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: .4px;
  text-transform: uppercase;
}
.rating-high { background: rgba(16,185,129,.15); color: #059669; }
.rating-med  { background: rgba(245,158, 11,.15); color: #b45309; }
.rating-low  { background: rgba(156,163,175,.15); color: #6b7280; }

/* =============================================================================
   1. KnowledgeGraphPage  (.kgp-*)
   ============================================================================= */
.kgp-container {
  display: flex;
  flex-direction: column;
  gap: 0;
  height: 100%;
  min-height: 0;
}
.kgp-search-row {
  padding: 16px 20px 8px;
  background: var(--bg-secondary, #fff);
  border-bottom: 1px solid var(--border-color, #e4e4e7);
}
.kgp-subtabs {
  display: flex;
  gap: 4px;
  padding: 8px 20px 0;
  background: var(--bg-secondary, #fff);
  border-bottom: 2px solid var(--border-color, #e4e4e7);
  overflow-x: auto;
}
.kgp-subtab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: var(--text-secondary, #71717a);
  cursor: pointer;
  border-bottom: 3px solid transparent;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  transition: color .2s, border-color .2s;
  margin-bottom: -2px;
}
.kgp-subtab:hover  { color: var(--text-primary, #18181b); }
.kgp-subtab.active { color: var(--accent, #2563eb); border-bottom-color: var(--accent, #2563eb); font-weight: 600; }
.kgp-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  background: var(--bg-primary, #f4f4f5);
}

/* =============================================================================
   2. CommunityGrid  (.community-*)
   ============================================================================= */
.community-grid-page { display: flex; flex-direction: column; gap: 16px; }

.community-grid-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.community-search-wrap {
  position: relative;
  flex: 1 1;
  min-width: 200px;
}
.community-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
  pointer-events: none;
}
.community-search-input {
  width: 100%;
  padding: 10px 36px 10px 36px;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  background: var(--bg-secondary, #fff);
  color: var(--text-primary, #18181b);
  font-size: 0.9rem;
  transition: border-color .2s, box-shadow .2s;
}
.community-search-input:focus {
  outline: none;
  border-color: var(--accent, #2563eb);
  box-shadow: 0 0 0 3px rgba(37,99,235,.1);
}
.community-search-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-secondary);
  padding: 4px;
  font-size: 0.8rem;
}

.community-view-toggle { display: flex; gap: 4px; }
.view-toggle-btn {
  padding: 8px 12px;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  background: var(--bg-secondary, #fff);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all .2s;
}
.view-toggle-btn.active,
.view-toggle-btn:hover {
  background: var(--accent, #2563eb);
  color: #fff;
  border-color: var(--accent, #2563eb);
}

/* Grid / List layouts */
.community-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}
.community-grid.community-list-mode {
  grid-template-columns: 1fr;
}

/* Community Card */
.community-card {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 12px;
  padding: 18px;
  cursor: pointer;
  transition: box-shadow .2s, transform .2s;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.community-card:hover {
  box-shadow: 0 6px 20px rgba(0,0,0,.10);
  transform: translateY(-2px);
}
.community-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.community-card-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary, #18181b);
  margin: 0;
  line-height: 1.3;
  flex: 1 1;
}
.community-rating-bar-wrap {
  height: 5px;
  background: var(--bg-tertiary, #f4f4f5);
  border-radius: 999px;
  overflow: hidden;
}
.community-rating-bar-fill {
  height: 100%;
  border-radius: 999px;
  transition: width .4s ease;
}
.community-card-summary {
  font-size: 0.85rem;
  color: var(--text-secondary, #71717a);
  line-height: 1.55;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
}
.community-card-summary.expanded {
  display: block;
  -webkit-line-clamp: unset;
}
.community-read-more {
  background: none;
  border: none;
  color: var(--accent, #2563eb);
  font-size: 0.8rem;
  cursor: pointer;
  padding: 0;
  font-weight: 500;
}
.community-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid var(--border-color, #e4e4e7);
}
.community-node-count {
  font-size: 0.8rem;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 5px;
}
.community-explore-hint {
  font-size: 0.8rem;
  color: var(--accent, #2563eb);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
}

/* Skeleton card */
.community-card-skeleton { cursor: default; }
.community-card-skeleton:hover { box-shadow: none; transform: none; }

/* Empty / Error states */
.community-empty-state, .community-error-state {
  text-align: center;
  padding: 48px 24px;
  color: var(--text-secondary);
}
.community-empty-icon {
  font-size: 3rem;
  margin-bottom: 16px;
  opacity: .5;
  display: block;
}
.community-empty-state h3 { font-size: 1.1rem; margin-bottom: 8px; color: var(--text-primary); }
.community-empty-state p  { font-size: 0.9rem; margin-bottom: 16px; }
.community-error-state {
  background: rgba(239,68,68,.08);
  border: 1px solid rgba(239,68,68,.2);
  border-radius: 8px;
  color: #dc2626;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
  font-size: 0.9rem;
}

/* =============================================================================
   3. CommunityDetailPanel  (.cdp-*)
   ============================================================================= */
.cdp-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.cdp-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 16px;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all .2s;
  align-self: flex-start;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}
.cdp-back-btn:hover { 
  border-color: var(--accent, #2563eb); 
  color: var(--accent, #2563eb); 
  box-shadow: 0 2px 6px rgba(37,99,235,0.15);
}

.cdp-split {
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 20px;
  flex: 1 1;
  min-height: 500px;
  overflow: hidden;
}
@media (max-width: 900px) {
  .cdp-split {
    grid-template-columns: 1fr;
    height: auto;
    min-height: unset;
    overflow: visible;
  }
}

/* Left panel */
.cdp-left-panel {
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 12px;
  overflow: hidden;
  height: 100%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.03);
}
.cdp-comm-header {
  padding: 24px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  flex-shrink: 0;
  background: var(--bg-tertiary, #fafafa);
}
.cdp-comm-header h2 { 
  font-size: 1.2rem; 
  font-weight: 700; 
  margin: 0 0 12px 0; 
  color: var(--text-primary); 
  line-height: 1.35;
}
.cdp-comm-meta { 
  display: flex; 
  align-items: center; 
  gap: 8px; 
  margin-bottom: 16px; 
  flex-wrap: wrap; 
}
.cdp-rating-pill {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #fff;
}
.cdp-node-pill {
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--text-secondary);
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  padding: 3px 12px;
  border-radius: 999px;
}
.cdp-comm-summary { 
  font-size: 0.9rem; 
  color: var(--text-secondary); 
  line-height: 1.6; 
  margin: 0; 
  background: var(--bg-secondary, #fff);
  padding: 14px;
  border-radius: 8px;
  border: 1px solid var(--border-color, #e4e4e7);
}

.cdp-node-list-header {
  padding: 14px 20px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  flex-shrink: 0;
  background: var(--bg-secondary, #fff);
}
.cdp-node-list-header h4 { 
  margin: 0; 
  font-size: 0.8rem; 
  color: var(--text-secondary); 
  font-weight: 700; 
  text-transform: uppercase; 
  letter-spacing: 0.5px; 
}
.cdp-node-list { 
  overflow-y: auto; 
  flex: 1 1; 
  padding: 12px; 
  background: var(--bg-secondary, #fff);
}
.cdp-node-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background .15s, border-color .15s;
  border: 1px solid transparent;
  margin-bottom: 4px;
}
.cdp-node-item:hover, .cdp-node-item.highlighted { 
  background: var(--bg-tertiary, #f8fafc);
  border-color: var(--border-color, #e4e4e7);
}
.cdp-node-type-chip {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 0.68rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.cdp-node-name { 
  flex: 1 1; 
  font-size: 0.88rem; 
  font-weight: 500;
  color: var(--text-primary); 
  min-width: 0; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  white-space: nowrap; 
}
.cdp-node-context-btn {
  background: var(--bg-tertiary, #f4f4f5);
  border: 1px solid var(--border-color, #e4e4e7);
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all .15s;
  font-size: 0.8rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cdp-node-context-btn:hover { 
  background: var(--accent, #2563eb); 
  border-color: var(--accent, #2563eb);
  color: #fff; 
}
.cdp-empty-nodes { font-size: 0.85rem; color: var(--text-secondary); text-align: center; padding: 24px; }

/* Right canvas — needs explicit height for ReactFlow */
.cdp-graph-canvas {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  height: 100%;
  min-height: 500px;
  display: flex;
  flex-direction: column;
}
.cdp-canvas-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--text-secondary);
  gap: 12px;
}
.cdp-canvas-empty i { font-size: 2.5rem; opacity: .4; }

/* Edge tooltip — rendered inside ReactFlow Panel */
.cdp-edge-tooltip {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 0.82rem;
  max-width: 420px;
  box-shadow: 0 4px 16px rgba(0,0,0,.15);
  z-index: 10;
  line-height: 1.45;
  pointer-events: none;
}
.cdp-edge-tooltip strong { color: var(--text-primary); }

/* Make sure ReactFlow renders full height within its wrapper */
.cdp-graph-canvas .react-flow,
.cdp-graph-canvas .react-flow__renderer,
.cdp-graph-canvas .react-flow__container {
  /* Use explicit 100% without !important to allow flex context to work */
  width: 100%;
  height: 100%;
}

/* Entity drawer overlay */
.cdp-entity-drawer {
  position: absolute;
  top: 0; right: 0;
  width: min(340px, 100%);
  height: 100%;
  background: var(--bg-secondary, #fff);
  border-left: 1px solid var(--border-color, #e4e4e7);
  border-radius: 0 12px 12px 0;
  overflow-y: auto;
  z-index: 20;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: -4px 0 16px rgba(0,0,0,.08);
}
.cdp-entity-drawer-header {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.cdp-entity-drawer-header h3 { margin: 0; flex: 1 1; font-size: 1rem; color: var(--text-primary); }
.cdp-close-btn {
  background: none;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  padding: 5px 9px;
  cursor: pointer;
  color: var(--text-secondary);
  font-size: 0.85rem;
  transition: all .2s;
}
.cdp-close-btn:hover { background: var(--danger, #ef4444); color: #fff; border-color: var(--danger, #ef4444); }
.cdp-entity-description { font-size: 0.85rem; color: var(--text-secondary); line-height: 1.55; }
.cdp-entity-props { display: flex; flex-direction: column; gap: 6px; }
.cdp-entity-prop-row {
  display: flex;
  gap: 8px;
  font-size: 0.82rem;
  padding: 6px 0;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
}
.cdp-prop-key { color: var(--text-secondary); min-width: 90px; font-weight: 600; }
.cdp-prop-val { color: var(--text-primary); flex: 1 1; word-break: break-all; }

/* Loading / Error */
.cdp-loading, .cdp-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px;
  color: var(--text-secondary);
  height: 100%;
}
.cdp-loading-spinner {
  width: 36px; height: 36px;
  border: 3px solid var(--border-color, #e4e4e7);
  border-top-color: var(--accent, #2563eb);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
.cdp-error { color: #dc2626; }

/* =============================================================================
   4. EntityTreeViewer  (.etv-*)
   ============================================================================= */
.etv-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 12px;
  overflow: hidden;
}

.etv-header {
  padding: 16px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.etv-header-left h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
}
.etv-root-name {
  font-weight: 400;
  color: var(--text-secondary);
  font-size: 0.95rem;
}
.etv-stats {
  display: block;
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-top: 4px;
  margin-left: 24px;
}
.etv-close-btn {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  transition: all .2s;
}
.etv-close-btn:hover { background: var(--bg-tertiary, #f4f4f5); color: var(--text-primary); }

.etv-controls {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  display: flex;
  gap: 20px;
  background: var(--bg-tertiary, #fafafa);
  flex-wrap: wrap;
}
.etv-control-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.etv-control-group label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text-secondary);
  letter-spacing: .5px;
}
.etv-seg-btns {
  display: inline-flex;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  padding: 2px;
}
.etv-seg-btn {
  background: none;
  border: none;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all .2s;
}
.etv-seg-btn.active {
  background: var(--bg-tertiary, #e4e4e7);
  color: var(--text-primary);
  font-weight: 600;
}
.etv-depth-slider { width: 120px; }

.etv-content { flex: 1 1; overflow-y: auto; padding: 16px; position: relative; }
.etv-tree-wrap, .etv-flat-list { display: flex; flex-direction: column; gap: 2px; }

.etv-tree-node { display: flex; flex-direction: column; }
.etv-tree-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background .15s;
  min-height: 32px;
}
.etv-tree-row:hover { background: var(--bg-tertiary, #f4f4f5); }

.etv-expand-btn {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 0.7rem;
  padding: 0;
}
.etv-expand-btn:disabled { cursor: default; opacity: .3; }

.etv-type-chip {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.65rem;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
}
.etv-entity-name {
  font-size: 0.85rem;
  color: var(--text-primary);
  font-weight: 500;
}
.etv-rel-tag {
  font-size: 0.7rem;
  color: var(--text-secondary);
  background: var(--bg-tertiary, #f4f4f5);
  padding: 1px 6px;
  border-radius: 4px;
  border: 1px solid var(--border-color, #e4e4e7);
}
.etv-evidence-link {
  color: var(--text-secondary);
  font-size: 0.8rem;
  opacity: .6;
  transition: opacity .2s;
}
.etv-evidence-link:hover { opacity: 1; color: var(--accent, #2563eb); }
.etv-context-btn {
  margin-left: auto;
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  opacity: 0;
  transition: opacity .2s, background .2s;
}
.etv-tree-row:hover .etv-context-btn { opacity: 1; }
.etv-context-btn:hover { background: var(--bg-secondary, #fff); color: var(--accent, #2563eb); }

/* Flat view rows */
.etv-flat-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-bottom: 1px solid var(--border-color, #f4f4f5);
}
.etv-flat-row:last-child { border-bottom: none; }

/* Loading/Empty/Error */
.etv-loading, .etv-empty, .etv-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--text-secondary);
  gap: 10px;
  padding: 20px;
}
.etv-spinner {
  width: 24px; height: 24px;
  border: 2px solid var(--border-color);
  border-top-color: var(--text-secondary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* =============================================================================
   5. UnifiedSearchBar & Results (.usb-*, .sr-*)
   ============================================================================= */
.usb-container { position: relative; width: 100%; max-width: 600px; }

.usb-bar {
  display: flex;
  align-items: center;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  padding: 0 12px;
  height: 40px;
  transition: box-shadow .2s, border-color .2s;
}
.usb-bar:focus-within {
  border-color: var(--accent, #2563eb);
  box-shadow: 0 0 0 3px rgba(37,99,235,.1);
}
.usb-icon { color: var(--text-secondary); margin-right: 10px; }
.usb-input {
  flex: 1 1;
  border: none;
  background: none;
  font-size: 0.9rem;
  color: var(--text-primary);
  height: 100%;
}
.usb-input:focus { outline: none; }
.usb-clear {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px;
  font-size: 0.85rem;
}

/* Search Results Panel */
.sr-panel {
  position: absolute;
  top: 48px;
  left: 0;
  width: 100%;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,.12);
  z-index: 100;
  overflow: hidden;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.sr-tabs {
  display: flex;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  background: var(--bg-tertiary, #fafafa);
}
.sr-tab {
  flex: 1 1;
  padding: 10px;
  background: none;
  border: none;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all .2s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}
.sr-tab:hover { background: rgba(0,0,0,.02); color: var(--text-primary); }
.sr-tab.active { color: var(--accent, #2563eb); border-bottom-color: var(--accent, #2563eb); background: var(--bg-secondary, #fff); }
.sr-tab-count {
  background: var(--bg-tertiary, #e4e4e7);
  padding: 1px 6px;
  border-radius: 99px;
  font-size: 0.7rem;
  min-width: 16px;
  text-align: center;
}

.sr-results-body {
  overflow-y: auto;
  max-height: 500px;
  padding: 8px 0;
}
.sr-loading, .sr-error, .sr-empty {
  padding: 24px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.9rem;
}
.sr-spinner {
  display: inline-block;
  width: 16px; height: 16px;
  border: 2px solid var(--text-secondary);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
  vertical-align: middle;
}

/* Result items */
.sr-result-item {
  padding: 10px 16px;
  border-bottom: 1px solid var(--border-color, #f4f4f5);
  cursor: pointer;
  transition: background .15s;
}
.sr-result-item:hover { background: var(--bg-tertiary, #f8fafc); }
.sr-result-item:last-child { border-bottom: none; }

/* Community result */
.sr-community .sr-result-header { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; }
.sr-result-summary { font-size: 0.8rem; color: var(--text-secondary); margin: 0; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

/* Entity result */
.sr-entity { display: flex; align-items: center; gap: 10px; }
.sr-type-chip {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.65rem;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  flex-shrink: 0;
}
.sr-result-body { flex: 1 1; min-width: 0; }
.sr-chevron { color: var(--text-secondary); opacity: .4; font-size: 0.8rem; }

/* Evidence result */
.sr-evidence { display: flex; flex-direction: column; gap: 6px; }
.sr-evidence-quote {
  font-size: 0.85rem;
  color: var(--text-primary);
  border-left: 3px solid var(--border-color, #e4e4e7);
  padding-left: 10px;
  margin: 0;
  font-style: italic;
  line-height: 1.5;
  background: var(--bg-tertiary, #fafafa);
  padding: 8px 10px;
  border-radius: 0 4px 4px 0;
}
.sr-expand-btn {
  display: block;
  margin-top: 4px;
  background: none;
  border: none;
  color: var(--accent, #2563eb);
  font-size: 0.75rem;
  cursor: pointer;
  padding: 0;
}
.sr-evidence-meta { display: flex; align-items: center; gap: 8px; font-size: 0.75rem; color: var(--text-secondary); flex-wrap: wrap; }
.sr-source-link { color: inherit; text-decoration: none; display: flex; align-items: center; gap: 4px; }
.sr-source-link:hover { color: var(--accent, #2563eb); }
.sr-provider-chip { background: var(--bg-tertiary, #e4e4e7); padding: 1px 6px; border-radius: 4px; }
.sr-entity-tags { display: flex; gap: 4px; flex-wrap: wrap; margin-top: 2px; }
.sr-entity-tag { font-size: 0.7rem; background: rgba(37,99,235,.1); color: var(--accent, #2563eb); padding: 1px 6px; border-radius: 4px; }

/* Highlight mark */
mark { background: #fef08a; color: inherit; padding: 0 1px; border-radius: 2px; }

/* =============================================================================
   6. EvidenceResultCard (Standalone) (.erc-*)
   ============================================================================= */
.erc-card {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,.04);
  margin-bottom: 12px;
}
.erc-quote {
  font-size: 0.9rem;
  line-height: 1.6;
  color: var(--text-primary);
  margin: 0 0 12px 0;
}
.erc-highlight { background: rgba(250, 204, 21, 0.3); font-weight: 500; }
.erc-expand-btn {
  display: block;
  margin-top: 8px;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 0.8rem;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}
.erc-expand-btn:hover { color: var(--accent, #2563eb); }

.erc-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border-color, #f4f4f5);
  font-size: 0.8rem;
  color: var(--text-secondary);
}
.erc-file-link {
  color: var(--text-primary);
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}
.erc-file-link:hover { color: var(--accent, #2563eb); text-decoration: underline; }
.erc-provider-chip {
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 0.7rem;
}

.erc-entities {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.erc-entities-label { font-size: 0.75rem; color: var(--text-secondary); font-weight: 600; }
.erc-entity-tag {
  background: var(--bg-tertiary, #f4f4f5);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 0.75rem;
  color: var(--text-primary);
  cursor: pointer;
  transition: all .2s;
}
.erc-entity-tag:hover { border-color: var(--accent, #2563eb); color: var(--accent, #2563eb); }

/* =============================================================================
   7. LatentConnectionPanel (.lcp-*)
   ============================================================================= */
.lcp-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 12px;
  overflow: hidden;
}
.lcp-header {
  padding: 16px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lcp-header h3 { margin: 0; font-size: 1.1rem; display: flex; align-items: center; gap: 8px; }
.lcp-close-btn { background: none; border: none; font-size: 1.1rem; color: var(--text-secondary); cursor: pointer; }

.lcp-controls {
  padding: 16px;
  background: var(--bg-tertiary, #fafafa);
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}
.lcp-control-row { display: flex; flex-direction: column; gap: 6px; }
.lcp-label { font-size: 0.75rem; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; }

/* Entity Input with Suggestions */
.lcp-entity-input-wrap { position: relative; }
.lcp-entity-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--border-color, #d4d4d8);
  border-radius: 6px;
  font-size: 0.9rem;
}
.lcp-entity-input:focus { outline: none; border-color: var(--accent, #2563eb); }
.lcp-input-spinner { position: absolute; right: 10px; top: 10px; color: var(--text-secondary); font-size: 0.8rem; }
.lcp-suggestions {
  position: absolute;
  top: 100%; left: 0; width: 100%;
  background: #fff;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,.1);
  margin-top: 4px;
  z-index: 50;
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
}
.lcp-suggestion-item {
  padding: 8px 12px;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
.lcp-suggestion-item:hover { background: var(--bg-tertiary, #f4f4f5); }
.lcp-sug-chip { font-size: 0.65rem; color: #fff; padding: 1px 5px; border-radius: 4px; font-weight: 700; }

/* Slider & Button */
.lcp-score-slider { width: 100%; }
.lcp-attr-input {
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 0.9rem;
}
.lcp-discover-btn {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 10px;
  font-weight: 600;
}

/* Results Area */
.lcp-results { flex: 1 1; display: flex; flex-direction: column; overflow: hidden; }
.lcp-seed-info {
  padding: 12px 16px;
  background: #eff6ff;
  border-bottom: 1px solid #dbeafe;
  color: #1e3a8a;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
}
.lcp-tabs {
  display: flex;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  background: #fff;
}
.lcp-tab {
  flex: 1 1;
  padding: 12px;
  background: none;
  border: none;
  font-weight: 600;
  color: var(--text-secondary);
  border-bottom: 3px solid transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.lcp-tab.active { color: var(--accent, #2563eb); border-bottom-color: var(--accent, #2563eb); background: #fafafa; }
.lcp-tab-count { background: #e4e4e7; color: #52525b; padding: 1px 8px; border-radius: 99px; font-size: 0.75rem; }

.lcp-tab-content { flex: 1 1; overflow-y: auto; padding: 0; background: #fafafa; }
.lcp-empty { padding: 40px; text-align: center; color: var(--text-secondary); font-style: italic; }

/* Connection Row */
.lcp-conn-row {
  background: #fff;
  border-bottom: 1px solid var(--border-color, #f4f4f5);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.lcp-conn-row:hover { background: #f8fafc; }
.lcp-conn-type-chip { font-size: 0.65rem; color: #fff; padding: 2px 6px; border-radius: 4px; font-weight: 700; width: 24px; text-align: center; overflow: hidden; text-overflow: ellipsis; }
.lcp-conn-name { flex: 1 1; font-weight: 500; color: var(--text-primary); }

.lcp-conf-badge {
  font-size: 0.7rem;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  text-transform: uppercase;
}
.conf-strong { background: #dcfce7; color: #15803d; }
.conf-mod    { background: #fef9c3; color: #a16207; }
.conf-weak   { background: #f3f4f6; color: #6b7280; }

.lcp-reason-tag {
  font-size: 0.7rem;
  padding: 2px 8px;
  border-radius: 99px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.lcp-reason-attr { background: #fff7ed; color: #c2410c; border: 1px solid #ffedd5; }
.lcp-reason-cooc { background: #eff6ff; color: #1d4ed8; border: 1px solid #dbeafe; }

.lcp-conf-bar {
  width: 60px;
  height: 4px;
  background: #e4e4e7;
  border-radius: 2px;
  overflow: hidden;
}
.lcp-conf-bar-fill { height: 100%; background: var(--accent, #2563eb); }
.lcp-view-btn {
  background: none;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.75rem;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all .2s;
}
.lcp-view-btn:hover { border-color: var(--accent, #2563eb); color: var(--accent, #2563eb); }

/* Bridge Row */
.lcp-bridge-row {
  background: #fff;
  border-bottom: 1px solid var(--border-color, #f4f4f5);
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.lcp-bridge-count { font-size: 0.8rem; color: var(--text-secondary); }
.lcp-community-pills { display: flex; flex-wrap: wrap; gap: 6px; }
.lcp-comm-pill {
  background: #f4f4f5;
  border: 1px solid #e4e4e7;
  padding: 2px 8px;
  border-radius: 99px;
  font-size: 0.7rem;
  color: var(--text-secondary);
  cursor: pointer;
}
.lcp-comm-pill:hover { border-color: var(--accent, #2563eb); color: var(--accent, #2563eb); }

/* =============================================================================
   8. DocumentDNAList (.dna-*)
   ============================================================================= */
.dna-list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  overflow: hidden;
}
.dna-toolbar {
  padding: 16px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-secondary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-shrink: 0;
}
.dna-toolbar h3 {
  margin: 0;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-primary);
}

.dna-sort-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: var(--text-secondary);
}
.dna-sort-select {
  padding: 6px 10px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 0.85rem;
  background: var(--bg-secondary);
  color: var(--text-primary);
}
.dna-sort-select:focus { outline: none; border-color: var(--accent); }
.dna-refresh-btn { padding: 6px 10px; }

/* The list scroll area — uses flex column so each row naturally pushes down */
.dna-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: var(--bg-primary);
}
.dna-empty, .dna-error {
  text-align: center;
  padding: 40px;
  color: var(--text-secondary);
}
.dna-empty i { font-size: 3rem; margin-bottom: 16px; opacity: .4; display: block; }
.dna-no-knowledge {
  font-size: 0.9rem;
  color: var(--text-secondary);
  font-style: italic;
  padding: 8px 0;
}

/* Each row is a flex column — header + detail. No overflow:hidden so expansion is visible */
.dna-row {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  transition: box-shadow .2s;
  /* Do NOT use overflow:hidden — it clips the expanded detail panel */
}
.dna-row:hover { box-shadow: 0 4px 12px rgba(0,0,0,.10); }
.dna-row-failed { border-left: 4px solid #ef4444; }

.dna-row-main {
  display: grid;
  grid-template-columns: 2fr 100px 1.5fr 1.5fr 30px;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  cursor: pointer;
  border-radius: 8px;
  -webkit-user-select: none;
          user-select: none;
}
.dna-row-main:hover { background: var(--bg-tertiary); }

@media (max-width: 900px) {
  .dna-row-main { grid-template-columns: 1fr 30px; gap: 8px; }
  .dna-status-badge, .dna-impact-col, .dna-strip-col { display: none; }
}

.dna-name-col { display: flex; align-items: center; gap: 8px; min-width: 0; overflow: hidden; }
.dna-source-icon { font-size: 0.85rem; color: var(--text-secondary); flex-shrink: 0; }

/* Name + description stacked block */
.dna-name-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow: hidden;
}
.dna-file-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.dna-file-desc {
  font-size: 0.75rem;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  font-style: italic;
  line-height: 1.3;
}
.dna-provider-badge {
  font-size: 0.7rem;
  background: var(--bg-tertiary);
  padding: 2px 6px;
  border-radius: 4px;
  color: var(--text-secondary);
  flex-shrink: 0;
}

/* Status icon colors (inline icon, not badge) */
.dna-status-ok      { color: #15803d; }
.dna-status-pending { color: #a16207; }
.dna-status-fail    { color: #b91c1c; }
.dna-status-none    { color: #71717a; }

/* Status Badges (the pill label in the grid) */
.dna-status-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 99px;
  text-align: center;
  white-space: nowrap;
}
.dna-status-badge.dna-status-ok      { background: rgba(16,185,129,.15); color: #15803d; }
.dna-status-badge.dna-status-pending { background: rgba(245,158,11,.15);  color: #a16207; }
.dna-status-badge.dna-status-fail    { background: rgba(239,68,68,.15);   color: #b91c1c; }
.dna-status-badge.dna-status-none    { background: var(--bg-tertiary);    color: var(--text-secondary); }

/* Impact Bar */
.dna-impact-col { display: flex; flex-direction: column; gap: 4px; }
.dna-impact-bar {
  height: 6px;
  background: var(--bg-tertiary);
  border-radius: 3px;
  overflow: hidden;
  width: 100%;
}
.dna-impact-fill { height: 100%; background: var(--accent); border-radius: 3px; }
.dna-impact-label { font-size: 0.7rem; color: var(--text-secondary); }

/* DNA Strip */
.dna-strip {
  height: 12px;
  display: flex;
  border-radius: 4px;
  overflow: hidden;
  background: var(--bg-tertiary);
  width: 100%;
}
.dna-strip-empty {
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  color: var(--text-secondary);
  width: 100%;
  opacity: .6;
}
.dna-expand-icon { color: var(--text-secondary); opacity: .5; }

/* ── Expanded Detail panel ───────────────────────────────────────────────── */
.dna-row-detail {
  padding: 16px;
  border-top: 1px solid var(--border-color);
  background: var(--bg-tertiary);
  border-radius: 0 0 8px 8px;
}

/* Description block in expanded DNA row */
.dna-detail-description {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 14px;
}
.dna-detail-description h5 {
  margin: 0 0 8px 0;
  font-size: 0.8rem;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: .4px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
}
.dna-detail-description p {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-primary);
  line-height: 1.6;
}

.dna-failed-notice {
  background: rgba(239,68,68,.12);
  color: #b91c1c;
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid rgba(239,68,68,.25);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  margin-bottom: 12px;
}
.dna-community-list h5 {
  margin: 0 0 10px 0;
  font-size: 0.8rem;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: .4px;
  font-weight: 700;
}
.dna-comm-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid var(--border-color);
  font-size: 0.9rem;
}
.dna-comm-row:last-child { border-bottom: none; }
.dna-comm-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.dna-comm-title { flex: 1 1; font-weight: 500; color: var(--text-primary); min-width: 0; overflow: hidden; text-overflow: ellipsis; }
.dna-comm-rating { color: var(--text-secondary); font-size: 0.85rem; white-space: nowrap; }
.dna-explore-comm-btn {
  font-size: 0.75rem;
  padding: 4px 10px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--accent);
  white-space: nowrap;
  flex-shrink: 0;
  transition: all .2s;
}
.dna-explore-comm-btn:hover {
  border-color: var(--accent);
  background: rgba(37,99,235,.08);
}
.dna-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.dna-action-btn { font-size: 0.85rem; padding: 8px 16px; display: flex; align-items: center; gap: 8px; }

/* =============================================================================
   8b. DocumentDNADetail (.ddd-*)
   Full DNA View for a single document — comprehensive, easy-to-read layout
   ============================================================================= */

.ddd-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Back / breadcrumb row ── */
.ddd-header-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* ── Hero card ── */
.ddd-hero {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,.06);
}
.ddd-hero-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(37,99,235,.12) 0%, rgba(99,102,241,.12) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ddd-hero-icon {
  font-size: 1.6rem;
  color: var(--accent, #2563eb);
}
.ddd-hero-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ddd-hero-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary, #18181b);
  word-break: break-word;
  line-height: 1.35;
}
.ddd-hero-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ddd-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 99px;
  font-size: 0.78rem;
  font-weight: 600;
  border: 1px solid transparent;
  white-space: nowrap;
}
.ddd-chip-provider {
  background: rgba(99,102,241,.1);
  color: #4f46e5;
  border-color: rgba(99,102,241,.2);
}
.ddd-chip-date {
  background: var(--bg-tertiary, #f4f4f5);
  color: var(--text-secondary, #71717a);
  border-color: var(--border-color, #e4e4e7);
}
/* Reuse existing dna-status-* colours for the chip */
.ddd-meta-chip.dna-status-ok      { background: rgba(16,185,129,.1);  color: #15803d; border-color: rgba(16,185,129,.2); }
.ddd-meta-chip.dna-status-pending { background: rgba(245,158,11,.1);  color: #a16207; border-color: rgba(245,158,11,.2); }
.ddd-meta-chip.dna-status-fail    { background: rgba(239,68,68,.1);   color: #b91c1c; border-color: rgba(239,68,68,.2); }
.ddd-meta-chip.dna-status-none    { background: var(--bg-tertiary);   color: var(--text-secondary); }

.ddd-url-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  color: var(--accent, #2563eb);
  text-decoration: none;
  word-break: break-all;
  line-height: 1.4;
}
.ddd-url-link:hover { text-decoration: underline; }
.ddd-hero-desc {
  margin: 0;
  font-size: 0.88rem;
  color: var(--text-secondary, #71717a);
  line-height: 1.6;
}
.ddd-hero-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
  align-self: flex-start;
}
.ddd-download-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
}
.ddd-download-btn:disabled { opacity: .6; cursor: not-allowed; }

@media (max-width: 720px) {
  .ddd-hero {
    flex-direction: column;
  }
  .ddd-hero-actions {
    width: 100%;
  }
  .ddd-download-btn {
    width: 100%;
    justify-content: center;
  }
}

/* ── Stats bar ── */
.ddd-stats-bar {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1px;
  background: var(--border-color, #e4e4e7);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 12px;
  overflow: hidden;
}
.ddd-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 18px 16px;
  background: var(--bg-secondary, #fff);
  text-align: center;
}
.ddd-stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary, #18181b);
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 1;
}
.ddd-stat-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .4px;
  color: var(--text-secondary, #71717a);
}
/* Status dot inside stat value */
.ddd-status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.ddd-status-dot.dna-status-ok      { background: #15803d; }
.ddd-status-dot.dna-status-pending { background: #a16207; }
.ddd-status-dot.dna-status-fail    { background: #b91c1c; }
.ddd-status-dot.dna-status-none    { background: #6b7280; }
/* DNA strip inside the wider stat cell */
.ddd-stat-strip {
  grid-column: span 2;
  align-items: stretch;
  gap: 8px;
}
.ddd-stat-strip .dna-strip {
  height: 16px;
  border-radius: 6px;
  width: 100%;
}
@media (max-width: 600px) {
  .ddd-stat-strip { grid-column: span 1; }
}

/* ── Section wrapper ── */
.ddd-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ddd-section-header { display: flex; flex-direction: column; gap: 4px; }
.ddd-section-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary, #18181b);
  display: flex;
  align-items: center;
  gap: 8px;
}
.ddd-section-title i { color: var(--accent, #2563eb); }
.ddd-section-subtitle {
  margin: 0;
  font-size: 0.85rem;
  color: var(--text-secondary, #71717a);
}

/* ── Community grid ── */
.ddd-comm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

/* ── Community Card (rich — matches community-card style) ── */
.ddd-comm-card {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 12px;
  padding: 18px;
  cursor: pointer;
  transition: box-shadow .2s, transform .2s;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ddd-comm-card:hover {
  box-shadow: 0 6px 20px rgba(0,0,0,.10);
  transform: translateY(-2px);
}

/* Header row: title + rating badge */
.ddd-comm-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.ddd-comm-card-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary, #18181b);
  margin: 0;
  line-height: 1.3;
  flex: 1 1;
}

/* Weight row */
.ddd-comm-weight-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.ddd-comm-weight-label {
  font-size: 0.78rem;
  color: var(--text-secondary, #71717a);
}
.ddd-comm-weight-value {
  font-size: 0.85rem;
  font-weight: 700;
}

/* Optional summary text — show full content */
.ddd-comm-summary {
  font-size: 0.85rem;
  color: var(--text-secondary, #71717a);
  line-height: 1.55;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
}
.ddd-comm-summary.expanded {
  display: block;
  -webkit-line-clamp: unset;
}

/* Footer */
.ddd-comm-card-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid var(--border-color, #e4e4e7);
}
.ddd-comm-explore-hint {
  font-size: 0.8rem;
  color: var(--accent, #2563eb);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
}

/* Kept for backward compat in case other files reference these */
.ddd-comm-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}
.ddd-comm-bar-wrap { width: 100%; }
.ddd-comm-bar {
  height: 6px;
  background: var(--bg-tertiary, #f4f4f5);
  border-radius: 3px;
  overflow: hidden;
}
.ddd-comm-bar-fill {
  height: 100%;
  border-radius: 3px;
  transition: width .4s ease;
}

/* ── Empty state ── */
.ddd-empty-communities {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px 24px;
  background: var(--bg-secondary, #fff);
  border: 1px dashed var(--border-color, #e4e4e7);
  border-radius: 12px;
  text-align: center;
  color: var(--text-secondary, #71717a);
}
.ddd-empty-communities i { font-size: 2.5rem; opacity: .4; }
.ddd-empty-communities p { margin: 0; font-size: 0.95rem; color: var(--text-primary, #18181b); }
.ddd-empty-communities span { font-size: 0.83rem; }

/* ── Journey hint banner ── */
.ddd-journey-hint {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  background: rgba(37,99,235,.06);
  border: 1px solid rgba(37,99,235,.15);
  border-radius: 10px;
  font-size: 0.85rem;
  color: var(--text-secondary, #71717a);
  line-height: 1.5;
}
.ddd-journey-hint > i {
  font-size: 1.1rem;
  color: var(--accent, #2563eb);
  flex-shrink: 0;
}
.ddd-journey-hint strong { color: var(--text-primary, #18181b); }

/* ── Dark theme overrides for ddd-* ── */
[data-theme="dark"] .ddd-hero {
  box-shadow: 0 2px 8px rgba(0,0,0,.3);
}
[data-theme="dark"] .ddd-hero-icon-wrap {
  background: linear-gradient(135deg, rgba(37,99,235,.2) 0%, rgba(99,102,241,.2) 100%);
}
[data-theme="dark"] .ddd-stat {
  background: var(--bg-secondary);
}
[data-theme="dark"] .ddd-comm-card {
  background: var(--bg-secondary);
}
[data-theme="dark"] .ddd-comm-card:hover {
  box-shadow: 0 6px 20px rgba(0,0,0,.4);
}
[data-theme="dark"] .ddd-comm-card-footer {
  border-top-color: var(--border-color);
}
[data-theme="dark"] .ddd-empty-communities {
  background: var(--bg-secondary);
}
[data-theme="dark"] .ddd-journey-hint {
  background: rgba(37,99,235,.1);
  border-color: rgba(37,99,235,.25);
}
[data-theme="dark"] .ddd-meta-chip.dna-status-ok      { background: rgba(16,185,129,.18);  color: #34d399; border-color: rgba(16,185,129,.3); }
[data-theme="dark"] .ddd-meta-chip.dna-status-pending { background: rgba(245,158,11,.18);  color: #fbbf24; border-color: rgba(245,158,11,.3); }
[data-theme="dark"] .ddd-meta-chip.dna-status-fail    { background: rgba(239,68,68,.18);   color: #f87171; border-color: rgba(239,68,68,.3); }
[data-theme="dark"] .ddd-status-dot.dna-status-ok      { background: #34d399; }
[data-theme="dark"] .ddd-status-dot.dna-status-pending { background: #fbbf24; }
[data-theme="dark"] .ddd-status-dot.dna-status-fail    { background: #f87171; }

/* =============================================================================
   9. DocumentNetworkGraph (.dng-*)
   ============================================================================= */
.dng-container {
  display: flex; flex-direction: column; height: 100%;
  background: var(--bg-secondary); border: 1px solid var(--border-color); border-radius: 12px; overflow: hidden;
}
.dng-toolbar {
  padding: 12px 16px; border-bottom: 1px solid var(--border-color);
  display: flex; align-items: center; justify-content: space-between;
}
.dng-control-group { display: flex; align-items: center; gap: 12px; font-size: 0.9rem; }
.dng-slider { width: 140px; }

.dng-layout { display: flex; flex: 1 1; overflow: hidden; position: relative; }
.dng-graph-area { flex: 1 1; background: #f8fafc; position: relative; }
.dng-sidebar-wrap {
  width: 300px; border-left: 1px solid var(--border-color); background: #fff;
  position: absolute; right: 0; top: 0; height: 100%; z-index: 10;
  box-shadow: -4px 0 16px rgba(0,0,0,.05);
}

.dng-sidebar { display: flex; flex-direction: column; height: 100%; }
.dng-sidebar-header {
  padding: 16px; border-bottom: 1px solid var(--border-color);
  display: flex; justify-content: space-between; align-items: center;
}
.dng-sidebar-header h4 { margin: 0; font-size: 1rem; color: var(--text-primary); }
.dng-close-btn { background: none; border: none; cursor: pointer; color: var(--text-secondary); }

.dng-node-provider { padding: 0 16px; margin: 12px 0 0 0; }
.dng-provider-chip { font-size: 0.7rem; color: #fff; padding: 2px 8px; border-radius: 4px; font-weight: 600; }

.dng-conn-label { margin: 16px 16px 8px; font-size: 0.8rem; color: var(--text-secondary); text-transform: uppercase; }
.dng-conn-row {
  padding: 8px 16px; border-bottom: 1px solid #f4f4f5; font-size: 0.9rem;
  display: flex; justify-content: space-between; align-items: center;
}
.dng-shared-count { background: #e0e7ff; color: #3730a3; padding: 2px 6px; border-radius: 4px; font-size: 0.75rem; font-weight: 600; }

.dng-edge-docs { padding: 16px; background: #f8fafc; border-bottom: 1px solid var(--border-color); margin: 0; font-size: 0.9rem; display: flex; flex-direction: column; align-items: center; gap: 8px; text-align: center; }
.dng-edge-icon { color: var(--text-secondary); }
.dng-shared-entities { padding: 16px; display: flex; flex-wrap: wrap; gap: 6px; overflow-y: auto; }
.dng-entity-tag {
  background: #fff; border: 1px solid var(--border-color); border-radius: 4px;
  padding: 4px 8px; font-size: 0.8rem; cursor: pointer; color: var(--text-primary);
  transition: all .2s;
}
.dng-entity-tag:hover { border-color: var(--accent); color: var(--accent); background: #eff6ff; }

.dng-loading, .dng-empty-state {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  height: 100%; color: var(--text-secondary); gap: 12px;
}
.dng-spinner { width: 32px; height: 32px; border: 3px solid var(--border-color); border-top-color: var(--accent); border-radius: 50%; animation: spin 1s linear infinite; }
.dng-empty-icon { font-size: 3rem; opacity: .4; }

/* ── Consolidated Comparison Sidebar ─────────────────────────────────────── */
.dng-sidebar-wide { width: 420px; }
@media (max-width: 600px) { .dng-sidebar-wide { width: 100%; } }

.dng-compare-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--bg-tertiary);
}
.dng-compare-placeholder {
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-style: italic;
  padding: 16px;
  background: var(--bg-secondary);
  border: 1px dashed var(--border-color);
  border-radius: 8px;
}
.dng-shared-graph-wrap {
  position: relative;
  background: var(--bg-secondary);
}

/* ── Enhanced Node Sidebar ───────────────────────────────────────────────── */
.dng-sidebar-title-wrap {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}
.dng-sidebar-source-icon { font-size: 0.9rem; color: var(--text-secondary); flex-shrink: 0; margin-top: 2px; }
.dng-sidebar-title-wrap h4 { margin: 0; font-size: 0.95rem; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; word-break: break-word; line-height: 1.35; }

/* Document metadata table */
.dng-doc-meta {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.dng-meta-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 0.82rem;
}
.dng-meta-key {
  color: var(--text-secondary);
  font-weight: 600;
  flex-shrink: 0;
  min-width: 90px;
}
.dng-meta-val { color: var(--text-primary); }
.dng-meta-status {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 99px;
  text-transform: capitalize;
}
.dng-status-processed, .dng-status-completed, .dng-status-indexed {
  background: rgba(16,185,129,.12); color: #15803d;
}
.dng-status-pending, .dng-status-queued, .dng-status-processing {
  background: rgba(245,158,11,.12); color: #a16207;
}
.dng-status-failed, .dng-status-error {
  background: rgba(239,68,68,.12); color: #b91c1c;
}

/* Description block inside node sidebar */
.dng-doc-description {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color);
}
.dng-section-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: .4px;
  margin: 0 0 6px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}
.dng-doc-description p {
  margin: 0;
  font-size: 0.82rem;
  color: var(--text-primary);
  line-height: 1.55;
}

/* Connected documents list inside node sidebar */
.dng-conn-list { overflow-y: auto; max-height: 180px; }
.dng-conn-row {
  padding: 8px 16px; border-bottom: 1px solid #f4f4f5; font-size: 0.85rem;
  display: flex; justify-content: space-between; align-items: center; gap: 8px;
}
.dng-conn-name { flex: 1 1; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* "Open Document" action at the bottom of the sidebar */
.dng-sidebar-actions {
  padding: 12px 16px;
  border-top: 1px solid var(--border-color);
  margin-top: auto;
}
.dng-open-doc-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  padding: 7px 14px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-secondary);
  color: var(--accent);
  text-decoration: none;
  transition: all .2s;
  cursor: pointer;
  font-weight: 500;
}
.dng-open-doc-btn:hover {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}

/* =============================================================================
   9b. DocumentNetworkGraph — New Features (.dng-*)
   Toolbar enhancements, provider grouping legend, overlap matrix, latent connections
   ============================================================================= */

/* ── Enhanced Toolbar ────────────────────────────────────────────────────── */
.dng-toolbar-enhanced {
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  padding: 10px 16px;
  min-height: 56px;
}
.dng-toolbar-enhanced h3 {
  margin: 0;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.dng-toolbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  flex: 1 1;
  justify-content: flex-end;
}

/* ── Toggle Button Group ─────────────────────────────────────────────────── */
.dng-toggle-group {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.dng-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  background: var(--bg-secondary, #fff);
  color: var(--text-secondary, #71717a);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all .2s;
  white-space: nowrap;
}
.dng-toggle-btn:hover {
  border-color: var(--accent, #2563eb);
  color: var(--accent, #2563eb);
  background: rgba(37,99,235,.05);
}
.dng-toggle-btn.active {
  background: var(--accent, #2563eb);
  color: #fff;
  border-color: var(--accent, #2563eb);
}
.dng-toggle-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 99px;
  font-size: 0.65rem;
  font-weight: 700;
  background: rgba(0,0,0,.12);
  color: inherit;
  line-height: 1;
}
.dng-toggle-btn.active .dng-toggle-badge {
  background: rgba(255,255,255,.25);
  color: #fff;
}
.dng-toggle-badge-active {
  background: rgba(255,255,255,.25) !important;
}

/* ── Provider Grouping Legend ────────────────────────────────────────────── */
.dng-provider-legend {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: var(--bg-tertiary, #fafafa);
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  flex-wrap: wrap;
  font-size: 0.8rem;
}
.dng-provider-legend-label {
  color: var(--text-secondary, #71717a);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.dng-provider-legend-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 99px;
  font-size: 0.75rem;
  color: var(--text-primary, #18181b);
  font-weight: 500;
}
.dng-provider-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.dng-provider-legend-hint {
  display: flex;
  align-items: center;
  gap: 5px;
  color: var(--text-secondary, #71717a);
  font-size: 0.75rem;
  margin-left: auto;
  font-style: italic;
}

/* ── Provider Overlap Matrix Wrapper ─────────────────────────────────────── */
.dng-overlap-wrap {
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  background: var(--bg-secondary, #fff);
  max-height: 300px;
  overflow-y: auto;
  flex-shrink: 0;
}
.dng-overlap-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: var(--bg-tertiary, #fafafa);
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary, #18181b);
  position: sticky;
  top: 0;
  z-index: 2;
}

/* ── Provider Overlap Matrix Content ─────────────────────────────────────── */
.dng-overlap-matrix {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* Provider stat strip */
.dng-overlap-provider-strip {
  display: flex;
  gap: 0;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
}
.dng-overlap-provider-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-right: 1px solid var(--border-color, #e4e4e7);
  min-width: 140px;
  flex: 1 1;
}
.dng-overlap-provider-chip:last-child {
  border-right: none;
}
.dng-overlap-provider-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.dng-overlap-provider-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.dng-overlap-provider-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-primary, #18181b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dng-overlap-provider-stats {
  font-size: 0.7rem;
  color: var(--text-secondary, #71717a);
}

/* Cross-provider pairs section */
.dng-overlap-pairs-section {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.dng-overlap-pairs-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary, #71717a);
  text-transform: uppercase;
  letter-spacing: .4px;
}
.dng-overlap-total-badge {
  font-size: 0.72rem;
  background: var(--bg-tertiary, #f4f4f5);
  color: var(--text-secondary, #71717a);
  padding: 2px 8px;
  border-radius: 99px;
  border: 1px solid var(--border-color, #e4e4e7);
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
}

/* Individual pair rows */
.dng-overlap-pair-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dng-overlap-pair-labels {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 260px;
  flex-shrink: 0;
}
.dng-overlap-pair-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  color: #fff;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dng-overlap-arrow-icon {
  color: var(--text-secondary, #71717a);
  font-size: 0.7rem;
  flex-shrink: 0;
}
.dng-overlap-bar-track {
  flex: 1 1;
  height: 6px;
  background: var(--bg-tertiary, #e4e4e7);
  border-radius: 3px;
  overflow: hidden;
}
.dng-overlap-bar-fill {
  height: 100%;
  background: var(--accent, #2563eb);
  border-radius: 3px;
  transition: width .4s ease;
  min-width: 4px;
}
.dng-overlap-pair-count {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--text-primary, #18181b);
  min-width: 24px;
  text-align: right;
  flex-shrink: 0;
}

/* Redundancy insight banner */
.dng-overlap-insight {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 16px;
  background: rgba(245,158,11,.08);
  border-top: 1px solid rgba(245,158,11,.2);
  font-size: 0.8rem;
  color: var(--text-secondary, #71717a);
  line-height: 1.5;
}
.dng-overlap-insight strong {
  color: var(--text-primary, #18181b);
}
.dng-overlap-insight-icon {
  color: #f59e0b;
  margin-top: 1px;
  flex-shrink: 0;
}

/* ── Latent Connections Section (in NodeDetail sidebar) ──────────────────── */
.dng-latent-section {
  border-top: 1px solid var(--border-color, #e4e4e7);
  margin-top: auto;
}
.dng-latent-toggle {
  display: flex;
  align-items: center;
  gap: 7px;
  width: 100%;
  padding: 10px 16px;
  background: var(--bg-tertiary, #fafafa);
  border: none;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-secondary, #71717a);
  text-align: left;
  transition: background .15s, color .15s;
}
.dng-latent-toggle:hover {
  background: var(--bg-secondary, #fff);
  color: var(--text-primary, #18181b);
}
.dng-latent-chevron {
  font-size: 0.65rem;
  flex-shrink: 0;
  transition: transform .2s;
}
.dng-latent-icon {
  color: var(--accent, #2563eb);
  flex-shrink: 0;
}
.dng-latent-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 99px;
  font-size: 0.65rem;
  font-weight: 700;
  background: var(--bg-secondary, #e4e4e7);
  color: var(--text-secondary, #71717a);
  border: 1px solid var(--border-color, #e4e4e7);
  margin-left: auto;
  line-height: 1;
}
.dng-latent-body {
  background: var(--bg-secondary, #fff);
  border-top: 1px solid var(--border-color, #e4e4e7);
  display: flex;
  flex-direction: column;
  gap: 0;
}
.dng-latent-empty {
  padding: 12px 16px;
  font-size: 0.82rem;
  color: var(--text-secondary, #71717a);
  font-style: italic;
}
.dng-latent-hint {
  padding: 8px 16px;
  font-size: 0.75rem;
  color: var(--text-secondary, #71717a);
  margin: 0;
  border-bottom: 1px solid var(--border-color, #f4f4f5);
  background: rgba(37,99,235,.04);
  line-height: 1.4;
}
.dng-latent-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 9px 16px;
  border-bottom: 1px solid var(--border-color, #f4f4f5);
  transition: background .15s;
}
.dng-latent-item:last-child {
  border-bottom: none;
}
.dng-latent-item:hover {
  background: var(--bg-tertiary, #fafafa);
}
.dng-latent-item-left {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}
.dng-latent-item-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 4px;
}
.dng-latent-item-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.dng-latent-item-name {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-primary, #18181b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.dng-latent-item-provider {
  font-size: 0.68rem;
  color: var(--text-secondary, #71717a);
  display: block;
}
.dng-latent-item-right {
  flex-shrink: 0;
  text-align: right;
}
.dng-latent-item-via {
  font-size: 0.72rem;
  color: var(--text-secondary, #71717a);
  line-height: 1.4;
}
.dng-latent-item-via strong {
  color: var(--accent, #2563eb);
  font-weight: 600;
}
.dng-latent-more {
  color: var(--text-secondary, #71717a);
  font-size: 0.68rem;
}

/* ── Dark mode overrides for new elements ────────────────────────────────── */
[data-theme="dark"] .dng-toggle-btn {
  background: var(--bg-secondary);
  border-color: var(--border-color);
}
[data-theme="dark"] .dng-toggle-btn:hover {
  background: rgba(37,99,235,.1);
}
[data-theme="dark"] .dng-toggle-btn.active {
  background: var(--accent);
}
[data-theme="dark"] .dng-provider-legend {
  background: var(--bg-primary);
}
[data-theme="dark"] .dng-provider-legend-chip {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}
[data-theme="dark"] .dng-overlap-wrap {
  background: var(--bg-secondary);
}
[data-theme="dark"] .dng-overlap-header {
  background: var(--bg-tertiary);
}
[data-theme="dark"] .dng-overlap-provider-chip {
  border-right-color: var(--border-color);
}
[data-theme="dark"] .dng-overlap-bar-track {
  background: var(--bg-tertiary);
}
[data-theme="dark"] .dng-overlap-insight {
  background: rgba(245,158,11,.1);
  border-top-color: rgba(245,158,11,.25);
}
[data-theme="dark"] .dng-overlap-insight strong {
  color: #fbbf24;
}
[data-theme="dark"] .dng-overlap-total-badge {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}
[data-theme="dark"] .dng-latent-toggle {
  background: var(--bg-primary);
  color: var(--text-secondary);
}
[data-theme="dark"] .dng-latent-toggle:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}
[data-theme="dark"] .dng-latent-body {
  background: var(--bg-secondary);
}
[data-theme="dark"] .dng-latent-hint {
  background: rgba(37,99,235,.08);
  border-bottom-color: var(--border-color);
}
[data-theme="dark"] .dng-latent-item:hover {
  background: var(--bg-tertiary);
}
[data-theme="dark"] .dng-latent-item {
  border-bottom-color: var(--border-color);
}
[data-theme="dark"] .dng-latent-count-badge {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}
[data-theme="dark"] .dng-latent-item-via strong {
  color: #60a5fa;
}

/* =============================================================================
   10. KnowledgeTimelineChart (.ktc-*)
   ============================================================================= */
.ktc-container {
  display: flex; flex-direction: column; height: 100%;
  background: var(--bg-secondary); border: 1px solid var(--border-color); border-radius: 12px; overflow: hidden;
}
.ktc-toolbar {
  padding: 12px 16px; border-bottom: 1px solid var(--border-color);
  display: flex; justify-content: space-between; align-items: center;
}
.ktc-actions { display: flex; gap: 4px; background: var(--bg-tertiary); padding: 2px; border-radius: 6px; }
.ktc-view-btn {
  border: none; background: none; padding: 6px 10px; border-radius: 4px; color: var(--text-secondary); cursor: pointer;
}
.ktc-view-btn.active { background: #fff; color: var(--text-primary); shadow: 0 1px 2px rgba(0,0,0,.1); }

.ktc-summary {
  display: flex; gap: 24px; padding: 16px 24px; background: #fafafa; border-bottom: 1px solid var(--border-color); flex-wrap: wrap;
}
.ktc-stat { display: flex; flex-direction: column; }
.ktc-stat-value { font-size: 1.5rem; font-weight: 700; color: var(--text-primary); line-height: 1; }
.ktc-stat-label { font-size: 0.75rem; color: var(--text-secondary); text-transform: uppercase; margin-top: 4px; }
.ktc-major-notice {
  margin-left: auto; background: #fffbeb; color: #92400e; padding: 8px 12px; border-radius: 6px;
  border: 1px solid #fcd34d; font-size: 0.85rem; display: flex; align-items: center; gap: 8px;
}

.ktc-chart-wrap { flex: 1 1; padding: 16px; position: relative; min-height: 300px; }

/* Timeline Table */
.ktc-table-wrap { flex: 1 1; overflow: auto; }
.ktc-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
.ktc-table th {
  text-align: left; padding: 10px 16px; background: #f4f4f5; color: var(--text-secondary);
  font-weight: 600; border-bottom: 1px solid var(--border-color); position: sticky; top: 0;
}
.ktc-sortable { cursor: pointer; }
.ktc-sortable:hover { background: #e4e4e7; }
.ktc-sort-icon { margin-left: 6px; font-size: 0.75rem; }
.ktc-table-row { border-bottom: 1px solid #f4f4f5; cursor: pointer; }
.ktc-table-row:hover { background: #f8fafc; }
.ktc-table td { padding: 10px 16px; color: var(--text-primary); }
.ktc-file-name { font-weight: 500; }
.ktc-dominant-chip { font-size: 0.75rem; color: #fff; padding: 2px 8px; border-radius: 99px; white-space: nowrap; }

/* =============================================================================
   11. DocumentBridgePanel (.dbp-*)
   ============================================================================= */
.dbp-container {
  display: flex; flex-direction: column; height: 100%;
  background: var(--bg-secondary); border: 1px solid var(--border-color); border-radius: 12px; overflow: hidden;
}
.dbp-header { padding: 16px 20px; border-bottom: 1px solid var(--border-color); }
.dbp-subtitle { margin: 4px 0 0 0; color: var(--text-secondary); font-size: 0.9rem; }

.dbp-selectors {
  padding: 20px; background: #fafafa; border-bottom: 1px solid var(--border-color);
  display: flex; align-items: flex-end; gap: 16px; flex-wrap: wrap;
}
.dbp-selector-wrap { flex: 1 1; display: flex; flex-direction: column; gap: 6px; min-width: 200px; }
.dbp-selector-label { font-size: 0.85rem; font-weight: 600; color: var(--text-secondary); }
.dbp-selector { padding: 10px; border: 1px solid var(--border-color); border-radius: 6px; font-size: 0.9rem; background: #fff; }
.dbp-vs-divider { display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 50%; background: #e4e4e7; color: #71717a; font-size: 1.2rem; flex-shrink: 0; margin-bottom: 2px; }
.dbp-find-btn { margin-bottom: 2px; padding: 10px 20px; min-width: 140px; }

.dbp-stats-row {
  display: flex; justify-content: space-around; align-items: center; padding: 20px;
  background: #fff; border-bottom: 1px solid #f4f4f5;
}
.dbp-stat { display: flex; flex-direction: column; align-items: center; }
.dbp-stat-value { font-size: 1.8rem; font-weight: 700; color: var(--text-primary); }
.dbp-stat-label { font-size: 0.8rem; color: var(--text-secondary); text-transform: uppercase; }
.dbp-doc-names { font-size: 0.9rem; color: var(--text-secondary); display: flex; align-items: center; gap: 10px; }
.dbp-merge-icon { color: var(--accent); }

.dbp-graph-wrap { flex: 1 1; position: relative; border-bottom: 1px solid var(--border-color); display: flex; flex-direction: column; }
.dbp-graph-title { position: absolute; top: 12px; left: 16px; margin: 0; font-size: 0.85rem; color: var(--text-secondary); z-index: 5; background: rgba(255,255,255,0.8); padding: 4px 8px; border-radius: 4px; }
.dbp-graph-canvas { flex: 1 1; min-height: 300px; background: #fff; }

.dbp-entity-list { height: 200px; overflow-y: auto; padding: 16px; background: #fafafa; }
.dbp-entity-list h4 { margin: 0 0 12px 0; font-size: 0.9rem; color: var(--text-secondary); }
.dbp-entity-row {
  display: flex; align-items: center; gap: 10px; padding: 8px 12px; background: #fff;
  border: 1px solid var(--border-color); border-radius: 6px; margin-bottom: 8px;
}
.dbp-entity-chip { font-size: 0.65rem; color: #fff; padding: 2px 6px; border-radius: 4px; font-weight: 700; width: 70px; text-align: center; }
.dbp-entity-name { border: none; background: none; font-weight: 600; color: var(--text-primary); cursor: pointer; text-align: left; }
.dbp-entity-name:hover { color: var(--accent); text-decoration: underline; }
.dbp-entity-desc { font-size: 0.8rem; color: var(--text-secondary); margin-left: auto; font-style: italic; }

.dbp-no-common { padding: 48px; text-align: center; color: var(--text-secondary); }
.dbp-empty-icon { font-size: 3rem; margin-bottom: 16px; opacity: .4; }
.dbp-hint { font-size: 0.9rem; background: #fff7ed; color: #c2410c; padding: 8px 16px; border-radius: 6px; display: inline-block; margin-top: 16px; }
.dbp-edge-tooltip {
  position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%);
  background: var(--bg-secondary); padding: 8px 12px; border: 1px solid var(--border-color); border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,.1); font-size: 0.8rem; max-width: 300px; z-index: 10;
  color: var(--text-primary);
}

/* ── Document Card Compare View ─────────────────────────────────────────── */
.dbp-card-compare {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: stretch;
  gap: 0;
  padding: 20px;
  background: var(--bg-tertiary, #fafafa);
  border-bottom: 1px solid var(--border-color);
}
@media (max-width: 760px) {
  .dbp-card-compare {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
  }
  .dbp-card-compare-divider {
    flex-direction: row !important;
    padding: 8px 0 !important;
  }
  .dbp-card-compare-line { flex: 1 1; height: 1px !important; width: auto !important; }
}

/* Individual document info card */
.dbp-doc-card {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 10px;
  border-top: 3px solid transparent;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  box-shadow: 0 2px 8px rgba(0,0,0,.06);
}
.dbp-doc-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dbp-doc-card-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .6px;
}
.dbp-doc-card-icon { font-size: 1.1rem; opacity: .6; }
.dbp-doc-card-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  word-break: break-word;
  line-height: 1.35;
}
.dbp-doc-card-desc {
  font-size: 0.82rem;
  color: var(--text-secondary);
  line-height: 1.55;
  margin: 0;
  font-style: italic;
}
.dbp-doc-card-meta {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: auto;
}
.dbp-doc-card-meta-row {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.8rem;
  color: var(--text-secondary);
}
.dbp-doc-card-meta-icon {
  font-size: 0.7rem;
  width: 14px;
  text-align: center;
  flex-shrink: 0;
  opacity: .65;
}
.dbp-doc-card-status {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: 99px;
  text-transform: capitalize;
}
.dbp-doc-card-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.78rem;
  color: var(--accent, #2563eb);
  text-decoration: none;
  padding: 5px 0;
  font-weight: 500;
  transition: opacity .2s;
  border-top: 1px solid var(--border-color);
  padding-top: 10px;
  margin-top: 4px;
}
.dbp-doc-card-link:hover { opacity: .7; }

/* Divider between the two cards */
.dbp-card-compare-divider {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
}
.dbp-card-compare-line {
  width: 1px;
  flex: 1 1;
  background: var(--border-color, #e4e4e7);
  min-height: 30px;
}
.dbp-card-compare-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  background: var(--bg-secondary, #fff);
  border: 2px solid var(--accent, #2563eb);
  border-radius: 50%;
  width: 56px;
  height: 56px;
  justify-content: center;
  color: var(--accent, #2563eb);
  box-shadow: 0 2px 8px rgba(37,99,235,.15);
  flex-shrink: 0;
}
.dbp-card-compare-badge i { font-size: 0.8rem; }
.dbp-card-compare-badge span { font-size: 1.1rem; font-weight: 700; line-height: 1; }
.dbp-card-compare-badge small { font-size: 0.6rem; text-transform: uppercase; letter-spacing: .4px; font-weight: 600; }

/* =============================================================================
   12. EntityContextWindow  (.ecw-*)
   ============================================================================= */

/* Overlay backdrop */
.ecw-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(2px);
}

/* Modal panel */
.ecw-modal {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 14px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 760px;
  height: 90vh;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header */
.ecw-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  flex-shrink: 0;
}
.ecw-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}
.ecw-type-chip {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 5px;
  font-size: 0.7rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: .4px;
}
.ecw-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary, #18181b);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ecw-close-btn {
  background: none;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  color: var(--text-secondary, #71717a);
  font-size: 0.9rem;
  flex-shrink: 0;
  transition: all .2s;
}
.ecw-close-btn:hover { background: var(--danger, #ef4444); color: #fff; border-color: var(--danger, #ef4444); }

/* Loading / Error */
.ecw-loading, .ecw-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 60px 40px;
  color: var(--text-secondary, #71717a);
  flex: 1 1;
}
.ecw-spinner {
  width: 36px; height: 36px;
  border: 3px solid var(--border-color, #e4e4e7);
  border-top-color: var(--accent, #2563eb);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.ecw-error { color: #dc2626; }
.ecw-error i { font-size: 2rem; opacity: .7; }

/* Stats banner */
.ecw-stats-bar {
  display: flex;
  gap: 0;
  background: var(--bg-tertiary, #fafafa);
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  flex-shrink: 0;
  overflow-x: auto;
}
.ecw-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 20px;
  border-right: 1px solid var(--border-color, #e4e4e7);
  min-width: 80px;
  flex-shrink: 0;
}
.ecw-stat:last-child { border-right: none; }
.ecw-stat-value {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--text-primary, #18181b);
  line-height: 1;
}
.ecw-stat-date { font-size: 0.85rem; }
.ecw-stat-label {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: .4px;
  color: var(--text-secondary, #71717a);
  margin-top: 4px;
  white-space: nowrap;
}

/* Tabs */
.ecw-tabs {
  display: flex;
  border-bottom: 2px solid var(--border-color, #e4e4e7);
  background: var(--bg-secondary, #fff);
  flex-shrink: 0;
  overflow-x: auto;
}
.ecw-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border: none;
  background: transparent;
  color: var(--text-secondary, #71717a);
  cursor: pointer;
  border-bottom: 3px solid transparent;
  font-size: 0.85rem;
  font-weight: 500;
  white-space: nowrap;
  transition: color .2s, border-color .2s;
  margin-bottom: -2px;
}
.ecw-tab:hover  { color: var(--text-primary, #18181b); }
.ecw-tab.active { color: var(--accent, #2563eb); border-bottom-color: var(--accent, #2563eb); font-weight: 600; }
.ecw-tab-count {
  background: var(--bg-tertiary, #f4f4f5);
  padding: 1px 6px;
  border-radius: 99px;
  font-size: 0.7rem;
  min-width: 16px;
  text-align: center;
}

/* Body / scroll area */
.ecw-body {
  flex: 1 1;
  overflow-y: auto;
  background: var(--bg-primary, #f4f4f5);
}

/* Shared section wrapper */
.ecw-section { padding: 16px; display: flex; flex-direction: column; gap: 12px; }
.ecw-empty {
  text-align: center;
  padding: 32px;
  color: var(--text-secondary, #71717a);
  font-style: italic;
  font-size: 0.9rem;
}

/* Shared chip */
.ecw-chip {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 4px;
  font-size: 0.65rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
  text-transform: uppercase;
}

/* ── Back button & breadcrumb ── */
.ecw-back-btn {
  background: none;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  padding: 5px 10px;
  cursor: pointer;
  color: var(--text-secondary, #71717a);
  font-size: 0.85rem;
  flex-shrink: 0;
  transition: all .2s;
}
.ecw-back-btn:hover { background: var(--bg-tertiary, #f4f4f5); color: var(--text-primary, #18181b); }

.ecw-breadcrumb-depth {
  font-size: 0.72rem;
  color: var(--text-secondary, #71717a);
  background: var(--bg-tertiary, #f4f4f5);
  padding: 3px 8px;
  border-radius: 99px;
  border: 1px solid var(--border-color, #e4e4e7);
  white-space: nowrap;
  flex-shrink: 0;
  cursor: help;
}

/* ── Stats actions area (pin button) ── */
.ecw-stats-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  padding: 0 14px;
  border-left: 1px solid var(--border-color, #e4e4e7);
  flex-shrink: 0;
}
.ecw-pin-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 13px;
  background: none;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  cursor: pointer;
  color: var(--text-secondary, #71717a);
  font-size: 0.8rem;
  font-weight: 500;
  transition: all .2s;
  white-space: nowrap;
}
.ecw-pin-btn:hover {
  background: var(--accent, #2563eb);
  color: #fff;
  border-color: var(--accent, #2563eb);
}
.ecw-pin-btn i { font-size: 0.75rem; }

/* ── Clickable entity pill (Connections tab) ── */
.ecw-entity-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 3px 8px 3px 2px;
  cursor: pointer;
  text-align: left;
  flex: 1 1;
  min-width: 0;
  transition: background .15s, border-color .15s;
}
.ecw-entity-pill:hover {
  background: var(--bg-tertiary, #f4f4f5);
  border-color: var(--border-color, #e4e4e7);
}
.ecw-entity-pill-name {
  flex: 1 1;
  font-size: 0.85rem;
  color: var(--text-primary, #18181b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ecw-entity-pill-arrow {
  font-size: 0.65rem;
  color: var(--text-secondary, #71717a);
  opacity: 0;
  transition: opacity .15s;
  flex-shrink: 0;
}
.ecw-entity-pill:hover .ecw-entity-pill-arrow { opacity: 1; }

/* ── Connections tab ── */
.ecw-conn-group { display: flex; flex-direction: column; gap: 6px; }
.ecw-section-title {
  margin: 0 0 6px 0;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: var(--text-secondary, #71717a);
  display: flex;
  align-items: center;
  gap: 6px;
}
.ecw-rel-group {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  overflow: hidden;
}
.ecw-rel-group-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background .15s;
}
.ecw-rel-group-toggle:hover { background: var(--bg-tertiary, #f4f4f5); }
.ecw-rel-direction-arrow {
  font-size: 0.9rem;
  color: var(--text-secondary, #71717a);
  flex-shrink: 0;
}
.ecw-rel-type-label {
  flex: 1 1;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary, #18181b);
  text-transform: uppercase;
  letter-spacing: .3px;
}
.ecw-rel-count-badge {
  background: var(--bg-tertiary, #e4e4e7);
  color: var(--text-secondary, #71717a);
  font-size: 0.7rem;
  font-weight: 700;
  padding: 1px 7px;
  border-radius: 99px;
  flex-shrink: 0;
}
.ecw-rel-chevron { font-size: 0.7rem; color: var(--text-secondary, #71717a); flex-shrink: 0; }

.ecw-rel-entity-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid var(--border-color, #e4e4e7);
  max-height: 220px;
  overflow-y: auto;
}
.ecw-rel-entity-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border-bottom: 1px solid var(--border-color, #f4f4f5);
}
.ecw-rel-entity-row:last-child { border-bottom: none; }
.ecw-rel-entity-name {
  flex: 1 1;
  font-size: 0.85rem;
  color: var(--text-primary, #18181b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ecw-rel-context {
  color: var(--text-secondary, #71717a);
  font-size: 0.75rem;
  cursor: help;
  flex-shrink: 0;
}

/* ── Evidence tab ── */
.ecw-evidence-row {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  padding: 10px 14px;
}
.ecw-evidence-icon { color: #ef4444; font-size: 1rem; flex-shrink: 0; }
.ecw-evidence-body { flex: 1 1; display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.ecw-evidence-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary, #18181b);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ecw-evidence-link {
  color: var(--accent, #2563eb);
  text-decoration: none;
}
.ecw-evidence-link:hover { text-decoration: underline; }
.ecw-evidence-type {
  font-size: 0.72rem;
  color: var(--text-secondary, #71717a);
  text-transform: uppercase;
  letter-spacing: .4px;
}
.ecw-evidence-connections {
  font-size: 0.78rem;
  color: var(--text-secondary, #71717a);
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  white-space: nowrap;
}
.ecw-evidence-row--clickable {
  cursor: pointer;
  transition: background .15s, border-color .15s, box-shadow .15s;
}
.ecw-evidence-row--clickable:hover {
  background: var(--bg-tertiary, #f8fafc);
  border-color: var(--accent, #2563eb);
  box-shadow: 0 2px 8px rgba(37,99,235,.1);
}
.ecw-evidence-row--clickable:hover .ecw-evidence-name {
  color: var(--accent, #2563eb);
}
.ecw-evidence-open-icon {
  font-size: 0.7rem;
  color: var(--text-secondary, #71717a);
  flex-shrink: 0;
  opacity: 0;
  transition: opacity .15s;
}
.ecw-evidence-row--clickable:hover .ecw-evidence-open-icon { opacity: 1; }

/* ── Similar tab ── */
.ecw-similar-row {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  padding: 9px 14px;
}
.ecw-similar-name {
  flex: 1 1;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-primary, #18181b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ecw-similar-score-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.ecw-similar-bar {
  width: 64px;
  height: 5px;
  background: var(--bg-tertiary, #e4e4e7);
  border-radius: 3px;
  overflow: hidden;
}
.ecw-similar-bar-fill {
  height: 100%;
  background: var(--accent, #2563eb);
  border-radius: 3px;
  transition: width .4s ease;
}
.ecw-similar-pct {
  font-size: 0.75rem;
  color: var(--text-secondary, #71717a);
  min-width: 30px;
  text-align: right;
}
.ecw-similar-shared {
  font-size: 0.75rem;
  color: var(--text-secondary, #71717a);
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.ecw-similar-row--clickable {
  cursor: pointer;
  transition: background .15s, border-color .15s;
}
.ecw-similar-row--clickable:hover {
  background: var(--bg-tertiary, #f8fafc);
  border-color: var(--accent, #2563eb);
}
.ecw-similar-row--clickable:hover .ecw-similar-name {
  color: var(--accent, #2563eb);
}
.ecw-similar-nav-icon {
  font-size: 0.65rem;
  color: var(--text-secondary, #71717a);
  flex-shrink: 0;
  opacity: 0;
  transition: opacity .15s;
}
.ecw-similar-row--clickable:hover .ecw-similar-nav-icon { opacity: 1; }

/* ── Properties tab ── */
.ecw-props-table {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  overflow: hidden;
}
.ecw-props-extra { margin-top: 10px; }
.ecw-prop-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 8px 14px;
  border-bottom: 1px solid var(--border-color, #f4f4f5);
  font-size: 0.85rem;
}
.ecw-prop-row:last-child { border-bottom: none; }
.ecw-prop-key {
  color: var(--text-secondary, #71717a);
  font-weight: 600;
  min-width: 100px;
  flex-shrink: 0;
}
.ecw-prop-val {
  color: var(--text-primary, #18181b);
  flex: 1 1;
  word-break: break-all;
}
.ecw-prop-mono {
  font-family: ui-monospace, 'Cascadia Code', monospace;
  font-size: 0.78rem;
  color: var(--text-secondary, #71717a);
}

/* ── Property value renderer helpers (.ecw-prop-*) ── */

/* Null / empty placeholder */
.ecw-prop-null {
  color: var(--text-secondary, #71717a);
  font-style: italic;
  opacity: 0.65;
}

/* Boolean badge */
.ecw-prop-bool {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 4px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
}
.ecw-prop-bool-yes { background: rgba(16,185,129,0.15); color: #15803d; }
.ecw-prop-bool-no  { background: rgba(148,163,184,0.2);  color: #64748b; }

/* Array of primitives — pill list */
.ecw-prop-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1 1;
}
.ecw-prop-tag {
  display: inline-block;
  padding: 2px 7px;
  background: var(--bg-tertiary, #f4f4f5);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 4px;
  font-size: 0.75rem;
  color: var(--text-primary, #18181b);
}

/* Flat object — nested key-value sub-table */
.ecw-prop-sub-table {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  background: var(--bg-tertiary, #f4f4f5);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 5px;
  padding: 6px 8px;
}
.ecw-prop-sub-row {
  display: flex;
  gap: 6px;
  font-size: 0.78rem;
}
.ecw-prop-sub-key {
  color: var(--text-secondary, #71717a);
  font-weight: 600;
  min-width: 80px;
  flex-shrink: 0;
}
.ecw-prop-sub-val {
  color: var(--text-primary, #18181b);
  word-break: break-word;
  flex: 1 1;
}

/* Complex / nested object — formatted JSON pre block */
.ecw-prop-json {
  flex: 1 1;
  margin: 0;
  padding: 8px 10px;
  background: var(--bg-tertiary, #f4f4f5);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 5px;
  font-family: ui-monospace, 'Cascadia Code', monospace;
  font-size: 0.72rem;
  color: var(--text-secondary, #71717a);
  white-space: pre-wrap;
  word-break: break-word;
  overflow-x: auto;
  line-height: 1.55;
  max-height: 200px;
  overflow-y: auto;
}

/* Also fix the prop-row alignment for complex values */
.ecw-prop-row {
  align-items: flex-start;
}
.ecw-prop-key {
  padding-top: 2px;
}

/* ── Deep Analysis tab (.ecw-da-*) ──────────────────────────────────────────── */

.ecw-da-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 48px 24px;
  text-align: center;
  color: var(--text-secondary, #71717a);
}
.ecw-da-empty i {
  font-size: 3rem;
  color: var(--accent, #2563eb);
  opacity: 0.4;
}
.ecw-da-empty h4 {
  margin: 0;
  font-size: 1rem;
  color: var(--text-primary, #18181b);
  font-weight: 700;
}
.ecw-da-empty p {
  margin: 0;
  font-size: 0.88rem;
  max-width: 300px;
  line-height: 1.6;
}
.ecw-da-generate-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 22px;
  background: var(--accent, #2563eb);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.12s;
}
.ecw-da-generate-btn:hover { opacity: 0.87; transform: translateY(-1px); }

.ecw-da-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ecw-da-overview {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  padding: 14px 16px;
}
.ecw-da-overview p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.65;
  color: var(--text-primary, #18181b);
  font-style: italic;
}

.ecw-da-section {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ecw-da-section-title {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary, #71717a);
  display: flex;
  align-items: center;
  gap: 6px;
}
.ecw-da-section-title i { color: var(--accent, #2563eb); }

.ecw-da-table {
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  overflow: hidden;
}
.ecw-da-row {
  display: flex;
  gap: 10px;
  padding: 7px 10px;
  border-bottom: 1px solid var(--border-color, #f4f4f5);
  font-size: 0.82rem;
  align-items: flex-start;
}
.ecw-da-row:last-child { border-bottom: none; }
.ecw-da-key {
  font-weight: 600;
  color: var(--text-secondary, #71717a);
  min-width: 110px;
  flex-shrink: 0;
  padding-top: 1px;
}
.ecw-da-val {
  color: var(--text-primary, #18181b);
  flex: 1 1;
  line-height: 1.5;
  word-break: break-word;
}

.ecw-da-text {
  margin: 0;
  font-size: 0.85rem;
  color: var(--text-primary, #18181b);
  line-height: 1.55;
}
.ecw-da-subdued { color: var(--text-secondary, #71717a); font-size: 0.8rem; }

.ecw-da-list-group { display: flex; flex-direction: column; gap: 6px; }
.ecw-da-list-label {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text-secondary, #71717a);
  display: flex;
  align-items: center;
  gap: 5px;
}
.ecw-da-label-signal     { color: #0891b2; }
.ecw-da-label-opportunity{ color: #7c3aed; }
.ecw-da-label-risk       { color: #b91c1c; }

.ecw-da-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.ecw-da-list-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.83rem;
  color: var(--text-primary, #18181b);
  line-height: 1.5;
  padding: 6px 10px;
  border-radius: 5px;
}
.ecw-da-list-item::before {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--border-color, #e4e4e7);
  flex-shrink: 0;
  margin-top: 5px;
}
.ecw-da-relationship        { background: rgba(99, 102, 241, 0.06); }
.ecw-da-relationship::before{ background: #6366f1; }
.ecw-da-signal              { background: rgba(8, 145, 178, 0.06); }
.ecw-da-signal::before      { background: #0891b2; }
.ecw-da-opportunity         { background: rgba(124, 58, 237, 0.06); }
.ecw-da-opportunity::before { background: #7c3aed; }
.ecw-da-risk                { background: rgba(185, 28, 28, 0.06); }
.ecw-da-risk::before        { background: #b91c1c; }
.ecw-da-flag                { background: rgba(239, 68, 68, 0.06); }
.ecw-da-flag::before        { background: #ef4444; }

.ecw-da-rec-list {
  list-style: none;
  padding: 0;
  margin: 0;
  counter-reset: rec-counter;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ecw-da-rec-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.85rem;
  color: var(--text-primary, #18181b);
  line-height: 1.55;
  padding: 8px 10px;
  background: rgba(37, 99, 235, 0.05);
  border: 1px solid rgba(37, 99, 235, 0.12);
  border-radius: 6px;
  counter-increment: rec-counter;
}
.ecw-da-rec-item::before {
  content: counter(rec-counter);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  min-width: 20px;
  background: var(--accent, #2563eb);
  color: #fff;
  border-radius: 50%;
  font-size: 0.68rem;
  font-weight: 700;
  flex-shrink: 0;
  line-height: 1;
}

.ecw-da-flags-section {
  border-color: rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.03);
}
.ecw-da-flags-title       { color: #b91c1c !important; }
.ecw-da-flags-title i     { color: #ef4444 !important; }

.ecw-da-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid var(--border-color, #e4e4e7);
  margin-top: 4px;
}
.ecw-da-footer-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ecw-da-regen-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: none;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  font-size: 0.8rem;
  color: var(--text-secondary, #71717a);
  cursor: pointer;
  transition: all 0.15s;
}
.ecw-da-regen-btn:hover:not(:disabled) {
  border-color: var(--accent, #2563eb);
  color: var(--accent, #2563eb);
}
.ecw-da-regen-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.ecw-da-tokens {
  font-size: 0.72rem;
  color: var(--text-secondary, #71717a);
  opacity: 0.65;
}

/* Dark overrides for ecw-da-* */
[data-theme="dark"] .ecw-da-overview   { background: var(--bg-secondary); border-color: var(--border-color); }
[data-theme="dark"] .ecw-da-section    { background: var(--bg-secondary); border-color: var(--border-color); }
[data-theme="dark"] .ecw-da-table      { border-color: var(--border-color); }
[data-theme="dark"] .ecw-da-row        { border-bottom-color: var(--border-color); }
[data-theme="dark"] .ecw-da-flags-section { background: rgba(239, 68, 68, 0.06); }
[data-theme="dark"] .ecw-da-rec-item   { background: rgba(37, 99, 235, 0.1); border-color: rgba(37, 99, 235, 0.2); }

/* =============================================================================
   13. Dark Theme Overrides — EntityContextWindow
   ============================================================================= */
[data-theme="dark"] .ecw-modal {
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);
}
[data-theme="dark"] .ecw-stats-bar  { background: var(--bg-tertiary); }
[data-theme="dark"] .ecw-tab.active { background: transparent; }
[data-theme="dark"] .ecw-body       { background: var(--bg-primary); }
[data-theme="dark"] .ecw-rel-group,
[data-theme="dark"] .ecw-evidence-row,
[data-theme="dark"] .ecw-similar-row,
[data-theme="dark"] .ecw-props-table { background: var(--bg-secondary); border-color: var(--border-color); }
[data-theme="dark"] .ecw-rel-group-toggle:hover { background: var(--bg-tertiary); }
[data-theme="dark"] .ecw-rel-entity-row { border-bottom-color: var(--border-color); }
[data-theme="dark"] .ecw-similar-bar  { background: var(--bg-tertiary); }
[data-theme="dark"] .ecw-prop-row     { border-bottom-color: var(--border-color); }
[data-theme="dark"] .ecw-rel-count-badge { background: var(--bg-tertiary); }

/* =============================================================================
   12. Dark Theme Overrides
   Patches for components that still use hardcoded colours in light-mode styles
   ============================================================================= */
[data-theme="dark"] {

  /* ── Shared ──────────────────────────────────────────────────────────────── */
  mark { background: rgba(250,204,21,.25); }

  /* ── Rating badges ──────────────────────────────────────────────────────── */
  .rating-high { background: rgba(16,185,129,.2); color: #34d399; }
  .rating-med  { background: rgba(245,158,11,.2);  color: #fbbf24; }
  .rating-low  { background: rgba(156,163,175,.2); color: #9ca3af; }

  /* ── KGP page ────────────────────────────────────────────────────────────── */
  .kgp-search-row,
  .kgp-subtabs { background: var(--bg-secondary); }

  /* ── Community cards ─────────────────────────────────────────────────────── */
  .community-card:hover { box-shadow: 0 6px 20px rgba(0,0,0,.4); }
  .community-error-state { background: rgba(239,68,68,.1); }

  /* ── CommunityDetailPanel ───────────────────────────────────────────────── */
  .cdp-back-btn:hover,
  .cdp-node-item:hover,
  .cdp-node-item.highlighted { background: var(--bg-tertiary); }
  .cdp-edge-tooltip { box-shadow: 0 4px 16px rgba(0,0,0,.5); }

  /* ── EntityTreeViewer ───────────────────────────────────────────────────── */
  .etv-controls { background: var(--bg-tertiary); }
  .etv-seg-btn.active { background: var(--bg-secondary); }

  /* ── Search results ─────────────────────────────────────────────────────── */
  .sr-panel { box-shadow: 0 10px 30px rgba(0,0,0,.5); }
  .sr-evidence-quote { background: var(--bg-tertiary); border-left-color: var(--border-color); }
  .sr-entity-tag { background: rgba(59,130,246,.15); }

  /* ── LatentConnectionPanel ───────────────────────────────────────────────── */
  .lcp-seed-info { background: rgba(37,99,235,.15); border-bottom-color: rgba(37,99,235,.3); color: #93c5fd; }
  .lcp-tabs { background: var(--bg-secondary); }
  .lcp-tab.active { background: var(--bg-tertiary); }
  .lcp-tab-count { background: var(--bg-tertiary); color: var(--text-secondary); }
  .lcp-tab-content { background: var(--bg-primary); }
  .lcp-conn-row { background: var(--bg-secondary); }
  .lcp-conn-row:hover { background: var(--bg-tertiary); }
  .lcp-bridge-row { background: var(--bg-secondary); }
  .lcp-comm-pill { background: var(--bg-tertiary); border-color: var(--border-color); }
  .lcp-conf-bar { background: var(--bg-tertiary); }
  .conf-strong { background: rgba(16,185,129,.2); color: #34d399; }
  .conf-mod    { background: rgba(245,158,11,.2);  color: #fbbf24; }
  .conf-weak   { background: var(--bg-tertiary);   color: var(--text-secondary); }
  .lcp-reason-attr { background: rgba(194,65,12,.15); color: #fb923c; border-color: rgba(194,65,12,.3); }
  .lcp-reason-cooc { background: rgba(29,78,216,.15);  color: #60a5fa; border-color: rgba(29,78,216,.3); }
  .lcp-suggestions { background: var(--bg-secondary); }

  /* ── DocumentDNAList ─────────────────────────────────────────────────────── */
  .dna-row:hover { box-shadow: 0 4px 16px rgba(0,0,0,.35); }
  .dna-row-failed { border-left-color: #f87171; }
  .dna-status-badge.dna-status-ok      { background: rgba(16,185,129,.2); color: #34d399; }
  .dna-status-badge.dna-status-pending { background: rgba(245,158,11,.2);  color: #fbbf24; }
  .dna-status-badge.dna-status-fail    { background: rgba(239,68,68,.2);   color: #f87171; }
  .dna-failed-notice { background: rgba(239,68,68,.15); color: #f87171; border-color: rgba(239,68,68,.3); }
  /* status icon colours in dark mode */
  .dna-status-ok   { color: #34d399; }
  .dna-status-pending { color: #fbbf24; }
  .dna-status-fail { color: #f87171; }

  /* ── DocumentNetworkGraph ───────────────────────────────────────────────── */
  .dng-graph-area { background: var(--bg-primary); }
  .dng-sidebar-wrap { background: var(--bg-secondary); }
  .dng-conn-row { border-bottom-color: var(--border-color); }
  .dng-edge-docs { background: var(--bg-primary); }
  .dng-entity-tag { background: var(--bg-secondary); }
  .dng-entity-tag:hover { background: rgba(59,130,246,.1); }
  .dng-shared-count { background: rgba(99,102,241,.2); color: #818cf8; }

  /* ── KnowledgeTimelineChart ─────────────────────────────────────────────── */
  .ktc-view-btn.active { background: var(--bg-tertiary); }
  .ktc-summary { background: var(--bg-secondary); }
  .ktc-major-notice { background: rgba(245,158,11,.15); color: #fbbf24; border-color: rgba(245,158,11,.3); }
  .ktc-table th { background: var(--bg-tertiary); }
  .ktc-sortable:hover { background: var(--bg-secondary); }
  .ktc-table-row { border-bottom-color: var(--border-color); }
  .ktc-table-row:hover { background: var(--bg-tertiary); }

  /* ── DocumentNetworkGraph: enhanced sidebar dark overrides ──────────────── */
  .dng-doc-meta { border-bottom-color: var(--border-color); }
  .dng-doc-description { border-bottom-color: var(--border-color); }
  .dng-sidebar-actions { border-top-color: var(--border-color); }
  .dng-open-doc-btn { background: var(--bg-secondary); border-color: var(--border-color); }
  .dng-open-doc-btn:hover { background: var(--accent); }
  .dng-status-processed, .dng-status-completed, .dng-status-indexed { background: rgba(16,185,129,.18); color: #34d399; }
  .dng-status-pending, .dng-status-queued, .dng-status-processing { background: rgba(245,158,11,.18); color: #fbbf24; }
  .dng-status-failed, .dng-status-error { background: rgba(239,68,68,.18); color: #f87171; }
  .dng-conn-list .dng-conn-row { border-bottom-color: var(--border-color); }

  /* ── DocumentDNAList: description dark overrides ────────────────────────── */
  .dna-detail-description { background: var(--bg-secondary); border-color: var(--border-color); }

  /* ── DocumentBridgePanel ────────────────────────────────────────────────── */
  .dbp-selectors { background: var(--bg-tertiary); }
  .dbp-selector { background: var(--bg-secondary); color: var(--text-primary); }
  .dbp-vs-divider { background: var(--bg-tertiary); color: var(--text-secondary); }
  .dbp-stats-row { background: var(--bg-secondary); border-bottom-color: var(--border-color); }
  .dbp-entity-row { background: var(--bg-secondary); }
  .dbp-entity-list { background: var(--bg-primary); }
  .dbp-entity-name:hover { color: var(--accent); }
  .dbp-hint { background: rgba(194,65,12,.15); color: #fb923c; }
  .dbp-graph-title { background: rgba(24,24,27,.8); color: var(--text-secondary); }
  .dbp-graph-canvas { background: var(--bg-secondary); }
  .dbp-edge-tooltip { box-shadow: 0 4px 12px rgba(0,0,0,.5); }

  /* ── DocumentBridgePanel: card compare dark overrides ───────────────────── */
  .dbp-card-compare { background: var(--bg-primary); }
  .dbp-doc-card { background: var(--bg-secondary); border-color: var(--border-color); box-shadow: 0 2px 8px rgba(0,0,0,.3); }
  .dbp-doc-card-link { border-top-color: var(--border-color); }
  .dbp-card-compare-line { background: var(--border-color); }
  .dbp-card-compare-badge { background: var(--bg-secondary); box-shadow: 0 2px 8px rgba(37,99,235,.2); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/KnowledgeGraphNew.css"],"names":[],"mappings":"AAAA;;;;kFAIkF;;AAElF,iFAAiF;AACjF;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,6BAA6B,EAAE;AACxC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB;;;2BAGyB;EACzB,2BAA2B;EAC3B,uCAAuC;EACvC,kBAAkB;AACpB;AACA,kBAAkB,YAAY,EAAE,UAAU,EAAE;AAC5C,kBAAkB,WAAW,GAAG,WAAW,EAAE;AAC7C,kBAAkB,YAAY,EAAE,UAAU,EAAE;;AAE5C,kFAAkF;AAClF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA,eAAe,gCAAgC,EAAE,cAAc,EAAE;AACjE,eAAe,iCAAiC,EAAE,cAAc,EAAE;AAClE,eAAe,iCAAiC,EAAE,cAAc,EAAE;;AAElE;;kFAEkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;EACZ,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,qCAAqC;EACrC,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;AACrB;AACA,qBAAqB,mCAAmC,EAAE;AAC1D,qBAAqB,6BAA6B,EAAE,2CAA2C,EAAE,gBAAgB,EAAE;AACnH;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sCAAsC;AACxC;;AAEA;;kFAEkF;AAClF,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEzE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,4BAA4B;EAC5B,8CAA8C;EAC9C,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,iBAAiB;EACjB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;AACnB;;AAEA,yBAAyB,aAAa,EAAE,QAAQ,EAAE;AAClD;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,kCAAkC;EAClC,WAAW;EACX,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,SAAS;EACT,gBAAgB;EAChB,SAAO;AACT;AACA;EACE,WAAW;EACX,uCAAuC;EACvC,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB;AAClB,2BAA2B,eAAe,EAAE;AAC5C,iCAAiC,gBAAgB,EAAE,eAAe,EAAE;;AAEpE,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA,4BAA4B,iBAAiB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AAC/F,4BAA4B,iBAAiB,EAAE,mBAAmB,EAAE;AACpE;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;kFAEkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,SAAO;EACP,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,qDAAqD;EACrD,cAAc;EACd,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,8CAA8C;EAC9C,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,8CAA8C;EAC9C,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;AACb;AACA,mBAAmB,kBAAkB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,aAAa,EAAE;;AAExG,uDAAuD;AACvD;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,SAAS;AACX;AACA,sBAAsB,iBAAiB,EAAE,WAAW,EAAE;;AAEtD,mDAAmD;AACnD;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;AACA,2BAA2B,0BAA0B,EAAE;;AAEvD,+DAA+D;AAC/D;;;EAGE,uEAAuE;EACvE,WAAW;EACX,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,MAAM,EAAE,QAAQ;EAChB,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,mDAAmD;EACnD,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA,+BAA+B,SAAS,EAAE,SAAO,EAAE,eAAe,EAAE,0BAA0B,EAAE;AAChG;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;AACA,uBAAuB,kCAAkC,EAAE,WAAW,EAAE,oCAAoC,EAAE;AAC9G,0BAA0B,kBAAkB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;AAC/F,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrE;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,qDAAqD;AACvD;AACA,gBAAgB,4BAA4B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACjF,gBAAgB,0BAA0B,EAAE,SAAO,EAAE,qBAAqB,EAAE;;AAE5E,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,WAAW,EAAE,YAAY;EACzB,8CAA8C;EAC9C,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;AACpC;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;AACpD,aAAa,cAAc,EAAE;;AAE7B;;kFAEkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA,uBAAuB,uCAAuC,EAAE,0BAA0B,EAAE;;AAE5F;EACE,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,SAAS;EACT,uCAAuC;EACvC,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;AAClB;AACA,oBAAoB,YAAY,EAAE;;AAElC,eAAe,SAAO,EAAE,gBAAgB,EAAE,aAAa,EAAE,kBAAkB,EAAE;AAC7E,iCAAiC,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAElF,iBAAiB,aAAa,EAAE,sBAAsB,EAAE;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA,sBAAsB,uCAAuC,EAAE;;AAE/D;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;AACA,2BAA2B,eAAe,EAAE,WAAW,EAAE;;AAEzD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;EACX,uBAAuB;AACzB;AACA,2BAA2B,UAAU,EAAE,6BAA6B,EAAE;AACtE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,uCAAuC;AACzC;AACA,uCAAuC,UAAU,EAAE;AACnD,yBAAyB,qCAAqC,EAAE,6BAA6B,EAAE;;AAE/F,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qDAAqD;AACvD;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,SAAS;EACT,aAAa;AACf;AACA;EACE,WAAW,EAAE,YAAY;EACzB,qCAAqC;EACrC,uCAAuC;EACvC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;kFAEkF;AAClF,iBAAiB,kBAAkB,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,4CAA4C;AAC9C;AACA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;AACA,YAAY,4BAA4B,EAAE,kBAAkB,EAAE;AAC9D;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;AACd;AACA,mBAAmB,aAAa,EAAE;AAClC;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,uCAAuC;AACzC;AACA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA,gBAAgB,2BAA2B,EAAE,0BAA0B,EAAE;AACzE,iBAAiB,6BAA6B,EAAE,2CAA2C,EAAE,qCAAqC,EAAE;AACpI;EACE,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,WAAW,EAAE,YAAY;EACzB,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,2BAA2B;AAC7B;AACA,wBAAwB,uCAAuC,EAAE;AACjE,6BAA6B,mBAAmB,EAAE;;AAElD,qBAAqB;AACrB,kCAAkC,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACpG,qBAAqB,iBAAiB,EAAE,4BAA4B,EAAE,SAAS,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,qBAAqB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;;AAEhM,kBAAkB;AAClB,aAAa,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC5D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;AACA,kBAAkB,SAAO,EAAE,YAAY,EAAE;AACzC,cAAc,4BAA4B,EAAE,WAAW,EAAE,iBAAiB,EAAE;;AAE5E,oBAAoB;AACpB,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mDAAmD;EACnD,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;AACA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACrI,kBAAkB,cAAc,EAAE,qBAAqB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACvG,wBAAwB,6BAA6B,EAAE;AACvD,oBAAoB,uCAAuC,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACnG,kBAAkB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,eAAe,EAAE;AAC7E,iBAAiB,iBAAiB,EAAE,8BAA8B,EAAE,6BAA6B,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAEzI,mBAAmB;AACnB,OAAO,mBAAmB,EAAE,cAAc,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAEhF;;kFAEkF;AAClF;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA,iBAAiB,mCAAmC,EAAE,gBAAgB,EAAE;AACxE;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,wBAAwB,6BAA6B,EAAE;;AAEvD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kDAAkD;EAClD,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,uBAAuB,6BAA6B,EAAE,0BAA0B,EAAE;AAClF;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA,sBAAsB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AAC1F;EACE,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;AACA,wBAAwB,oCAAoC,EAAE,6BAA6B,EAAE;;AAE7F;;kFAEkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qDAAqD;EACrD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,iBAAiB,SAAS,EAAE,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC7F,iBAAiB,gBAAgB,EAAE,YAAY,EAAE,iBAAiB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAEnH;EACE,aAAa;EACb,uCAAuC;EACvC,qDAAqD;EACrD,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;AACA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACpE,aAAa,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE;;AAE5G,kCAAkC;AAClC,yBAAyB,kBAAkB,EAAE;AAC7C;EACE,WAAW;EACX,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;AACnB;AACA,0BAA0B,aAAa,EAAE,oCAAoC,EAAE;AAC/E,qBAAqB,kBAAkB,EAAE,WAAW,EAAE,SAAS,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;AAClH;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO,EAAE,WAAW;EAC/B,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,6BAA6B,uCAAuC,EAAE;AACtE,gBAAgB,kBAAkB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAEzG,oBAAoB;AACpB,oBAAoB,WAAW,EAAE;AACjC;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB,eAAe,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACjF;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA,kBAAkB,6BAA6B,EAAE,2CAA2C,EAAE,mBAAmB,EAAE;AACnH,iBAAiB,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAEjH,mBAAmB,SAAO,EAAE,gBAAgB,EAAE,UAAU,EAAE,mBAAmB,EAAE;AAC/E,aAAa,aAAa,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;;AAElG,mBAAmB;AACnB;EACE,gBAAgB;EAChB,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,kBAAkB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC3L,iBAAiB,SAAO,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAExE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;;AAEpD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACnF,mBAAmB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAEnF;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,qBAAqB,YAAY,EAAE,kCAAkC,EAAE;AACvE;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;AACA,sBAAsB,oCAAoC,EAAE,6BAA6B,EAAE;;AAE3F,eAAe;AACf;EACE,gBAAgB;EAChB,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,oBAAoB,iBAAiB,EAAE,4BAA4B,EAAE;AACrE,uBAAuB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AACjE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;AACA,uBAAuB,oCAAoC,EAAE,6BAA6B,EAAE;;AAE5F;;kFAEkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA,yBAAyB,aAAa,EAAE,2BAA2B,EAAE;AACrE,mBAAmB,iBAAiB,EAAE;;AAEtC,8EAA8E;AAC9E;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;AACA,eAAe,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE,cAAc,EAAE;AAClF;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4FAA4F;AAC5F;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,oEAAoE;AACtE;AACA,iBAAiB,sCAAsC,EAAE;AACzD,kBAAkB,8BAA8B,EAAE;;AAElD;EACE,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,sBAAsB,8BAA8B,EAAE;;AAEtD;EACE,gBAAgB,+BAA+B,EAAE,QAAQ,EAAE;EAC3D,qDAAqD,aAAa,EAAE;AACtE;;AAEA,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE,gBAAgB,EAAE;AAC9F,mBAAmB,kBAAkB,EAAE,4BAA4B,EAAE,cAAc,EAAE;;AAErF,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,gDAAgD;AAChD,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,cAAc,EAAE;;AAEtC,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,uCAAuC,gCAAgC,EAAE,cAAc,EAAE;AACzF,uCAAuC,gCAAgC,GAAG,cAAc,EAAE;AAC1F,uCAAuC,+BAA+B,IAAI,cAAc,EAAE;AAC1F,uCAAuC,8BAA8B,KAAK,4BAA4B,EAAE;;AAExG,eAAe;AACf,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnE;EACE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA,mBAAmB,YAAY,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AAChF,oBAAoB,iBAAiB,EAAE,4BAA4B,EAAE;;AAErE,cAAc;AACd;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,WAAW;AACb;AACA,mBAAmB,4BAA4B,EAAE,WAAW,EAAE;;AAE9D,+EAA+E;AAC/E;EACE,aAAa;EACb,yCAAyC;EACzC,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,4CAA4C;EAC5C,iBAAiB;AACnB;AACA,2BAA2B,mBAAmB,EAAE;AAChD,gBAAgB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC/E,kBAAkB,SAAO,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAClI,mBAAmB,4BAA4B,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC1F;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;AACA,kBAAkB,kBAAkB,EAAE,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAEvG;;;kFAGkF;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sFAAsF;EACtF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,0CAA0C;AAC5C;AACA,qDAAqD;AACrD,oCAAoC,+BAA+B,GAAG,cAAc,EAAE,iCAAiC,EAAE;AACzH,oCAAoC,+BAA+B,GAAG,cAAc,EAAE,iCAAiC,EAAE;AACzH,oCAAoC,8BAA8B,IAAI,cAAc,EAAE,gCAAgC,EAAE;AACxH,oCAAoC,8BAA8B,IAAI,4BAA4B,EAAE;;AAEpG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;AACA,sBAAsB,0BAA0B,EAAE;AAClD;EACE,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,6BAA6B,WAAW,EAAE,mBAAmB,EAAE;;AAE/D;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,wCAAwC;EACxC,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;AACvC;AACA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,qCAAqC,mBAAmB,EAAE;AAC1D,qCAAqC,mBAAmB,EAAE;AAC1D,qCAAqC,mBAAmB,EAAE;AAC1D,yCAAyC;AACzC;EACE,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB,mBAAmB,EAAE;AACzC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACvE;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,uBAAuB,6BAA6B,EAAE;AACtD;EACE,SAAS;EACT,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,SAAS;EACT,gBAAgB;EAChB,SAAO;AACT;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iEAAiE;AACjE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA,qBAAqB,WAAW,EAAE;AAClC;EACE,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;AACA,2BAA2B,iBAAiB,EAAE,WAAW,EAAE;AAC3D,2BAA2B,SAAS,EAAE,kBAAkB,EAAE,mCAAmC,EAAE;AAC/F,8BAA8B,kBAAkB,EAAE;;AAElD,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;AAChB;AACA,2BAA2B,mCAAmC,EAAE;;AAEhE,yCAAyC;AACzC;EACE,oCAAoC;AACtC;AACA;EACE,oFAAoF;AACtF;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA,wDAAwD,gCAAgC,GAAG,cAAc,EAAE,iCAAiC,EAAE;AAC9I,wDAAwD,gCAAgC,GAAG,cAAc,EAAE,iCAAiC,EAAE;AAC9I,wDAAwD,+BAA+B,IAAI,cAAc,EAAE,gCAAgC,EAAE;AAC7I,yDAAyD,mBAAmB,EAAE;AAC9E,yDAAyD,mBAAmB,EAAE;AAC9E,yDAAyD,mBAAmB,EAAE;;AAE9E;;kFAEkF;AAClF;EACE,aAAa,EAAE,sBAAsB,EAAE,YAAY;EACnD,+BAA+B,EAAE,qCAAqC,EAAE,mBAAmB,EAAE,gBAAgB;AAC/G;AACA;EACE,kBAAkB,EAAE,4CAA4C;EAChE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;AACpE;AACA,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE;AACvF,cAAc,YAAY,EAAE;;AAE5B,cAAc,aAAa,EAAE,SAAO,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC5E,kBAAkB,SAAO,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACpE;EACE,YAAY,EAAE,0CAA0C,EAAE,gBAAgB;EAC1E,kBAAkB,EAAE,QAAQ,EAAE,MAAM,EAAE,YAAY,EAAE,WAAW;EAC/D,uCAAuC;AACzC;;AAEA,eAAe,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACpE;EACE,aAAa,EAAE,4CAA4C;EAC3D,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;AACpE;AACA,yBAAyB,SAAS,EAAE,eAAe,EAAE,0BAA0B,EAAE;AACjF,iBAAiB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,4BAA4B,EAAE;;AAEhG,qBAAqB,eAAe,EAAE,kBAAkB,EAAE;AAC1D,qBAAqB,iBAAiB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAE7G,kBAAkB,qBAAqB,EAAE,iBAAiB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE;AACrH;EACE,iBAAiB,EAAE,gCAAgC,EAAE,iBAAiB;EACtE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;AACpE;AACA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAErI,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,4CAA4C,EAAE,SAAS,EAAE,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAC3N,iBAAiB,4BAA4B,EAAE;AAC/C,uBAAuB,aAAa,EAAE,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAClG;EACE,gBAAgB,EAAE,qCAAqC,EAAE,kBAAkB;EAC3E,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE,0BAA0B;EAChF,mBAAmB;AACrB;AACA,wBAAwB,2BAA2B,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;;AAEhG;EACE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB;EACnF,YAAY,EAAE,4BAA4B,EAAE,SAAS;AACvD;AACA,eAAe,WAAW,EAAE,YAAY,EAAE,qCAAqC,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,kCAAkC,EAAE;AAC1K,kBAAkB,eAAe,EAAE,WAAW,EAAE;;AAEhD,+EAA+E;AAC/E,oBAAoB,YAAY,EAAE;AAClC,4BAA4B,oBAAoB,WAAW,EAAE,EAAE;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;AACA,2BAA2B,iBAAiB,EAAE,4BAA4B,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7G,6BAA6B,SAAS,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE;;AAE9K,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA,gBAAgB,0BAA0B,EAAE;AAC5C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,gCAAgC,EAAE,cAAc;AAClD;AACA;EACE,gCAAgC,EAAE,cAAc;AAClD;AACA;EACE,+BAA+B,EAAE,cAAc;AACjD;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD,iBAAiB,gBAAgB,EAAE,iBAAiB,EAAE;AACtD;EACE,iBAAiB,EAAE,gCAAgC,EAAE,kBAAkB;EACvE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,QAAQ;AAC9E;AACA,iBAAiB,SAAO,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAEtH,wDAAwD;AACxD;EACE,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;;kFAGkF;;AAElF,+EAA+E;AAC/E;EACE,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,SAAO;EACP,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,4CAA4C;AAC9C;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,uCAAuC;EACvC,qDAAqD;EACrD,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,qDAAqD;EACrD,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uCAAuC;EACvC,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,MAAM;EACN,eAAe;EACf,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oDAAoD;EACpD,gBAAgB;EAChB,SAAO;AACT;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,SAAO;EACP,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,yCAAyC;EACzC,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,kDAAkD;EAClD,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,qCAAqC;EACrC,8CAA8C;EAC9C,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,SAAS;EACT,qDAAqD;EACrD,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,qDAAqD;EACrD,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;;AAEA;;kFAEkF;AAClF;EACE,aAAa,EAAE,sBAAsB,EAAE,YAAY;EACnD,+BAA+B,EAAE,qCAAqC,EAAE,mBAAmB,EAAE,gBAAgB;AAC/G;AACA;EACE,kBAAkB,EAAE,4CAA4C;EAChE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;AACpE;AACA,eAAe,aAAa,EAAE,QAAQ,EAAE,8BAA8B,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAC1G;EACE,YAAY,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,eAAe;AACtH;AACA,uBAAuB,gBAAgB,EAAE,0BAA0B,EAAE,gCAAgC,EAAE;;AAEvG;EACE,aAAa,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,4CAA4C,EAAE,eAAe;AAClI;AACA,YAAY,aAAa,EAAE,sBAAsB,EAAE;AACnD,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,cAAc,EAAE;AACnG,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE,eAAe,EAAE;AAChH;EACE,iBAAiB,EAAE,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB;EAC7F,yBAAyB,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;AAC7F;;AAEA,kBAAkB,SAAO,EAAE,aAAa,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;;AAEjF,mBAAmB;AACnB,kBAAkB,SAAO,EAAE,cAAc,EAAE;AAC3C,aAAa,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;AACxE;EACE,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,4BAA4B;EACvF,gBAAgB,EAAE,4CAA4C,EAAE,gBAAgB,EAAE,MAAM;AAC1F;AACA,gBAAgB,eAAe,EAAE;AACjC,sBAAsB,mBAAmB,EAAE;AAC3C,iBAAiB,gBAAgB,EAAE,kBAAkB,EAAE;AACvD,iBAAiB,gCAAgC,EAAE,eAAe,EAAE;AACpE,uBAAuB,mBAAmB,EAAE;AAC5C,gBAAgB,kBAAkB,EAAE,0BAA0B,EAAE;AAChE,iBAAiB,gBAAgB,EAAE;AACnC,qBAAqB,kBAAkB,EAAE,WAAW,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;;AAElH;;kFAEkF;AAClF;EACE,aAAa,EAAE,sBAAsB,EAAE,YAAY;EACnD,+BAA+B,EAAE,qCAAqC,EAAE,mBAAmB,EAAE,gBAAgB;AAC/G;AACA,cAAc,kBAAkB,EAAE,4CAA4C,EAAE;AAChF,gBAAgB,iBAAiB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;;AAEpF;EACE,aAAa,EAAE,mBAAmB,EAAE,4CAA4C;EAChF,aAAa,EAAE,qBAAqB,EAAE,SAAS,EAAE,eAAe;AAClE;AACA,qBAAqB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACjG,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAC1F,gBAAgB,aAAa,EAAE,qCAAqC,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC/H,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC1N,gBAAgB,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAE1E;EACE,aAAa,EAAE,6BAA6B,EAAE,mBAAmB,EAAE,aAAa;EAChF,gBAAgB,EAAE,gCAAgC;AACpD;AACA,YAAY,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AACxE,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACnF,kBAAkB,iBAAiB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE;AAC9F,iBAAiB,iBAAiB,EAAE,4BAA4B,EAAE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACjH,kBAAkB,oBAAoB,EAAE;;AAExC,kBAAkB,SAAO,EAAE,kBAAkB,EAAE,4CAA4C,EAAE,aAAa,EAAE,sBAAsB,EAAE;AACpI,mBAAmB,kBAAkB,EAAE,SAAS,EAAE,UAAU,EAAE,SAAS,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,UAAU,EAAE,iCAAiC,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAChN,oBAAoB,SAAO,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAElE,mBAAmB,aAAa,EAAE,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACxF,sBAAsB,kBAAkB,EAAE,iBAAiB,EAAE,4BAA4B,EAAE;AAC3F;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE,gBAAgB;EAClF,qCAAqC,EAAE,kBAAkB,EAAE,kBAAkB;AAC/E;AACA,mBAAmB,kBAAkB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAC7I,mBAAmB,YAAY,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACpI,yBAAyB,oBAAoB,EAAE,0BAA0B,EAAE;AAC3E,mBAAmB,iBAAiB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;;AAE3G,iBAAiB,aAAa,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AAClF,kBAAkB,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE;AACrE,YAAY,iBAAiB,EAAE,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AACpJ;EACE,kBAAkB,EAAE,YAAY,EAAE,SAAS,EAAE,2BAA2B;EACxE,+BAA+B,EAAE,iBAAiB,EAAE,qCAAqC,EAAE,kBAAkB;EAC7G,qCAAqC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,WAAW;EACvF,0BAA0B;AAC5B;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mCAAmC;EACnC,oBAAoB;EACpB,MAAM;EACN,aAAa;EACb,uCAAuC;EACvC,4CAA4C;AAC9C;AACA;EACE;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;EACA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;EACA,yBAAyB,SAAO,EAAE,sBAAsB,EAAE,sBAAsB,EAAE;AACpF;;AAEA,kCAAkC;AAClC;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;AACA,qBAAqB,iBAAiB,EAAE,WAAW,EAAE;AACrD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;AACjB;AACA,2BAA2B,WAAW,EAAE;;AAExC,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,UAAU;EACV,SAAO;EACP,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,yCAAyC;EACzC,cAAc;AAChB;AACA,4BAA4B,iBAAiB,EAAE;AAC/C,+BAA+B,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACpF,gCAAgC,iBAAiB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;;AAEtH;;kFAEkF;;AAElF,qBAAqB;AACrB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA,uBAAuB,kCAAkC,EAAE,WAAW,EAAE,oCAAoC,EAAE;;AAE9G,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,SAAO;AACT;AACA;EACE,WAAW,EAAE,YAAY;EACzB,8CAA8C;EAC9C,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;AACpC;AACA,aAAa,cAAc,EAAE;AAC7B,eAAe,eAAe,EAAE,WAAW,EAAE;;AAE7C,iBAAiB;AACjB;EACE,aAAa;EACb,MAAM;EACN,uCAAuC;EACvC,qDAAqD;EACrD,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;EACf,cAAc;AAChB;AACA,uBAAuB,kBAAkB,EAAE;AAC3C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;AAChB;AACA,iBAAiB,kBAAkB,EAAE;AACrC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qDAAqD;EACrD,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;AACrB;AACA,kBAAkB,mCAAmC,EAAE;AACvD,kBAAkB,6BAA6B,EAAE,2CAA2C,EAAE,gBAAgB,EAAE;AAChH;EACE,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,2BAA2B;AAC3B,eAAe,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAChF;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA,sBAAsB,uCAAuC,EAAE,mCAAmC,EAAE;;AAEpG;EACE,kBAAkB;EAClB,qCAAqC;EACrC,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mDAAmD;EACnD,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,oCAAoC;AACtC;AACA,iBAAiB,kBAAkB,EAAE;;AAErC,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,UAAU;EACV,wBAAwB;EACxB,cAAc;AAChB;AACA,gDAAgD,UAAU,EAAE;;AAE5D,0BAA0B;AAC1B,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnE;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA,8BAA8B,uCAAuC,EAAE;AACvE;EACE,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA,mBAAmB,iBAAiB,EAAE,qCAAqC,EAAE,cAAc,EAAE;;AAE7F;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kDAAkD;EAClD,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qDAAqD;AACvD;AACA,iCAAiC,mBAAmB,EAAE;AACtD;EACE,SAAO;EACP,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;AACpB;AACA,qBAAqB,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;AACtE,qBAAqB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAC7F;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA,2BAA2B,0BAA0B,EAAE;AACvD;EACE,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,+DAA+D;AACjE;AACA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B;AACA,6DAA6D,UAAU,EAAE;;AAEzE,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B;AACA,0DAA0D,UAAU,EAAE;;AAEtE,yBAAyB;AACzB;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;AACA,mBAAmB,gBAAgB,EAAE;AACrC;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,iBAAiB;EACjB,qDAAqD;EACrD,kBAAkB;AACpB;AACA,2BAA2B,mBAAmB,EAAE;AAChD;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,SAAO;EACP,qBAAqB;AACvB;AACA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,wDAAwD;;AAExD,6BAA6B;AAC7B;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,qBAAqB,iCAAiC,EAAE,cAAc,EAAE;AACxE,qBAAqB,iCAAiC,GAAG,cAAc,EAAE;;AAEzE,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAO;AACT;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,SAAO;AACT;;AAEA,uDAAuD;AACvD;EACE,SAAO;EACP,SAAS;EACT,iBAAiB;EACjB,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,qDAAqD;EACrD,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA,kFAAkF;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;AACA,6BAA6B,aAAa,EAAE,2BAA2B,EAAE;;AAEzE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,0BAA0B,6BAA6B,EAAE;;AAEzD;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,qDAAqD;EACrD,kBAAkB;EAClB,uBAAuB;AACzB;AACA,yBAAyB,mBAAmB,EAAE;AAC9C;EACE,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,SAAO;EACP,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;AACnB;AACA,kBAAkB,qCAAqC,EAAE,iBAAiB,EAAE;;AAE5E,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACtE;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;;AAE3C;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,eAAe;AACjB;AACA,8BAA8B,oCAAoC,EAAE;AACpE,8BAA8B,mBAAmB,EAAE;AACnD,8BAA8B,mCAAmC,EAAE;AACnE,8BAA8B,mBAAmB,EAAE;AACnD,8BAA8B,oCAAoC,EAAE;AACpE,8BAA8B,mBAAmB,EAAE;AACnD,8BAA8B,mCAAmC,EAAE;AACnE,8BAA8B,mBAAmB,EAAE;AACnD,8BAA8B,mCAAmC,EAAE;AACnE,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;AACA,4BAA4B,yBAAyB,EAAE;AACvD,4BAA4B,yBAAyB,EAAE;;AAEvD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kDAAkD;EAClD,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;AACA,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;AAChE;EACE,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;AACf;;AAEA,gCAAgC;AAChC,yCAAyC,+BAA+B,EAAE,iCAAiC,EAAE;AAC7G,yCAAyC,+BAA+B,EAAE,iCAAiC,EAAE;AAC7G,yCAAyC,iCAAiC,EAAE;AAC5E,yCAAyC,wCAAwC,EAAE;AACnF,4CAA4C,mCAAmC,EAAE;AACjF,yCAAyC,kCAAkC,EAAE,oCAAoC,EAAE;;AAEnH;;kFAEkF;AAClF;EACE,0CAA0C;AAC5C;AACA,sCAAsC,8BAA8B,EAAE;AACtE,sCAAsC,uBAAuB,EAAE;AAC/D,sCAAsC,6BAA6B,EAAE;AACrE;;;uCAGuC,+BAA+B,EAAE,iCAAiC,EAAE;AAC3G,kDAAkD,8BAA8B,EAAE;AAClF,0CAA0C,wCAAwC,EAAE;AACpF,wCAAwC,8BAA8B,EAAE;AACxE,wCAAwC,wCAAwC,EAAE;AAClF,2CAA2C,8BAA8B,EAAE;;AAE3E;;;kFAGkF;AAClF;;EAEE,+EAA+E;EAC/E,OAAO,gCAAgC,EAAE;;EAEzC,8EAA8E;EAC9E,eAAe,+BAA+B,EAAE,cAAc,EAAE;EAChE,eAAe,+BAA+B,GAAG,cAAc,EAAE;EACjE,eAAe,gCAAgC,EAAE,cAAc,EAAE;;EAEjE,+EAA+E;EAC/E;iBACe,+BAA+B,EAAE;;EAEhD,+EAA+E;EAC/E,wBAAwB,qCAAqC,EAAE;EAC/D,yBAAyB,8BAA8B,EAAE;;EAEzD,8EAA8E;EAC9E;;+BAE6B,8BAA8B,EAAE;EAC7D,oBAAoB,qCAAqC,EAAE;;EAE3D,8EAA8E;EAC9E,gBAAgB,8BAA8B,EAAE;EAChD,sBAAsB,+BAA+B,EAAE;;EAEvD,8EAA8E;EAC9E,YAAY,sCAAsC,EAAE;EACpD,qBAAqB,8BAA8B,EAAE,sCAAsC,EAAE;EAC7F,iBAAiB,gCAAgC,EAAE;;EAEnD,+EAA+E;EAC/E,iBAAiB,+BAA+B,EAAE,uCAAuC,EAAE,cAAc,EAAE;EAC3G,YAAY,+BAA+B,EAAE;EAC7C,kBAAkB,8BAA8B,EAAE;EAClD,iBAAiB,8BAA8B,EAAE,4BAA4B,EAAE;EAC/E,mBAAmB,6BAA6B,EAAE;EAClD,gBAAgB,+BAA+B,EAAE;EACjD,sBAAsB,8BAA8B,EAAE;EACtD,kBAAkB,+BAA+B,EAAE;EACnD,iBAAiB,8BAA8B,EAAE,iCAAiC,EAAE;EACpF,gBAAgB,8BAA8B,EAAE;EAChD,eAAe,+BAA+B,EAAE,cAAc,EAAE;EAChE,eAAe,+BAA+B,GAAG,cAAc,EAAE;EACjE,eAAe,8BAA8B,IAAI,4BAA4B,EAAE;EAC/E,mBAAmB,+BAA+B,EAAE,cAAc,EAAE,gCAAgC,EAAE;EACtG,mBAAmB,+BAA+B,GAAG,cAAc,EAAE,gCAAgC,EAAE;EACvG,mBAAmB,+BAA+B,EAAE;;EAEpD,+EAA+E;EAC/E,iBAAiB,sCAAsC,EAAE;EACzD,kBAAkB,0BAA0B,EAAE;EAC9C,uCAAuC,+BAA+B,EAAE,cAAc,EAAE;EACxF,uCAAuC,+BAA+B,GAAG,cAAc,EAAE;EACzF,uCAAuC,8BAA8B,IAAI,cAAc,EAAE;EACzF,qBAAqB,+BAA+B,EAAE,cAAc,EAAE,gCAAgC,EAAE;EACxG,qCAAqC;EACrC,mBAAmB,cAAc,EAAE;EACnC,sBAAsB,cAAc,EAAE;EACtC,mBAAmB,cAAc,EAAE;;EAEnC,8EAA8E;EAC9E,kBAAkB,6BAA6B,EAAE;EACjD,oBAAoB,+BAA+B,EAAE;EACrD,gBAAgB,wCAAwC,EAAE;EAC1D,iBAAiB,6BAA6B,EAAE;EAChD,kBAAkB,+BAA+B,EAAE;EACnD,wBAAwB,+BAA+B,EAAE;EACzD,oBAAoB,+BAA+B,EAAE,cAAc,EAAE;;EAErE,8EAA8E;EAC9E,uBAAuB,8BAA8B,EAAE;EACvD,eAAe,+BAA+B,EAAE;EAChD,oBAAoB,gCAAgC,EAAE,cAAc,EAAE,iCAAiC,EAAE;EACzG,gBAAgB,8BAA8B,EAAE;EAChD,sBAAsB,+BAA+B,EAAE;EACvD,iBAAiB,wCAAwC,EAAE;EAC3D,uBAAuB,8BAA8B,EAAE;;EAEvD,8EAA8E;EAC9E,gBAAgB,wCAAwC,EAAE;EAC1D,uBAAuB,wCAAwC,EAAE;EACjE,uBAAuB,qCAAqC,EAAE;EAC9D,oBAAoB,+BAA+B,EAAE,iCAAiC,EAAE;EACxF,0BAA0B,yBAAyB,EAAE;EACrD,oEAAoE,gCAAgC,EAAE,cAAc,EAAE;EACtH,kEAAkE,gCAAgC,EAAE,cAAc,EAAE;EACpH,wCAAwC,+BAA+B,EAAE,cAAc,EAAE;EACzF,+BAA+B,wCAAwC,EAAE;;EAEzE,8EAA8E;EAC9E,0BAA0B,+BAA+B,EAAE,iCAAiC,EAAE;;EAE9F,8EAA8E;EAC9E,iBAAiB,8BAA8B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE,0BAA0B,EAAE;EAC7E,kBAAkB,8BAA8B,EAAE,4BAA4B,EAAE;EAChF,iBAAiB,+BAA+B,EAAE,wCAAwC,EAAE;EAC5F,kBAAkB,+BAA+B,EAAE;EACnD,mBAAmB,6BAA6B,EAAE;EAClD,yBAAyB,oBAAoB,EAAE;EAC/C,YAAY,+BAA+B,EAAE,cAAc,EAAE;EAC7D,mBAAmB,6BAA6B,EAAE,4BAA4B,EAAE;EAChF,oBAAoB,+BAA+B,EAAE;EACrD,oBAAoB,qCAAqC,EAAE;;EAE3D,8EAA8E;EAC9E,oBAAoB,6BAA6B,EAAE;EACnD,gBAAgB,+BAA+B,EAAE,iCAAiC,EAAE,oCAAoC,EAAE;EAC1H,qBAAqB,qCAAqC,EAAE;EAC5D,yBAAyB,+BAA+B,EAAE;EAC1D,0BAA0B,+BAA+B,EAAE,wCAAwC,EAAE;AACvG","sourcesContent":["/* =============================================================================\n   KnowledgeGraphNew.css\n   Styles for Steps 5–7: Community Navigation, Search & Discovery,\n   User Items Intelligence (Document DNA, Network, Timeline, Bridge)\n   ============================================================================= */\n\n/* ── Shared Skeleton Animation ─────────────────────────────────────────────── */\n@keyframes shimmer {\n  0%   { background-position: -600px 0; }\n  100% { background-position:  600px 0; }\n}\n.skeleton-line {\n  height: 14px;\n  border-radius: 6px;\n  background: linear-gradient(90deg,\n    var(--bg-tertiary) 25%,\n    var(--border-color) 50%,\n    var(--bg-tertiary) 75%);\n  background-size: 600px 100%;\n  animation: shimmer 1.4s infinite linear;\n  margin-bottom: 8px;\n}\n.skeleton-title { height: 18px; width: 60%; }\n.skeleton-bar   { height: 8px;  width: 100%; }\n.skeleton-short { height: 12px; width: 40%; }\n\n/* ── Rating badges (shared) ─────────────────────────────────────────────────── */\n.community-rating-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: .4px;\n  text-transform: uppercase;\n}\n.rating-high { background: rgba(16,185,129,.15); color: #059669; }\n.rating-med  { background: rgba(245,158, 11,.15); color: #b45309; }\n.rating-low  { background: rgba(156,163,175,.15); color: #6b7280; }\n\n/* =============================================================================\n   1. KnowledgeGraphPage  (.kgp-*)\n   ============================================================================= */\n.kgp-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  height: 100%;\n  min-height: 0;\n}\n.kgp-search-row {\n  padding: 16px 20px 8px;\n  background: var(--bg-secondary, #fff);\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n}\n.kgp-subtabs {\n  display: flex;\n  gap: 4px;\n  padding: 8px 20px 0;\n  background: var(--bg-secondary, #fff);\n  border-bottom: 2px solid var(--border-color, #e4e4e7);\n  overflow-x: auto;\n}\n.kgp-subtab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary, #71717a);\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  font-size: 0.875rem;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: color .2s, border-color .2s;\n  margin-bottom: -2px;\n}\n.kgp-subtab:hover  { color: var(--text-primary, #18181b); }\n.kgp-subtab.active { color: var(--accent, #2563eb); border-bottom-color: var(--accent, #2563eb); font-weight: 600; }\n.kgp-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  background: var(--bg-primary, #f4f4f5);\n}\n\n/* =============================================================================\n   2. CommunityGrid  (.community-*)\n   ============================================================================= */\n.community-grid-page { display: flex; flex-direction: column; gap: 16px; }\n\n.community-grid-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.community-search-wrap {\n  position: relative;\n  flex: 1;\n  min-width: 200px;\n}\n.community-search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-secondary);\n  pointer-events: none;\n}\n.community-search-input {\n  width: 100%;\n  padding: 10px 36px 10px 36px;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  background: var(--bg-secondary, #fff);\n  color: var(--text-primary, #18181b);\n  font-size: 0.9rem;\n  transition: border-color .2s, box-shadow .2s;\n}\n.community-search-input:focus {\n  outline: none;\n  border-color: var(--accent, #2563eb);\n  box-shadow: 0 0 0 3px rgba(37,99,235,.1);\n}\n.community-search-clear {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-secondary);\n  padding: 4px;\n  font-size: 0.8rem;\n}\n\n.community-view-toggle { display: flex; gap: 4px; }\n.view-toggle-btn {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  background: var(--bg-secondary, #fff);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all .2s;\n}\n.view-toggle-btn.active,\n.view-toggle-btn:hover {\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border-color: var(--accent, #2563eb);\n}\n\n/* Grid / List layouts */\n.community-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n.community-grid.community-list-mode {\n  grid-template-columns: 1fr;\n}\n\n/* Community Card */\n.community-card {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 12px;\n  padding: 18px;\n  cursor: pointer;\n  transition: box-shadow .2s, transform .2s;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.community-card:hover {\n  box-shadow: 0 6px 20px rgba(0,0,0,.10);\n  transform: translateY(-2px);\n}\n.community-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n.community-card-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary, #18181b);\n  margin: 0;\n  line-height: 1.3;\n  flex: 1;\n}\n.community-rating-bar-wrap {\n  height: 5px;\n  background: var(--bg-tertiary, #f4f4f5);\n  border-radius: 999px;\n  overflow: hidden;\n}\n.community-rating-bar-fill {\n  height: 100%;\n  border-radius: 999px;\n  transition: width .4s ease;\n}\n.community-card-summary {\n  font-size: 0.85rem;\n  color: var(--text-secondary, #71717a);\n  line-height: 1.55;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin: 0;\n}\n.community-card-summary.expanded {\n  display: block;\n  -webkit-line-clamp: unset;\n}\n.community-read-more {\n  background: none;\n  border: none;\n  color: var(--accent, #2563eb);\n  font-size: 0.8rem;\n  cursor: pointer;\n  padding: 0;\n  font-weight: 500;\n}\n.community-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: auto;\n  padding-top: 8px;\n  border-top: 1px solid var(--border-color, #e4e4e7);\n}\n.community-node-count {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.community-explore-hint {\n  font-size: 0.8rem;\n  color: var(--accent, #2563eb);\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n/* Skeleton card */\n.community-card-skeleton { cursor: default; }\n.community-card-skeleton:hover { box-shadow: none; transform: none; }\n\n/* Empty / Error states */\n.community-empty-state, .community-error-state {\n  text-align: center;\n  padding: 48px 24px;\n  color: var(--text-secondary);\n}\n.community-empty-icon {\n  font-size: 3rem;\n  margin-bottom: 16px;\n  opacity: .5;\n  display: block;\n}\n.community-empty-state h3 { font-size: 1.1rem; margin-bottom: 8px; color: var(--text-primary); }\n.community-empty-state p  { font-size: 0.9rem; margin-bottom: 16px; }\n.community-error-state {\n  background: rgba(239,68,68,.08);\n  border: 1px solid rgba(239,68,68,.2);\n  border-radius: 8px;\n  color: #dc2626;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  text-align: left;\n  font-size: 0.9rem;\n}\n\n/* =============================================================================\n   3. CommunityDetailPanel  (.cdp-*)\n   ============================================================================= */\n.cdp-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.cdp-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px 16px;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 600;\n  transition: all .2s;\n  align-self: flex-start;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n}\n.cdp-back-btn:hover { \n  border-color: var(--accent, #2563eb); \n  color: var(--accent, #2563eb); \n  box-shadow: 0 2px 6px rgba(37,99,235,0.15);\n}\n\n.cdp-split {\n  display: grid;\n  grid-template-columns: 340px 1fr;\n  gap: 20px;\n  flex: 1;\n  min-height: 500px;\n  overflow: hidden;\n}\n@media (max-width: 900px) {\n  .cdp-split {\n    grid-template-columns: 1fr;\n    height: auto;\n    min-height: unset;\n    overflow: visible;\n  }\n}\n\n/* Left panel */\n.cdp-left-panel {\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 12px;\n  overflow: hidden;\n  height: 100%;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.03);\n}\n.cdp-comm-header {\n  padding: 24px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n  background: var(--bg-tertiary, #fafafa);\n}\n.cdp-comm-header h2 { \n  font-size: 1.2rem; \n  font-weight: 700; \n  margin: 0 0 12px 0; \n  color: var(--text-primary); \n  line-height: 1.35;\n}\n.cdp-comm-meta { \n  display: flex; \n  align-items: center; \n  gap: 8px; \n  margin-bottom: 16px; \n  flex-wrap: wrap; \n}\n.cdp-rating-pill {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #fff;\n}\n.cdp-node-pill {\n  font-size: 0.78rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  padding: 3px 12px;\n  border-radius: 999px;\n}\n.cdp-comm-summary { \n  font-size: 0.9rem; \n  color: var(--text-secondary); \n  line-height: 1.6; \n  margin: 0; \n  background: var(--bg-secondary, #fff);\n  padding: 14px;\n  border-radius: 8px;\n  border: 1px solid var(--border-color, #e4e4e7);\n}\n\n.cdp-node-list-header {\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n  background: var(--bg-secondary, #fff);\n}\n.cdp-node-list-header h4 { \n  margin: 0; \n  font-size: 0.8rem; \n  color: var(--text-secondary); \n  font-weight: 700; \n  text-transform: uppercase; \n  letter-spacing: 0.5px; \n}\n.cdp-node-list { \n  overflow-y: auto; \n  flex: 1; \n  padding: 12px; \n  background: var(--bg-secondary, #fff);\n}\n.cdp-node-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background .15s, border-color .15s;\n  border: 1px solid transparent;\n  margin-bottom: 4px;\n}\n.cdp-node-item:hover, .cdp-node-item.highlighted { \n  background: var(--bg-tertiary, #f8fafc);\n  border-color: var(--border-color, #e4e4e7);\n}\n.cdp-node-type-chip {\n  display: inline-block;\n  padding: 3px 8px;\n  border-radius: 6px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n  flex-shrink: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n.cdp-node-name { \n  flex: 1; \n  font-size: 0.88rem; \n  font-weight: 500;\n  color: var(--text-primary); \n  min-width: 0; \n  overflow: hidden; \n  text-overflow: ellipsis; \n  white-space: nowrap; \n}\n.cdp-node-context-btn {\n  background: var(--bg-tertiary, #f4f4f5);\n  border: 1px solid var(--border-color, #e4e4e7);\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all .15s;\n  font-size: 0.8rem;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.cdp-node-context-btn:hover { \n  background: var(--accent, #2563eb); \n  border-color: var(--accent, #2563eb);\n  color: #fff; \n}\n.cdp-empty-nodes { font-size: 0.85rem; color: var(--text-secondary); text-align: center; padding: 24px; }\n\n/* Right canvas — needs explicit height for ReactFlow */\n.cdp-graph-canvas {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 12px;\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n}\n.cdp-canvas-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--text-secondary);\n  gap: 12px;\n}\n.cdp-canvas-empty i { font-size: 2.5rem; opacity: .4; }\n\n/* Edge tooltip — rendered inside ReactFlow Panel */\n.cdp-edge-tooltip {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 0.82rem;\n  max-width: 420px;\n  box-shadow: 0 4px 16px rgba(0,0,0,.15);\n  z-index: 10;\n  line-height: 1.45;\n  pointer-events: none;\n}\n.cdp-edge-tooltip strong { color: var(--text-primary); }\n\n/* Make sure ReactFlow renders full height within its wrapper */\n.cdp-graph-canvas .react-flow,\n.cdp-graph-canvas .react-flow__renderer,\n.cdp-graph-canvas .react-flow__container {\n  /* Use explicit 100% without !important to allow flex context to work */\n  width: 100%;\n  height: 100%;\n}\n\n/* Entity drawer overlay */\n.cdp-entity-drawer {\n  position: absolute;\n  top: 0; right: 0;\n  width: min(340px, 100%);\n  height: 100%;\n  background: var(--bg-secondary, #fff);\n  border-left: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 0 12px 12px 0;\n  overflow-y: auto;\n  z-index: 20;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  box-shadow: -4px 0 16px rgba(0,0,0,.08);\n}\n.cdp-entity-drawer-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.cdp-entity-drawer-header h3 { margin: 0; flex: 1; font-size: 1rem; color: var(--text-primary); }\n.cdp-close-btn {\n  background: none;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  padding: 5px 9px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  transition: all .2s;\n}\n.cdp-close-btn:hover { background: var(--danger, #ef4444); color: #fff; border-color: var(--danger, #ef4444); }\n.cdp-entity-description { font-size: 0.85rem; color: var(--text-secondary); line-height: 1.55; }\n.cdp-entity-props { display: flex; flex-direction: column; gap: 6px; }\n.cdp-entity-prop-row {\n  display: flex;\n  gap: 8px;\n  font-size: 0.82rem;\n  padding: 6px 0;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n}\n.cdp-prop-key { color: var(--text-secondary); min-width: 90px; font-weight: 600; }\n.cdp-prop-val { color: var(--text-primary); flex: 1; word-break: break-all; }\n\n/* Loading / Error */\n.cdp-loading, .cdp-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 48px;\n  color: var(--text-secondary);\n  height: 100%;\n}\n.cdp-loading-spinner {\n  width: 36px; height: 36px;\n  border: 3px solid var(--border-color, #e4e4e7);\n  border-top-color: var(--accent, #2563eb);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n.cdp-error { color: #dc2626; }\n\n/* =============================================================================\n   4. EntityTreeViewer  (.etv-*)\n   ============================================================================= */\n.etv-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.etv-header {\n  padding: 16px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.etv-header-left h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.etv-root-name {\n  font-weight: 400;\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n}\n.etv-stats {\n  display: block;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin-top: 4px;\n  margin-left: 24px;\n}\n.etv-close-btn {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  transition: all .2s;\n}\n.etv-close-btn:hover { background: var(--bg-tertiary, #f4f4f5); color: var(--text-primary); }\n\n.etv-controls {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  display: flex;\n  gap: 20px;\n  background: var(--bg-tertiary, #fafafa);\n  flex-wrap: wrap;\n}\n.etv-control-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.etv-control-group label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  letter-spacing: .5px;\n}\n.etv-seg-btns {\n  display: inline-flex;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  padding: 2px;\n}\n.etv-seg-btn {\n  background: none;\n  border: none;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all .2s;\n}\n.etv-seg-btn.active {\n  background: var(--bg-tertiary, #e4e4e7);\n  color: var(--text-primary);\n  font-weight: 600;\n}\n.etv-depth-slider { width: 120px; }\n\n.etv-content { flex: 1; overflow-y: auto; padding: 16px; position: relative; }\n.etv-tree-wrap, .etv-flat-list { display: flex; flex-direction: column; gap: 2px; }\n\n.etv-tree-node { display: flex; flex-direction: column; }\n.etv-tree-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: background .15s;\n  min-height: 32px;\n}\n.etv-tree-row:hover { background: var(--bg-tertiary, #f4f4f5); }\n\n.etv-expand-btn {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  font-size: 0.7rem;\n  padding: 0;\n}\n.etv-expand-btn:disabled { cursor: default; opacity: .3; }\n\n.etv-type-chip {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: #fff;\n  text-transform: uppercase;\n}\n.etv-entity-name {\n  font-size: 0.85rem;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n.etv-rel-tag {\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n  background: var(--bg-tertiary, #f4f4f5);\n  padding: 1px 6px;\n  border-radius: 4px;\n  border: 1px solid var(--border-color, #e4e4e7);\n}\n.etv-evidence-link {\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  opacity: .6;\n  transition: opacity .2s;\n}\n.etv-evidence-link:hover { opacity: 1; color: var(--accent, #2563eb); }\n.etv-context-btn {\n  margin-left: auto;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  opacity: 0;\n  transition: opacity .2s, background .2s;\n}\n.etv-tree-row:hover .etv-context-btn { opacity: 1; }\n.etv-context-btn:hover { background: var(--bg-secondary, #fff); color: var(--accent, #2563eb); }\n\n/* Flat view rows */\n.etv-flat-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  border-bottom: 1px solid var(--border-color, #f4f4f5);\n}\n.etv-flat-row:last-child { border-bottom: none; }\n\n/* Loading/Empty/Error */\n.etv-loading, .etv-empty, .etv-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--text-secondary);\n  gap: 10px;\n  padding: 20px;\n}\n.etv-spinner {\n  width: 24px; height: 24px;\n  border: 2px solid var(--border-color);\n  border-top-color: var(--text-secondary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* =============================================================================\n   5. UnifiedSearchBar & Results (.usb-*, .sr-*)\n   ============================================================================= */\n.usb-container { position: relative; width: 100%; max-width: 600px; }\n\n.usb-bar {\n  display: flex;\n  align-items: center;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  padding: 0 12px;\n  height: 40px;\n  transition: box-shadow .2s, border-color .2s;\n}\n.usb-bar:focus-within {\n  border-color: var(--accent, #2563eb);\n  box-shadow: 0 0 0 3px rgba(37,99,235,.1);\n}\n.usb-icon { color: var(--text-secondary); margin-right: 10px; }\n.usb-input {\n  flex: 1;\n  border: none;\n  background: none;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  height: 100%;\n}\n.usb-input:focus { outline: none; }\n.usb-clear {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 4px;\n  font-size: 0.85rem;\n}\n\n/* Search Results Panel */\n.sr-panel {\n  position: absolute;\n  top: 48px;\n  left: 0;\n  width: 100%;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0,0,0,.12);\n  z-index: 100;\n  overflow: hidden;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.sr-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  background: var(--bg-tertiary, #fafafa);\n}\n.sr-tab {\n  flex: 1;\n  padding: 10px;\n  background: none;\n  border: none;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all .2s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n}\n.sr-tab:hover { background: rgba(0,0,0,.02); color: var(--text-primary); }\n.sr-tab.active { color: var(--accent, #2563eb); border-bottom-color: var(--accent, #2563eb); background: var(--bg-secondary, #fff); }\n.sr-tab-count {\n  background: var(--bg-tertiary, #e4e4e7);\n  padding: 1px 6px;\n  border-radius: 99px;\n  font-size: 0.7rem;\n  min-width: 16px;\n  text-align: center;\n}\n\n.sr-results-body {\n  overflow-y: auto;\n  max-height: 500px;\n  padding: 8px 0;\n}\n.sr-loading, .sr-error, .sr-empty {\n  padding: 24px;\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n.sr-spinner {\n  display: inline-block;\n  width: 16px; height: 16px;\n  border: 2px solid var(--text-secondary);\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n\n/* Result items */\n.sr-result-item {\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--border-color, #f4f4f5);\n  cursor: pointer;\n  transition: background .15s;\n}\n.sr-result-item:hover { background: var(--bg-tertiary, #f8fafc); }\n.sr-result-item:last-child { border-bottom: none; }\n\n/* Community result */\n.sr-community .sr-result-header { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; }\n.sr-result-summary { font-size: 0.8rem; color: var(--text-secondary); margin: 0; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }\n\n/* Entity result */\n.sr-entity { display: flex; align-items: center; gap: 10px; }\n.sr-type-chip {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: #fff;\n  text-transform: uppercase;\n  flex-shrink: 0;\n}\n.sr-result-body { flex: 1; min-width: 0; }\n.sr-chevron { color: var(--text-secondary); opacity: .4; font-size: 0.8rem; }\n\n/* Evidence result */\n.sr-evidence { display: flex; flex-direction: column; gap: 6px; }\n.sr-evidence-quote {\n  font-size: 0.85rem;\n  color: var(--text-primary);\n  border-left: 3px solid var(--border-color, #e4e4e7);\n  padding-left: 10px;\n  margin: 0;\n  font-style: italic;\n  line-height: 1.5;\n  background: var(--bg-tertiary, #fafafa);\n  padding: 8px 10px;\n  border-radius: 0 4px 4px 0;\n}\n.sr-expand-btn {\n  display: block;\n  margin-top: 4px;\n  background: none;\n  border: none;\n  color: var(--accent, #2563eb);\n  font-size: 0.75rem;\n  cursor: pointer;\n  padding: 0;\n}\n.sr-evidence-meta { display: flex; align-items: center; gap: 8px; font-size: 0.75rem; color: var(--text-secondary); flex-wrap: wrap; }\n.sr-source-link { color: inherit; text-decoration: none; display: flex; align-items: center; gap: 4px; }\n.sr-source-link:hover { color: var(--accent, #2563eb); }\n.sr-provider-chip { background: var(--bg-tertiary, #e4e4e7); padding: 1px 6px; border-radius: 4px; }\n.sr-entity-tags { display: flex; gap: 4px; flex-wrap: wrap; margin-top: 2px; }\n.sr-entity-tag { font-size: 0.7rem; background: rgba(37,99,235,.1); color: var(--accent, #2563eb); padding: 1px 6px; border-radius: 4px; }\n\n/* Highlight mark */\nmark { background: #fef08a; color: inherit; padding: 0 1px; border-radius: 2px; }\n\n/* =============================================================================\n   6. EvidenceResultCard (Standalone) (.erc-*)\n   ============================================================================= */\n.erc-card {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 4px rgba(0,0,0,.04);\n  margin-bottom: 12px;\n}\n.erc-quote {\n  font-size: 0.9rem;\n  line-height: 1.6;\n  color: var(--text-primary);\n  margin: 0 0 12px 0;\n}\n.erc-highlight { background: rgba(250, 204, 21, 0.3); font-weight: 500; }\n.erc-expand-btn {\n  display: block;\n  margin-top: 8px;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.erc-expand-btn:hover { color: var(--accent, #2563eb); }\n\n.erc-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-color, #f4f4f5);\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n.erc-file-link {\n  color: var(--text-primary);\n  text-decoration: none;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.erc-file-link:hover { color: var(--accent, #2563eb); text-decoration: underline; }\n.erc-provider-chip {\n  color: #fff;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 0.7rem;\n}\n\n.erc-entities {\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.erc-entities-label { font-size: 0.75rem; color: var(--text-secondary); font-weight: 600; }\n.erc-entity-tag {\n  background: var(--bg-tertiary, #f4f4f5);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 4px;\n  padding: 2px 8px;\n  font-size: 0.75rem;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all .2s;\n}\n.erc-entity-tag:hover { border-color: var(--accent, #2563eb); color: var(--accent, #2563eb); }\n\n/* =============================================================================\n   7. LatentConnectionPanel (.lcp-*)\n   ============================================================================= */\n.lcp-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 12px;\n  overflow: hidden;\n}\n.lcp-header {\n  padding: 16px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.lcp-header h3 { margin: 0; font-size: 1.1rem; display: flex; align-items: center; gap: 8px; }\n.lcp-close-btn { background: none; border: none; font-size: 1.1rem; color: var(--text-secondary); cursor: pointer; }\n\n.lcp-controls {\n  padding: 16px;\n  background: var(--bg-tertiary, #fafafa);\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n}\n.lcp-control-row { display: flex; flex-direction: column; gap: 6px; }\n.lcp-label { font-size: 0.75rem; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; }\n\n/* Entity Input with Suggestions */\n.lcp-entity-input-wrap { position: relative; }\n.lcp-entity-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid var(--border-color, #d4d4d8);\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n.lcp-entity-input:focus { outline: none; border-color: var(--accent, #2563eb); }\n.lcp-input-spinner { position: absolute; right: 10px; top: 10px; color: var(--text-secondary); font-size: 0.8rem; }\n.lcp-suggestions {\n  position: absolute;\n  top: 100%; left: 0; width: 100%;\n  background: #fff;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0,0,0,.1);\n  margin-top: 4px;\n  z-index: 50;\n  max-height: 200px;\n  overflow-y: auto;\n  list-style: none;\n  padding: 0;\n}\n.lcp-suggestion-item {\n  padding: 8px 12px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.lcp-suggestion-item:hover { background: var(--bg-tertiary, #f4f4f5); }\n.lcp-sug-chip { font-size: 0.65rem; color: #fff; padding: 1px 5px; border-radius: 4px; font-weight: 700; }\n\n/* Slider & Button */\n.lcp-score-slider { width: 100%; }\n.lcp-attr-input {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n.lcp-discover-btn {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding: 10px;\n  font-weight: 600;\n}\n\n/* Results Area */\n.lcp-results { flex: 1; display: flex; flex-direction: column; overflow: hidden; }\n.lcp-seed-info {\n  padding: 12px 16px;\n  background: #eff6ff;\n  border-bottom: 1px solid #dbeafe;\n  color: #1e3a8a;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n}\n.lcp-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  background: #fff;\n}\n.lcp-tab {\n  flex: 1;\n  padding: 12px;\n  background: none;\n  border: none;\n  font-weight: 600;\n  color: var(--text-secondary);\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n.lcp-tab.active { color: var(--accent, #2563eb); border-bottom-color: var(--accent, #2563eb); background: #fafafa; }\n.lcp-tab-count { background: #e4e4e7; color: #52525b; padding: 1px 8px; border-radius: 99px; font-size: 0.75rem; }\n\n.lcp-tab-content { flex: 1; overflow-y: auto; padding: 0; background: #fafafa; }\n.lcp-empty { padding: 40px; text-align: center; color: var(--text-secondary); font-style: italic; }\n\n/* Connection Row */\n.lcp-conn-row {\n  background: #fff;\n  border-bottom: 1px solid var(--border-color, #f4f4f5);\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.lcp-conn-row:hover { background: #f8fafc; }\n.lcp-conn-type-chip { font-size: 0.65rem; color: #fff; padding: 2px 6px; border-radius: 4px; font-weight: 700; width: 24px; text-align: center; overflow: hidden; text-overflow: ellipsis; }\n.lcp-conn-name { flex: 1; font-weight: 500; color: var(--text-primary); }\n\n.lcp-conf-badge {\n  font-size: 0.7rem;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.conf-strong { background: #dcfce7; color: #15803d; }\n.conf-mod    { background: #fef9c3; color: #a16207; }\n.conf-weak   { background: #f3f4f6; color: #6b7280; }\n\n.lcp-reason-tag {\n  font-size: 0.7rem;\n  padding: 2px 8px;\n  border-radius: 99px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.lcp-reason-attr { background: #fff7ed; color: #c2410c; border: 1px solid #ffedd5; }\n.lcp-reason-cooc { background: #eff6ff; color: #1d4ed8; border: 1px solid #dbeafe; }\n\n.lcp-conf-bar {\n  width: 60px;\n  height: 4px;\n  background: #e4e4e7;\n  border-radius: 2px;\n  overflow: hidden;\n}\n.lcp-conf-bar-fill { height: 100%; background: var(--accent, #2563eb); }\n.lcp-view-btn {\n  background: none;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all .2s;\n}\n.lcp-view-btn:hover { border-color: var(--accent, #2563eb); color: var(--accent, #2563eb); }\n\n/* Bridge Row */\n.lcp-bridge-row {\n  background: #fff;\n  border-bottom: 1px solid var(--border-color, #f4f4f5);\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.lcp-bridge-count { font-size: 0.8rem; color: var(--text-secondary); }\n.lcp-community-pills { display: flex; flex-wrap: wrap; gap: 6px; }\n.lcp-comm-pill {\n  background: #f4f4f5;\n  border: 1px solid #e4e4e7;\n  padding: 2px 8px;\n  border-radius: 99px;\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.lcp-comm-pill:hover { border-color: var(--accent, #2563eb); color: var(--accent, #2563eb); }\n\n/* =============================================================================\n   8. DocumentDNAList (.dna-*)\n   ============================================================================= */\n.dna-list-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  overflow: hidden;\n}\n.dna-toolbar {\n  padding: 16px;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-shrink: 0;\n}\n.dna-toolbar h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-primary);\n}\n\n.dna-sort-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n.dna-sort-select {\n  padding: 6px 10px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  font-size: 0.85rem;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n.dna-sort-select:focus { outline: none; border-color: var(--accent); }\n.dna-refresh-btn { padding: 6px 10px; }\n\n/* The list scroll area — uses flex column so each row naturally pushes down */\n.dna-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: var(--bg-primary);\n}\n.dna-empty, .dna-error {\n  text-align: center;\n  padding: 40px;\n  color: var(--text-secondary);\n}\n.dna-empty i { font-size: 3rem; margin-bottom: 16px; opacity: .4; display: block; }\n.dna-no-knowledge {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  font-style: italic;\n  padding: 8px 0;\n}\n\n/* Each row is a flex column — header + detail. No overflow:hidden so expansion is visible */\n.dna-row {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  transition: box-shadow .2s;\n  /* Do NOT use overflow:hidden — it clips the expanded detail panel */\n}\n.dna-row:hover { box-shadow: 0 4px 12px rgba(0,0,0,.10); }\n.dna-row-failed { border-left: 4px solid #ef4444; }\n\n.dna-row-main {\n  display: grid;\n  grid-template-columns: 2fr 100px 1.5fr 1.5fr 30px;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 16px;\n  cursor: pointer;\n  border-radius: 8px;\n  user-select: none;\n}\n.dna-row-main:hover { background: var(--bg-tertiary); }\n\n@media (max-width: 900px) {\n  .dna-row-main { grid-template-columns: 1fr 30px; gap: 8px; }\n  .dna-status-badge, .dna-impact-col, .dna-strip-col { display: none; }\n}\n\n.dna-name-col { display: flex; align-items: center; gap: 8px; min-width: 0; overflow: hidden; }\n.dna-source-icon { font-size: 0.85rem; color: var(--text-secondary); flex-shrink: 0; }\n\n/* Name + description stacked block */\n.dna-name-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  overflow: hidden;\n}\n.dna-file-name {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n.dna-file-desc {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  font-style: italic;\n  line-height: 1.3;\n}\n.dna-provider-badge {\n  font-size: 0.7rem;\n  background: var(--bg-tertiary);\n  padding: 2px 6px;\n  border-radius: 4px;\n  color: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n/* Status icon colors (inline icon, not badge) */\n.dna-status-ok      { color: #15803d; }\n.dna-status-pending { color: #a16207; }\n.dna-status-fail    { color: #b91c1c; }\n.dna-status-none    { color: #71717a; }\n\n/* Status Badges (the pill label in the grid) */\n.dna-status-badge {\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: 99px;\n  text-align: center;\n  white-space: nowrap;\n}\n.dna-status-badge.dna-status-ok      { background: rgba(16,185,129,.15); color: #15803d; }\n.dna-status-badge.dna-status-pending { background: rgba(245,158,11,.15);  color: #a16207; }\n.dna-status-badge.dna-status-fail    { background: rgba(239,68,68,.15);   color: #b91c1c; }\n.dna-status-badge.dna-status-none    { background: var(--bg-tertiary);    color: var(--text-secondary); }\n\n/* Impact Bar */\n.dna-impact-col { display: flex; flex-direction: column; gap: 4px; }\n.dna-impact-bar {\n  height: 6px;\n  background: var(--bg-tertiary);\n  border-radius: 3px;\n  overflow: hidden;\n  width: 100%;\n}\n.dna-impact-fill { height: 100%; background: var(--accent); border-radius: 3px; }\n.dna-impact-label { font-size: 0.7rem; color: var(--text-secondary); }\n\n/* DNA Strip */\n.dna-strip {\n  height: 12px;\n  display: flex;\n  border-radius: 4px;\n  overflow: hidden;\n  background: var(--bg-tertiary);\n  width: 100%;\n}\n.dna-strip-empty {\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  color: var(--text-secondary);\n  width: 100%;\n  opacity: .6;\n}\n.dna-expand-icon { color: var(--text-secondary); opacity: .5; }\n\n/* ── Expanded Detail panel ───────────────────────────────────────────────── */\n.dna-row-detail {\n  padding: 16px;\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-tertiary);\n  border-radius: 0 0 8px 8px;\n}\n\n/* Description block in expanded DNA row */\n.dna-detail-description {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 12px 14px;\n  margin-bottom: 14px;\n}\n.dna-detail-description h5 {\n  margin: 0 0 8px 0;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.dna-detail-description p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n  line-height: 1.6;\n}\n\n.dna-failed-notice {\n  background: rgba(239,68,68,.12);\n  color: #b91c1c;\n  padding: 10px 14px;\n  border-radius: 6px;\n  border: 1px solid rgba(239,68,68,.25);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  margin-bottom: 12px;\n}\n.dna-community-list h5 {\n  margin: 0 0 10px 0;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  font-weight: 700;\n}\n.dna-comm-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--border-color);\n  font-size: 0.9rem;\n}\n.dna-comm-row:last-child { border-bottom: none; }\n.dna-comm-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }\n.dna-comm-title { flex: 1; font-weight: 500; color: var(--text-primary); min-width: 0; overflow: hidden; text-overflow: ellipsis; }\n.dna-comm-rating { color: var(--text-secondary); font-size: 0.85rem; white-space: nowrap; }\n.dna-explore-comm-btn {\n  font-size: 0.75rem;\n  padding: 4px 10px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--accent);\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: all .2s;\n}\n.dna-explore-comm-btn:hover {\n  border-color: var(--accent);\n  background: rgba(37,99,235,.08);\n}\n.dna-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n.dna-action-btn { font-size: 0.85rem; padding: 8px 16px; display: flex; align-items: center; gap: 8px; }\n\n/* =============================================================================\n   8b. DocumentDNADetail (.ddd-*)\n   Full DNA View for a single document — comprehensive, easy-to-read layout\n   ============================================================================= */\n\n.ddd-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Back / breadcrumb row ── */\n.ddd-header-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* ── Hero card ── */\n.ddd-hero {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 14px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0,0,0,.06);\n}\n.ddd-hero-icon-wrap {\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, rgba(37,99,235,.12) 0%, rgba(99,102,241,.12) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.ddd-hero-icon {\n  font-size: 1.6rem;\n  color: var(--accent, #2563eb);\n}\n.ddd-hero-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.ddd-hero-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary, #18181b);\n  word-break: break-word;\n  line-height: 1.35;\n}\n.ddd-hero-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.ddd-meta-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 99px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n.ddd-chip-provider {\n  background: rgba(99,102,241,.1);\n  color: #4f46e5;\n  border-color: rgba(99,102,241,.2);\n}\n.ddd-chip-date {\n  background: var(--bg-tertiary, #f4f4f5);\n  color: var(--text-secondary, #71717a);\n  border-color: var(--border-color, #e4e4e7);\n}\n/* Reuse existing dna-status-* colours for the chip */\n.ddd-meta-chip.dna-status-ok      { background: rgba(16,185,129,.1);  color: #15803d; border-color: rgba(16,185,129,.2); }\n.ddd-meta-chip.dna-status-pending { background: rgba(245,158,11,.1);  color: #a16207; border-color: rgba(245,158,11,.2); }\n.ddd-meta-chip.dna-status-fail    { background: rgba(239,68,68,.1);   color: #b91c1c; border-color: rgba(239,68,68,.2); }\n.ddd-meta-chip.dna-status-none    { background: var(--bg-tertiary);   color: var(--text-secondary); }\n\n.ddd-url-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  color: var(--accent, #2563eb);\n  text-decoration: none;\n  word-break: break-all;\n  line-height: 1.4;\n}\n.ddd-url-link:hover { text-decoration: underline; }\n.ddd-hero-desc {\n  margin: 0;\n  font-size: 0.88rem;\n  color: var(--text-secondary, #71717a);\n  line-height: 1.6;\n}\n.ddd-hero-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-shrink: 0;\n  align-self: flex-start;\n}\n.ddd-download-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.ddd-download-btn:disabled { opacity: .6; cursor: not-allowed; }\n\n@media (max-width: 720px) {\n  .ddd-hero {\n    flex-direction: column;\n  }\n  .ddd-hero-actions {\n    width: 100%;\n  }\n  .ddd-download-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* ── Stats bar ── */\n.ddd-stats-bar {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 1px;\n  background: var(--border-color, #e4e4e7);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 12px;\n  overflow: hidden;\n}\n.ddd-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 18px 16px;\n  background: var(--bg-secondary, #fff);\n  text-align: center;\n}\n.ddd-stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary, #18181b);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  line-height: 1;\n}\n.ddd-stat-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  color: var(--text-secondary, #71717a);\n}\n/* Status dot inside stat value */\n.ddd-status-dot {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.ddd-status-dot.dna-status-ok      { background: #15803d; }\n.ddd-status-dot.dna-status-pending { background: #a16207; }\n.ddd-status-dot.dna-status-fail    { background: #b91c1c; }\n.ddd-status-dot.dna-status-none    { background: #6b7280; }\n/* DNA strip inside the wider stat cell */\n.ddd-stat-strip {\n  grid-column: span 2;\n  align-items: stretch;\n  gap: 8px;\n}\n.ddd-stat-strip .dna-strip {\n  height: 16px;\n  border-radius: 6px;\n  width: 100%;\n}\n@media (max-width: 600px) {\n  .ddd-stat-strip { grid-column: span 1; }\n}\n\n/* ── Section wrapper ── */\n.ddd-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.ddd-section-header { display: flex; flex-direction: column; gap: 4px; }\n.ddd-section-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary, #18181b);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.ddd-section-title i { color: var(--accent, #2563eb); }\n.ddd-section-subtitle {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary, #71717a);\n}\n\n/* ── Community grid ── */\n.ddd-comm-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n/* ── Community Card (rich — matches community-card style) ── */\n.ddd-comm-card {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 12px;\n  padding: 18px;\n  cursor: pointer;\n  transition: box-shadow .2s, transform .2s;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.ddd-comm-card:hover {\n  box-shadow: 0 6px 20px rgba(0,0,0,.10);\n  transform: translateY(-2px);\n}\n\n/* Header row: title + rating badge */\n.ddd-comm-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n.ddd-comm-card-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary, #18181b);\n  margin: 0;\n  line-height: 1.3;\n  flex: 1;\n}\n\n/* Weight row */\n.ddd-comm-weight-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n.ddd-comm-weight-label {\n  font-size: 0.78rem;\n  color: var(--text-secondary, #71717a);\n}\n.ddd-comm-weight-value {\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n\n/* Optional summary text — show full content */\n.ddd-comm-summary {\n  font-size: 0.85rem;\n  color: var(--text-secondary, #71717a);\n  line-height: 1.55;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin: 0;\n}\n.ddd-comm-summary.expanded {\n  display: block;\n  -webkit-line-clamp: unset;\n}\n\n/* Footer */\n.ddd-comm-card-footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: auto;\n  padding-top: 8px;\n  border-top: 1px solid var(--border-color, #e4e4e7);\n}\n.ddd-comm-explore-hint {\n  font-size: 0.8rem;\n  color: var(--accent, #2563eb);\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n/* Kept for backward compat in case other files reference these */\n.ddd-comm-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.ddd-comm-bar-wrap { width: 100%; }\n.ddd-comm-bar {\n  height: 6px;\n  background: var(--bg-tertiary, #f4f4f5);\n  border-radius: 3px;\n  overflow: hidden;\n}\n.ddd-comm-bar-fill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width .4s ease;\n}\n\n/* ── Empty state ── */\n.ddd-empty-communities {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 48px 24px;\n  background: var(--bg-secondary, #fff);\n  border: 1px dashed var(--border-color, #e4e4e7);\n  border-radius: 12px;\n  text-align: center;\n  color: var(--text-secondary, #71717a);\n}\n.ddd-empty-communities i { font-size: 2.5rem; opacity: .4; }\n.ddd-empty-communities p { margin: 0; font-size: 0.95rem; color: var(--text-primary, #18181b); }\n.ddd-empty-communities span { font-size: 0.83rem; }\n\n/* ── Journey hint banner ── */\n.ddd-journey-hint {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 18px;\n  background: rgba(37,99,235,.06);\n  border: 1px solid rgba(37,99,235,.15);\n  border-radius: 10px;\n  font-size: 0.85rem;\n  color: var(--text-secondary, #71717a);\n  line-height: 1.5;\n}\n.ddd-journey-hint > i {\n  font-size: 1.1rem;\n  color: var(--accent, #2563eb);\n  flex-shrink: 0;\n}\n.ddd-journey-hint strong { color: var(--text-primary, #18181b); }\n\n/* ── Dark theme overrides for ddd-* ── */\n[data-theme=\"dark\"] .ddd-hero {\n  box-shadow: 0 2px 8px rgba(0,0,0,.3);\n}\n[data-theme=\"dark\"] .ddd-hero-icon-wrap {\n  background: linear-gradient(135deg, rgba(37,99,235,.2) 0%, rgba(99,102,241,.2) 100%);\n}\n[data-theme=\"dark\"] .ddd-stat {\n  background: var(--bg-secondary);\n}\n[data-theme=\"dark\"] .ddd-comm-card {\n  background: var(--bg-secondary);\n}\n[data-theme=\"dark\"] .ddd-comm-card:hover {\n  box-shadow: 0 6px 20px rgba(0,0,0,.4);\n}\n[data-theme=\"dark\"] .ddd-comm-card-footer {\n  border-top-color: var(--border-color);\n}\n[data-theme=\"dark\"] .ddd-empty-communities {\n  background: var(--bg-secondary);\n}\n[data-theme=\"dark\"] .ddd-journey-hint {\n  background: rgba(37,99,235,.1);\n  border-color: rgba(37,99,235,.25);\n}\n[data-theme=\"dark\"] .ddd-meta-chip.dna-status-ok      { background: rgba(16,185,129,.18);  color: #34d399; border-color: rgba(16,185,129,.3); }\n[data-theme=\"dark\"] .ddd-meta-chip.dna-status-pending { background: rgba(245,158,11,.18);  color: #fbbf24; border-color: rgba(245,158,11,.3); }\n[data-theme=\"dark\"] .ddd-meta-chip.dna-status-fail    { background: rgba(239,68,68,.18);   color: #f87171; border-color: rgba(239,68,68,.3); }\n[data-theme=\"dark\"] .ddd-status-dot.dna-status-ok      { background: #34d399; }\n[data-theme=\"dark\"] .ddd-status-dot.dna-status-pending { background: #fbbf24; }\n[data-theme=\"dark\"] .ddd-status-dot.dna-status-fail    { background: #f87171; }\n\n/* =============================================================================\n   9. DocumentNetworkGraph (.dng-*)\n   ============================================================================= */\n.dng-container {\n  display: flex; flex-direction: column; height: 100%;\n  background: var(--bg-secondary); border: 1px solid var(--border-color); border-radius: 12px; overflow: hidden;\n}\n.dng-toolbar {\n  padding: 12px 16px; border-bottom: 1px solid var(--border-color);\n  display: flex; align-items: center; justify-content: space-between;\n}\n.dng-control-group { display: flex; align-items: center; gap: 12px; font-size: 0.9rem; }\n.dng-slider { width: 140px; }\n\n.dng-layout { display: flex; flex: 1; overflow: hidden; position: relative; }\n.dng-graph-area { flex: 1; background: #f8fafc; position: relative; }\n.dng-sidebar-wrap {\n  width: 300px; border-left: 1px solid var(--border-color); background: #fff;\n  position: absolute; right: 0; top: 0; height: 100%; z-index: 10;\n  box-shadow: -4px 0 16px rgba(0,0,0,.05);\n}\n\n.dng-sidebar { display: flex; flex-direction: column; height: 100%; }\n.dng-sidebar-header {\n  padding: 16px; border-bottom: 1px solid var(--border-color);\n  display: flex; justify-content: space-between; align-items: center;\n}\n.dng-sidebar-header h4 { margin: 0; font-size: 1rem; color: var(--text-primary); }\n.dng-close-btn { background: none; border: none; cursor: pointer; color: var(--text-secondary); }\n\n.dng-node-provider { padding: 0 16px; margin: 12px 0 0 0; }\n.dng-provider-chip { font-size: 0.7rem; color: #fff; padding: 2px 8px; border-radius: 4px; font-weight: 600; }\n\n.dng-conn-label { margin: 16px 16px 8px; font-size: 0.8rem; color: var(--text-secondary); text-transform: uppercase; }\n.dng-conn-row {\n  padding: 8px 16px; border-bottom: 1px solid #f4f4f5; font-size: 0.9rem;\n  display: flex; justify-content: space-between; align-items: center;\n}\n.dng-shared-count { background: #e0e7ff; color: #3730a3; padding: 2px 6px; border-radius: 4px; font-size: 0.75rem; font-weight: 600; }\n\n.dng-edge-docs { padding: 16px; background: #f8fafc; border-bottom: 1px solid var(--border-color); margin: 0; font-size: 0.9rem; display: flex; flex-direction: column; align-items: center; gap: 8px; text-align: center; }\n.dng-edge-icon { color: var(--text-secondary); }\n.dng-shared-entities { padding: 16px; display: flex; flex-wrap: wrap; gap: 6px; overflow-y: auto; }\n.dng-entity-tag {\n  background: #fff; border: 1px solid var(--border-color); border-radius: 4px;\n  padding: 4px 8px; font-size: 0.8rem; cursor: pointer; color: var(--text-primary);\n  transition: all .2s;\n}\n.dng-entity-tag:hover { border-color: var(--accent); color: var(--accent); background: #eff6ff; }\n\n.dng-loading, .dng-empty-state {\n  display: flex; flex-direction: column; align-items: center; justify-content: center;\n  height: 100%; color: var(--text-secondary); gap: 12px;\n}\n.dng-spinner { width: 32px; height: 32px; border: 3px solid var(--border-color); border-top-color: var(--accent); border-radius: 50%; animation: spin 1s linear infinite; }\n.dng-empty-icon { font-size: 3rem; opacity: .4; }\n\n/* ── Consolidated Comparison Sidebar ─────────────────────────────────────── */\n.dng-sidebar-wide { width: 420px; }\n@media (max-width: 600px) { .dng-sidebar-wide { width: 100%; } }\n\n.dng-compare-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--bg-tertiary);\n}\n.dng-compare-placeholder {\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  font-style: italic;\n  padding: 16px;\n  background: var(--bg-secondary);\n  border: 1px dashed var(--border-color);\n  border-radius: 8px;\n}\n.dng-shared-graph-wrap {\n  position: relative;\n  background: var(--bg-secondary);\n}\n\n/* ── Enhanced Node Sidebar ───────────────────────────────────────────────── */\n.dng-sidebar-title-wrap {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n.dng-sidebar-source-icon { font-size: 0.9rem; color: var(--text-secondary); flex-shrink: 0; margin-top: 2px; }\n.dng-sidebar-title-wrap h4 { margin: 0; font-size: 0.95rem; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; word-break: break-word; line-height: 1.35; }\n\n/* Document metadata table */\n.dng-doc-meta {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.dng-meta-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 0.82rem;\n}\n.dng-meta-key {\n  color: var(--text-secondary);\n  font-weight: 600;\n  flex-shrink: 0;\n  min-width: 90px;\n}\n.dng-meta-val { color: var(--text-primary); }\n.dng-meta-status {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 99px;\n  text-transform: capitalize;\n}\n.dng-status-processed, .dng-status-completed, .dng-status-indexed {\n  background: rgba(16,185,129,.12); color: #15803d;\n}\n.dng-status-pending, .dng-status-queued, .dng-status-processing {\n  background: rgba(245,158,11,.12); color: #a16207;\n}\n.dng-status-failed, .dng-status-error {\n  background: rgba(239,68,68,.12); color: #b91c1c;\n}\n\n/* Description block inside node sidebar */\n.dng-doc-description {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-color);\n}\n.dng-section-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  margin: 0 0 6px 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.dng-doc-description p {\n  margin: 0;\n  font-size: 0.82rem;\n  color: var(--text-primary);\n  line-height: 1.55;\n}\n\n/* Connected documents list inside node sidebar */\n.dng-conn-list { overflow-y: auto; max-height: 180px; }\n.dng-conn-row {\n  padding: 8px 16px; border-bottom: 1px solid #f4f4f5; font-size: 0.85rem;\n  display: flex; justify-content: space-between; align-items: center; gap: 8px;\n}\n.dng-conn-name { flex: 1; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n/* \"Open Document\" action at the bottom of the sidebar */\n.dng-sidebar-actions {\n  padding: 12px 16px;\n  border-top: 1px solid var(--border-color);\n  margin-top: auto;\n}\n.dng-open-doc-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  padding: 7px 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-secondary);\n  color: var(--accent);\n  text-decoration: none;\n  transition: all .2s;\n  cursor: pointer;\n  font-weight: 500;\n}\n.dng-open-doc-btn:hover {\n  background: var(--accent);\n  color: #fff;\n  border-color: var(--accent);\n}\n\n/* =============================================================================\n   9b. DocumentNetworkGraph — New Features (.dng-*)\n   Toolbar enhancements, provider grouping legend, overlap matrix, latent connections\n   ============================================================================= */\n\n/* ── Enhanced Toolbar ────────────────────────────────────────────────────── */\n.dng-toolbar-enhanced {\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  padding: 10px 16px;\n  min-height: 56px;\n}\n.dng-toolbar-enhanced h3 {\n  margin: 0;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n.dng-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  flex: 1;\n  justify-content: flex-end;\n}\n\n/* ── Toggle Button Group ─────────────────────────────────────────────────── */\n.dng-toggle-group {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.dng-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  background: var(--bg-secondary, #fff);\n  color: var(--text-secondary, #71717a);\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all .2s;\n  white-space: nowrap;\n}\n.dng-toggle-btn:hover {\n  border-color: var(--accent, #2563eb);\n  color: var(--accent, #2563eb);\n  background: rgba(37,99,235,.05);\n}\n.dng-toggle-btn.active {\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border-color: var(--accent, #2563eb);\n}\n.dng-toggle-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 99px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  background: rgba(0,0,0,.12);\n  color: inherit;\n  line-height: 1;\n}\n.dng-toggle-btn.active .dng-toggle-badge {\n  background: rgba(255,255,255,.25);\n  color: #fff;\n}\n.dng-toggle-badge-active {\n  background: rgba(255,255,255,.25) !important;\n}\n\n/* ── Provider Grouping Legend ────────────────────────────────────────────── */\n.dng-provider-legend {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 16px;\n  background: var(--bg-tertiary, #fafafa);\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  flex-wrap: wrap;\n  font-size: 0.8rem;\n}\n.dng-provider-legend-label {\n  color: var(--text-secondary, #71717a);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.dng-provider-legend-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 8px;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 99px;\n  font-size: 0.75rem;\n  color: var(--text-primary, #18181b);\n  font-weight: 500;\n}\n.dng-provider-legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.dng-provider-legend-hint {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: var(--text-secondary, #71717a);\n  font-size: 0.75rem;\n  margin-left: auto;\n  font-style: italic;\n}\n\n/* ── Provider Overlap Matrix Wrapper ─────────────────────────────────────── */\n.dng-overlap-wrap {\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  background: var(--bg-secondary, #fff);\n  max-height: 300px;\n  overflow-y: auto;\n  flex-shrink: 0;\n}\n.dng-overlap-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background: var(--bg-tertiary, #fafafa);\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-primary, #18181b);\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n/* ── Provider Overlap Matrix Content ─────────────────────────────────────── */\n.dng-overlap-matrix {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* Provider stat strip */\n.dng-overlap-provider-strip {\n  display: flex;\n  gap: 0;\n  flex-wrap: wrap;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n}\n.dng-overlap-provider-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-right: 1px solid var(--border-color, #e4e4e7);\n  min-width: 140px;\n  flex: 1;\n}\n.dng-overlap-provider-chip:last-child {\n  border-right: none;\n}\n.dng-overlap-provider-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.dng-overlap-provider-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n.dng-overlap-provider-name {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-primary, #18181b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dng-overlap-provider-stats {\n  font-size: 0.7rem;\n  color: var(--text-secondary, #71717a);\n}\n\n/* Cross-provider pairs section */\n.dng-overlap-pairs-section {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.dng-overlap-pairs-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-secondary, #71717a);\n  text-transform: uppercase;\n  letter-spacing: .4px;\n}\n.dng-overlap-total-badge {\n  font-size: 0.72rem;\n  background: var(--bg-tertiary, #f4f4f5);\n  color: var(--text-secondary, #71717a);\n  padding: 2px 8px;\n  border-radius: 99px;\n  border: 1px solid var(--border-color, #e4e4e7);\n  font-weight: 500;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n/* Individual pair rows */\n.dng-overlap-pair-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.dng-overlap-pair-labels {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 260px;\n  flex-shrink: 0;\n}\n.dng-overlap-pair-pill {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #fff;\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dng-overlap-arrow-icon {\n  color: var(--text-secondary, #71717a);\n  font-size: 0.7rem;\n  flex-shrink: 0;\n}\n.dng-overlap-bar-track {\n  flex: 1;\n  height: 6px;\n  background: var(--bg-tertiary, #e4e4e7);\n  border-radius: 3px;\n  overflow: hidden;\n}\n.dng-overlap-bar-fill {\n  height: 100%;\n  background: var(--accent, #2563eb);\n  border-radius: 3px;\n  transition: width .4s ease;\n  min-width: 4px;\n}\n.dng-overlap-pair-count {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--text-primary, #18181b);\n  min-width: 24px;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n/* Redundancy insight banner */\n.dng-overlap-insight {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 16px;\n  background: rgba(245,158,11,.08);\n  border-top: 1px solid rgba(245,158,11,.2);\n  font-size: 0.8rem;\n  color: var(--text-secondary, #71717a);\n  line-height: 1.5;\n}\n.dng-overlap-insight strong {\n  color: var(--text-primary, #18181b);\n}\n.dng-overlap-insight-icon {\n  color: #f59e0b;\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n\n/* ── Latent Connections Section (in NodeDetail sidebar) ──────────────────── */\n.dng-latent-section {\n  border-top: 1px solid var(--border-color, #e4e4e7);\n  margin-top: auto;\n}\n.dng-latent-toggle {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  width: 100%;\n  padding: 10px 16px;\n  background: var(--bg-tertiary, #fafafa);\n  border: none;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-secondary, #71717a);\n  text-align: left;\n  transition: background .15s, color .15s;\n}\n.dng-latent-toggle:hover {\n  background: var(--bg-secondary, #fff);\n  color: var(--text-primary, #18181b);\n}\n.dng-latent-chevron {\n  font-size: 0.65rem;\n  flex-shrink: 0;\n  transition: transform .2s;\n}\n.dng-latent-icon {\n  color: var(--accent, #2563eb);\n  flex-shrink: 0;\n}\n.dng-latent-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 99px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  background: var(--bg-secondary, #e4e4e7);\n  color: var(--text-secondary, #71717a);\n  border: 1px solid var(--border-color, #e4e4e7);\n  margin-left: auto;\n  line-height: 1;\n}\n.dng-latent-body {\n  background: var(--bg-secondary, #fff);\n  border-top: 1px solid var(--border-color, #e4e4e7);\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.dng-latent-empty {\n  padding: 12px 16px;\n  font-size: 0.82rem;\n  color: var(--text-secondary, #71717a);\n  font-style: italic;\n}\n.dng-latent-hint {\n  padding: 8px 16px;\n  font-size: 0.75rem;\n  color: var(--text-secondary, #71717a);\n  margin: 0;\n  border-bottom: 1px solid var(--border-color, #f4f4f5);\n  background: rgba(37,99,235,.04);\n  line-height: 1.4;\n}\n.dng-latent-item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 9px 16px;\n  border-bottom: 1px solid var(--border-color, #f4f4f5);\n  transition: background .15s;\n}\n.dng-latent-item:last-child {\n  border-bottom: none;\n}\n.dng-latent-item:hover {\n  background: var(--bg-tertiary, #fafafa);\n}\n.dng-latent-item-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n.dng-latent-item-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n.dng-latent-item-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n.dng-latent-item-name {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-primary, #18181b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n}\n.dng-latent-item-provider {\n  font-size: 0.68rem;\n  color: var(--text-secondary, #71717a);\n  display: block;\n}\n.dng-latent-item-right {\n  flex-shrink: 0;\n  text-align: right;\n}\n.dng-latent-item-via {\n  font-size: 0.72rem;\n  color: var(--text-secondary, #71717a);\n  line-height: 1.4;\n}\n.dng-latent-item-via strong {\n  color: var(--accent, #2563eb);\n  font-weight: 600;\n}\n.dng-latent-more {\n  color: var(--text-secondary, #71717a);\n  font-size: 0.68rem;\n}\n\n/* ── Dark mode overrides for new elements ────────────────────────────────── */\n[data-theme=\"dark\"] .dng-toggle-btn {\n  background: var(--bg-secondary);\n  border-color: var(--border-color);\n}\n[data-theme=\"dark\"] .dng-toggle-btn:hover {\n  background: rgba(37,99,235,.1);\n}\n[data-theme=\"dark\"] .dng-toggle-btn.active {\n  background: var(--accent);\n}\n[data-theme=\"dark\"] .dng-provider-legend {\n  background: var(--bg-primary);\n}\n[data-theme=\"dark\"] .dng-provider-legend-chip {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n[data-theme=\"dark\"] .dng-overlap-wrap {\n  background: var(--bg-secondary);\n}\n[data-theme=\"dark\"] .dng-overlap-header {\n  background: var(--bg-tertiary);\n}\n[data-theme=\"dark\"] .dng-overlap-provider-chip {\n  border-right-color: var(--border-color);\n}\n[data-theme=\"dark\"] .dng-overlap-bar-track {\n  background: var(--bg-tertiary);\n}\n[data-theme=\"dark\"] .dng-overlap-insight {\n  background: rgba(245,158,11,.1);\n  border-top-color: rgba(245,158,11,.25);\n}\n[data-theme=\"dark\"] .dng-overlap-insight strong {\n  color: #fbbf24;\n}\n[data-theme=\"dark\"] .dng-overlap-total-badge {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n[data-theme=\"dark\"] .dng-latent-toggle {\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n}\n[data-theme=\"dark\"] .dng-latent-toggle:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n[data-theme=\"dark\"] .dng-latent-body {\n  background: var(--bg-secondary);\n}\n[data-theme=\"dark\"] .dng-latent-hint {\n  background: rgba(37,99,235,.08);\n  border-bottom-color: var(--border-color);\n}\n[data-theme=\"dark\"] .dng-latent-item:hover {\n  background: var(--bg-tertiary);\n}\n[data-theme=\"dark\"] .dng-latent-item {\n  border-bottom-color: var(--border-color);\n}\n[data-theme=\"dark\"] .dng-latent-count-badge {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n[data-theme=\"dark\"] .dng-latent-item-via strong {\n  color: #60a5fa;\n}\n\n/* =============================================================================\n   10. KnowledgeTimelineChart (.ktc-*)\n   ============================================================================= */\n.ktc-container {\n  display: flex; flex-direction: column; height: 100%;\n  background: var(--bg-secondary); border: 1px solid var(--border-color); border-radius: 12px; overflow: hidden;\n}\n.ktc-toolbar {\n  padding: 12px 16px; border-bottom: 1px solid var(--border-color);\n  display: flex; justify-content: space-between; align-items: center;\n}\n.ktc-actions { display: flex; gap: 4px; background: var(--bg-tertiary); padding: 2px; border-radius: 6px; }\n.ktc-view-btn {\n  border: none; background: none; padding: 6px 10px; border-radius: 4px; color: var(--text-secondary); cursor: pointer;\n}\n.ktc-view-btn.active { background: #fff; color: var(--text-primary); shadow: 0 1px 2px rgba(0,0,0,.1); }\n\n.ktc-summary {\n  display: flex; gap: 24px; padding: 16px 24px; background: #fafafa; border-bottom: 1px solid var(--border-color); flex-wrap: wrap;\n}\n.ktc-stat { display: flex; flex-direction: column; }\n.ktc-stat-value { font-size: 1.5rem; font-weight: 700; color: var(--text-primary); line-height: 1; }\n.ktc-stat-label { font-size: 0.75rem; color: var(--text-secondary); text-transform: uppercase; margin-top: 4px; }\n.ktc-major-notice {\n  margin-left: auto; background: #fffbeb; color: #92400e; padding: 8px 12px; border-radius: 6px;\n  border: 1px solid #fcd34d; font-size: 0.85rem; display: flex; align-items: center; gap: 8px;\n}\n\n.ktc-chart-wrap { flex: 1; padding: 16px; position: relative; min-height: 300px; }\n\n/* Timeline Table */\n.ktc-table-wrap { flex: 1; overflow: auto; }\n.ktc-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }\n.ktc-table th {\n  text-align: left; padding: 10px 16px; background: #f4f4f5; color: var(--text-secondary);\n  font-weight: 600; border-bottom: 1px solid var(--border-color); position: sticky; top: 0;\n}\n.ktc-sortable { cursor: pointer; }\n.ktc-sortable:hover { background: #e4e4e7; }\n.ktc-sort-icon { margin-left: 6px; font-size: 0.75rem; }\n.ktc-table-row { border-bottom: 1px solid #f4f4f5; cursor: pointer; }\n.ktc-table-row:hover { background: #f8fafc; }\n.ktc-table td { padding: 10px 16px; color: var(--text-primary); }\n.ktc-file-name { font-weight: 500; }\n.ktc-dominant-chip { font-size: 0.75rem; color: #fff; padding: 2px 8px; border-radius: 99px; white-space: nowrap; }\n\n/* =============================================================================\n   11. DocumentBridgePanel (.dbp-*)\n   ============================================================================= */\n.dbp-container {\n  display: flex; flex-direction: column; height: 100%;\n  background: var(--bg-secondary); border: 1px solid var(--border-color); border-radius: 12px; overflow: hidden;\n}\n.dbp-header { padding: 16px 20px; border-bottom: 1px solid var(--border-color); }\n.dbp-subtitle { margin: 4px 0 0 0; color: var(--text-secondary); font-size: 0.9rem; }\n\n.dbp-selectors {\n  padding: 20px; background: #fafafa; border-bottom: 1px solid var(--border-color);\n  display: flex; align-items: flex-end; gap: 16px; flex-wrap: wrap;\n}\n.dbp-selector-wrap { flex: 1; display: flex; flex-direction: column; gap: 6px; min-width: 200px; }\n.dbp-selector-label { font-size: 0.85rem; font-weight: 600; color: var(--text-secondary); }\n.dbp-selector { padding: 10px; border: 1px solid var(--border-color); border-radius: 6px; font-size: 0.9rem; background: #fff; }\n.dbp-vs-divider { display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 50%; background: #e4e4e7; color: #71717a; font-size: 1.2rem; flex-shrink: 0; margin-bottom: 2px; }\n.dbp-find-btn { margin-bottom: 2px; padding: 10px 20px; min-width: 140px; }\n\n.dbp-stats-row {\n  display: flex; justify-content: space-around; align-items: center; padding: 20px;\n  background: #fff; border-bottom: 1px solid #f4f4f5;\n}\n.dbp-stat { display: flex; flex-direction: column; align-items: center; }\n.dbp-stat-value { font-size: 1.8rem; font-weight: 700; color: var(--text-primary); }\n.dbp-stat-label { font-size: 0.8rem; color: var(--text-secondary); text-transform: uppercase; }\n.dbp-doc-names { font-size: 0.9rem; color: var(--text-secondary); display: flex; align-items: center; gap: 10px; }\n.dbp-merge-icon { color: var(--accent); }\n\n.dbp-graph-wrap { flex: 1; position: relative; border-bottom: 1px solid var(--border-color); display: flex; flex-direction: column; }\n.dbp-graph-title { position: absolute; top: 12px; left: 16px; margin: 0; font-size: 0.85rem; color: var(--text-secondary); z-index: 5; background: rgba(255,255,255,0.8); padding: 4px 8px; border-radius: 4px; }\n.dbp-graph-canvas { flex: 1; min-height: 300px; background: #fff; }\n\n.dbp-entity-list { height: 200px; overflow-y: auto; padding: 16px; background: #fafafa; }\n.dbp-entity-list h4 { margin: 0 0 12px 0; font-size: 0.9rem; color: var(--text-secondary); }\n.dbp-entity-row {\n  display: flex; align-items: center; gap: 10px; padding: 8px 12px; background: #fff;\n  border: 1px solid var(--border-color); border-radius: 6px; margin-bottom: 8px;\n}\n.dbp-entity-chip { font-size: 0.65rem; color: #fff; padding: 2px 6px; border-radius: 4px; font-weight: 700; width: 70px; text-align: center; }\n.dbp-entity-name { border: none; background: none; font-weight: 600; color: var(--text-primary); cursor: pointer; text-align: left; }\n.dbp-entity-name:hover { color: var(--accent); text-decoration: underline; }\n.dbp-entity-desc { font-size: 0.8rem; color: var(--text-secondary); margin-left: auto; font-style: italic; }\n\n.dbp-no-common { padding: 48px; text-align: center; color: var(--text-secondary); }\n.dbp-empty-icon { font-size: 3rem; margin-bottom: 16px; opacity: .4; }\n.dbp-hint { font-size: 0.9rem; background: #fff7ed; color: #c2410c; padding: 8px 16px; border-radius: 6px; display: inline-block; margin-top: 16px; }\n.dbp-edge-tooltip {\n  position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%);\n  background: var(--bg-secondary); padding: 8px 12px; border: 1px solid var(--border-color); border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0,0,0,.1); font-size: 0.8rem; max-width: 300px; z-index: 10;\n  color: var(--text-primary);\n}\n\n/* ── Document Card Compare View ─────────────────────────────────────────── */\n.dbp-card-compare {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: stretch;\n  gap: 0;\n  padding: 20px;\n  background: var(--bg-tertiary, #fafafa);\n  border-bottom: 1px solid var(--border-color);\n}\n@media (max-width: 760px) {\n  .dbp-card-compare {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto auto;\n  }\n  .dbp-card-compare-divider {\n    flex-direction: row !important;\n    padding: 8px 0 !important;\n  }\n  .dbp-card-compare-line { flex: 1; height: 1px !important; width: auto !important; }\n}\n\n/* Individual document info card */\n.dbp-doc-card {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 10px;\n  border-top: 3px solid transparent;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n  box-shadow: 0 2px 8px rgba(0,0,0,.06);\n}\n.dbp-doc-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.dbp-doc-card-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: .6px;\n}\n.dbp-doc-card-icon { font-size: 1.1rem; opacity: .6; }\n.dbp-doc-card-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  word-break: break-word;\n  line-height: 1.35;\n}\n.dbp-doc-card-desc {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  line-height: 1.55;\n  margin: 0;\n  font-style: italic;\n}\n.dbp-doc-card-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-top: auto;\n}\n.dbp-doc-card-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n.dbp-doc-card-meta-icon {\n  font-size: 0.7rem;\n  width: 14px;\n  text-align: center;\n  flex-shrink: 0;\n  opacity: .65;\n}\n.dbp-doc-card-status {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 1px 8px;\n  border-radius: 99px;\n  text-transform: capitalize;\n}\n.dbp-doc-card-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.78rem;\n  color: var(--accent, #2563eb);\n  text-decoration: none;\n  padding: 5px 0;\n  font-weight: 500;\n  transition: opacity .2s;\n  border-top: 1px solid var(--border-color);\n  padding-top: 10px;\n  margin-top: 4px;\n}\n.dbp-doc-card-link:hover { opacity: .7; }\n\n/* Divider between the two cards */\n.dbp-card-compare-divider {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 16px;\n}\n.dbp-card-compare-line {\n  width: 1px;\n  flex: 1;\n  background: var(--border-color, #e4e4e7);\n  min-height: 30px;\n}\n.dbp-card-compare-badge {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  background: var(--bg-secondary, #fff);\n  border: 2px solid var(--accent, #2563eb);\n  border-radius: 50%;\n  width: 56px;\n  height: 56px;\n  justify-content: center;\n  color: var(--accent, #2563eb);\n  box-shadow: 0 2px 8px rgba(37,99,235,.15);\n  flex-shrink: 0;\n}\n.dbp-card-compare-badge i { font-size: 0.8rem; }\n.dbp-card-compare-badge span { font-size: 1.1rem; font-weight: 700; line-height: 1; }\n.dbp-card-compare-badge small { font-size: 0.6rem; text-transform: uppercase; letter-spacing: .4px; font-weight: 600; }\n\n/* =============================================================================\n   12. EntityContextWindow  (.ecw-*)\n   ============================================================================= */\n\n/* Overlay backdrop */\n.ecw-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  backdrop-filter: blur(2px);\n}\n\n/* Modal panel */\n.ecw-modal {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 14px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 760px;\n  height: 90vh;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Header */\n.ecw-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n}\n.ecw-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n.ecw-type-chip {\n  display: inline-block;\n  padding: 3px 9px;\n  border-radius: 5px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n  flex-shrink: 0;\n  text-transform: uppercase;\n  letter-spacing: .4px;\n}\n.ecw-title {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary, #18181b);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ecw-close-btn {\n  background: none;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  padding: 6px 10px;\n  cursor: pointer;\n  color: var(--text-secondary, #71717a);\n  font-size: 0.9rem;\n  flex-shrink: 0;\n  transition: all .2s;\n}\n.ecw-close-btn:hover { background: var(--danger, #ef4444); color: #fff; border-color: var(--danger, #ef4444); }\n\n/* Loading / Error */\n.ecw-loading, .ecw-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 60px 40px;\n  color: var(--text-secondary, #71717a);\n  flex: 1;\n}\n.ecw-spinner {\n  width: 36px; height: 36px;\n  border: 3px solid var(--border-color, #e4e4e7);\n  border-top-color: var(--accent, #2563eb);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n.ecw-error { color: #dc2626; }\n.ecw-error i { font-size: 2rem; opacity: .7; }\n\n/* Stats banner */\n.ecw-stats-bar {\n  display: flex;\n  gap: 0;\n  background: var(--bg-tertiary, #fafafa);\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n  overflow-x: auto;\n}\n.ecw-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 12px 20px;\n  border-right: 1px solid var(--border-color, #e4e4e7);\n  min-width: 80px;\n  flex-shrink: 0;\n}\n.ecw-stat:last-child { border-right: none; }\n.ecw-stat-value {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: var(--text-primary, #18181b);\n  line-height: 1;\n}\n.ecw-stat-date { font-size: 0.85rem; }\n.ecw-stat-label {\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  color: var(--text-secondary, #71717a);\n  margin-top: 4px;\n  white-space: nowrap;\n}\n\n/* Tabs */\n.ecw-tabs {\n  display: flex;\n  border-bottom: 2px solid var(--border-color, #e4e4e7);\n  background: var(--bg-secondary, #fff);\n  flex-shrink: 0;\n  overflow-x: auto;\n}\n.ecw-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 18px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary, #71717a);\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  font-size: 0.85rem;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: color .2s, border-color .2s;\n  margin-bottom: -2px;\n}\n.ecw-tab:hover  { color: var(--text-primary, #18181b); }\n.ecw-tab.active { color: var(--accent, #2563eb); border-bottom-color: var(--accent, #2563eb); font-weight: 600; }\n.ecw-tab-count {\n  background: var(--bg-tertiary, #f4f4f5);\n  padding: 1px 6px;\n  border-radius: 99px;\n  font-size: 0.7rem;\n  min-width: 16px;\n  text-align: center;\n}\n\n/* Body / scroll area */\n.ecw-body {\n  flex: 1;\n  overflow-y: auto;\n  background: var(--bg-primary, #f4f4f5);\n}\n\n/* Shared section wrapper */\n.ecw-section { padding: 16px; display: flex; flex-direction: column; gap: 12px; }\n.ecw-empty {\n  text-align: center;\n  padding: 32px;\n  color: var(--text-secondary, #71717a);\n  font-style: italic;\n  font-size: 0.9rem;\n}\n\n/* Shared chip */\n.ecw-chip {\n  display: inline-block;\n  padding: 2px 7px;\n  border-radius: 4px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n  flex-shrink: 0;\n  text-transform: uppercase;\n}\n\n/* ── Back button & breadcrumb ── */\n.ecw-back-btn {\n  background: none;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  padding: 5px 10px;\n  cursor: pointer;\n  color: var(--text-secondary, #71717a);\n  font-size: 0.85rem;\n  flex-shrink: 0;\n  transition: all .2s;\n}\n.ecw-back-btn:hover { background: var(--bg-tertiary, #f4f4f5); color: var(--text-primary, #18181b); }\n\n.ecw-breadcrumb-depth {\n  font-size: 0.72rem;\n  color: var(--text-secondary, #71717a);\n  background: var(--bg-tertiary, #f4f4f5);\n  padding: 3px 8px;\n  border-radius: 99px;\n  border: 1px solid var(--border-color, #e4e4e7);\n  white-space: nowrap;\n  flex-shrink: 0;\n  cursor: help;\n}\n\n/* ── Stats actions area (pin button) ── */\n.ecw-stats-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  padding: 0 14px;\n  border-left: 1px solid var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n}\n.ecw-pin-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 13px;\n  background: none;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  cursor: pointer;\n  color: var(--text-secondary, #71717a);\n  font-size: 0.8rem;\n  font-weight: 500;\n  transition: all .2s;\n  white-space: nowrap;\n}\n.ecw-pin-btn:hover {\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border-color: var(--accent, #2563eb);\n}\n.ecw-pin-btn i { font-size: 0.75rem; }\n\n/* ── Clickable entity pill (Connections tab) ── */\n.ecw-entity-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  padding: 3px 8px 3px 2px;\n  cursor: pointer;\n  text-align: left;\n  flex: 1;\n  min-width: 0;\n  transition: background .15s, border-color .15s;\n}\n.ecw-entity-pill:hover {\n  background: var(--bg-tertiary, #f4f4f5);\n  border-color: var(--border-color, #e4e4e7);\n}\n.ecw-entity-pill-name {\n  flex: 1;\n  font-size: 0.85rem;\n  color: var(--text-primary, #18181b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ecw-entity-pill-arrow {\n  font-size: 0.65rem;\n  color: var(--text-secondary, #71717a);\n  opacity: 0;\n  transition: opacity .15s;\n  flex-shrink: 0;\n}\n.ecw-entity-pill:hover .ecw-entity-pill-arrow { opacity: 1; }\n\n/* ── Connections tab ── */\n.ecw-conn-group { display: flex; flex-direction: column; gap: 6px; }\n.ecw-section-title {\n  margin: 0 0 6px 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: .5px;\n  color: var(--text-secondary, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.ecw-rel-group {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  overflow: hidden;\n}\n.ecw-rel-group-toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 14px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  transition: background .15s;\n}\n.ecw-rel-group-toggle:hover { background: var(--bg-tertiary, #f4f4f5); }\n.ecw-rel-direction-arrow {\n  font-size: 0.9rem;\n  color: var(--text-secondary, #71717a);\n  flex-shrink: 0;\n}\n.ecw-rel-type-label {\n  flex: 1;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-primary, #18181b);\n  text-transform: uppercase;\n  letter-spacing: .3px;\n}\n.ecw-rel-count-badge {\n  background: var(--bg-tertiary, #e4e4e7);\n  color: var(--text-secondary, #71717a);\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 1px 7px;\n  border-radius: 99px;\n  flex-shrink: 0;\n}\n.ecw-rel-chevron { font-size: 0.7rem; color: var(--text-secondary, #71717a); flex-shrink: 0; }\n\n.ecw-rel-entity-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border-top: 1px solid var(--border-color, #e4e4e7);\n  max-height: 220px;\n  overflow-y: auto;\n}\n.ecw-rel-entity-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 14px;\n  border-bottom: 1px solid var(--border-color, #f4f4f5);\n}\n.ecw-rel-entity-row:last-child { border-bottom: none; }\n.ecw-rel-entity-name {\n  flex: 1;\n  font-size: 0.85rem;\n  color: var(--text-primary, #18181b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ecw-rel-context {\n  color: var(--text-secondary, #71717a);\n  font-size: 0.75rem;\n  cursor: help;\n  flex-shrink: 0;\n}\n\n/* ── Evidence tab ── */\n.ecw-evidence-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  padding: 10px 14px;\n}\n.ecw-evidence-icon { color: #ef4444; font-size: 1rem; flex-shrink: 0; }\n.ecw-evidence-body { flex: 1; display: flex; flex-direction: column; gap: 2px; min-width: 0; }\n.ecw-evidence-name {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-primary, #18181b);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ecw-evidence-link {\n  color: var(--accent, #2563eb);\n  text-decoration: none;\n}\n.ecw-evidence-link:hover { text-decoration: underline; }\n.ecw-evidence-type {\n  font-size: 0.72rem;\n  color: var(--text-secondary, #71717a);\n  text-transform: uppercase;\n  letter-spacing: .4px;\n}\n.ecw-evidence-connections {\n  font-size: 0.78rem;\n  color: var(--text-secondary, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n.ecw-evidence-row--clickable {\n  cursor: pointer;\n  transition: background .15s, border-color .15s, box-shadow .15s;\n}\n.ecw-evidence-row--clickable:hover {\n  background: var(--bg-tertiary, #f8fafc);\n  border-color: var(--accent, #2563eb);\n  box-shadow: 0 2px 8px rgba(37,99,235,.1);\n}\n.ecw-evidence-row--clickable:hover .ecw-evidence-name {\n  color: var(--accent, #2563eb);\n}\n.ecw-evidence-open-icon {\n  font-size: 0.7rem;\n  color: var(--text-secondary, #71717a);\n  flex-shrink: 0;\n  opacity: 0;\n  transition: opacity .15s;\n}\n.ecw-evidence-row--clickable:hover .ecw-evidence-open-icon { opacity: 1; }\n\n/* ── Similar tab ── */\n.ecw-similar-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  padding: 9px 14px;\n}\n.ecw-similar-name {\n  flex: 1;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text-primary, #18181b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ecw-similar-score-wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.ecw-similar-bar {\n  width: 64px;\n  height: 5px;\n  background: var(--bg-tertiary, #e4e4e7);\n  border-radius: 3px;\n  overflow: hidden;\n}\n.ecw-similar-bar-fill {\n  height: 100%;\n  background: var(--accent, #2563eb);\n  border-radius: 3px;\n  transition: width .4s ease;\n}\n.ecw-similar-pct {\n  font-size: 0.75rem;\n  color: var(--text-secondary, #71717a);\n  min-width: 30px;\n  text-align: right;\n}\n.ecw-similar-shared {\n  font-size: 0.75rem;\n  color: var(--text-secondary, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n.ecw-similar-row--clickable {\n  cursor: pointer;\n  transition: background .15s, border-color .15s;\n}\n.ecw-similar-row--clickable:hover {\n  background: var(--bg-tertiary, #f8fafc);\n  border-color: var(--accent, #2563eb);\n}\n.ecw-similar-row--clickable:hover .ecw-similar-name {\n  color: var(--accent, #2563eb);\n}\n.ecw-similar-nav-icon {\n  font-size: 0.65rem;\n  color: var(--text-secondary, #71717a);\n  flex-shrink: 0;\n  opacity: 0;\n  transition: opacity .15s;\n}\n.ecw-similar-row--clickable:hover .ecw-similar-nav-icon { opacity: 1; }\n\n/* ── Properties tab ── */\n.ecw-props-table {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  overflow: hidden;\n}\n.ecw-props-extra { margin-top: 10px; }\n.ecw-prop-row {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  padding: 8px 14px;\n  border-bottom: 1px solid var(--border-color, #f4f4f5);\n  font-size: 0.85rem;\n}\n.ecw-prop-row:last-child { border-bottom: none; }\n.ecw-prop-key {\n  color: var(--text-secondary, #71717a);\n  font-weight: 600;\n  min-width: 100px;\n  flex-shrink: 0;\n}\n.ecw-prop-val {\n  color: var(--text-primary, #18181b);\n  flex: 1;\n  word-break: break-all;\n}\n.ecw-prop-mono {\n  font-family: ui-monospace, 'Cascadia Code', monospace;\n  font-size: 0.78rem;\n  color: var(--text-secondary, #71717a);\n}\n\n/* ── Property value renderer helpers (.ecw-prop-*) ── */\n\n/* Null / empty placeholder */\n.ecw-prop-null {\n  color: var(--text-secondary, #71717a);\n  font-style: italic;\n  opacity: 0.65;\n}\n\n/* Boolean badge */\n.ecw-prop-bool {\n  display: inline-block;\n  padding: 1px 8px;\n  border-radius: 4px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.ecw-prop-bool-yes { background: rgba(16,185,129,0.15); color: #15803d; }\n.ecw-prop-bool-no  { background: rgba(148,163,184,0.2);  color: #64748b; }\n\n/* Array of primitives — pill list */\n.ecw-prop-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  flex: 1;\n}\n.ecw-prop-tag {\n  display: inline-block;\n  padding: 2px 7px;\n  background: var(--bg-tertiary, #f4f4f5);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 4px;\n  font-size: 0.75rem;\n  color: var(--text-primary, #18181b);\n}\n\n/* Flat object — nested key-value sub-table */\n.ecw-prop-sub-table {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  background: var(--bg-tertiary, #f4f4f5);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 5px;\n  padding: 6px 8px;\n}\n.ecw-prop-sub-row {\n  display: flex;\n  gap: 6px;\n  font-size: 0.78rem;\n}\n.ecw-prop-sub-key {\n  color: var(--text-secondary, #71717a);\n  font-weight: 600;\n  min-width: 80px;\n  flex-shrink: 0;\n}\n.ecw-prop-sub-val {\n  color: var(--text-primary, #18181b);\n  word-break: break-word;\n  flex: 1;\n}\n\n/* Complex / nested object — formatted JSON pre block */\n.ecw-prop-json {\n  flex: 1;\n  margin: 0;\n  padding: 8px 10px;\n  background: var(--bg-tertiary, #f4f4f5);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 5px;\n  font-family: ui-monospace, 'Cascadia Code', monospace;\n  font-size: 0.72rem;\n  color: var(--text-secondary, #71717a);\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow-x: auto;\n  line-height: 1.55;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n/* Also fix the prop-row alignment for complex values */\n.ecw-prop-row {\n  align-items: flex-start;\n}\n.ecw-prop-key {\n  padding-top: 2px;\n}\n\n/* ── Deep Analysis tab (.ecw-da-*) ──────────────────────────────────────────── */\n\n.ecw-da-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 48px 24px;\n  text-align: center;\n  color: var(--text-secondary, #71717a);\n}\n.ecw-da-empty i {\n  font-size: 3rem;\n  color: var(--accent, #2563eb);\n  opacity: 0.4;\n}\n.ecw-da-empty h4 {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--text-primary, #18181b);\n  font-weight: 700;\n}\n.ecw-da-empty p {\n  margin: 0;\n  font-size: 0.88rem;\n  max-width: 300px;\n  line-height: 1.6;\n}\n.ecw-da-generate-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 22px;\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s, transform 0.12s;\n}\n.ecw-da-generate-btn:hover { opacity: 0.87; transform: translateY(-1px); }\n\n.ecw-da-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ecw-da-overview {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  padding: 14px 16px;\n}\n.ecw-da-overview p {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.65;\n  color: var(--text-primary, #18181b);\n  font-style: italic;\n}\n\n.ecw-da-section {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 8px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.ecw-da-section-title {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.ecw-da-section-title i { color: var(--accent, #2563eb); }\n\n.ecw-da-table {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  overflow: hidden;\n}\n.ecw-da-row {\n  display: flex;\n  gap: 10px;\n  padding: 7px 10px;\n  border-bottom: 1px solid var(--border-color, #f4f4f5);\n  font-size: 0.82rem;\n  align-items: flex-start;\n}\n.ecw-da-row:last-child { border-bottom: none; }\n.ecw-da-key {\n  font-weight: 600;\n  color: var(--text-secondary, #71717a);\n  min-width: 110px;\n  flex-shrink: 0;\n  padding-top: 1px;\n}\n.ecw-da-val {\n  color: var(--text-primary, #18181b);\n  flex: 1;\n  line-height: 1.5;\n  word-break: break-word;\n}\n\n.ecw-da-text {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--text-primary, #18181b);\n  line-height: 1.55;\n}\n.ecw-da-subdued { color: var(--text-secondary, #71717a); font-size: 0.8rem; }\n\n.ecw-da-list-group { display: flex; flex-direction: column; gap: 6px; }\n.ecw-da-list-label {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--text-secondary, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.ecw-da-label-signal     { color: #0891b2; }\n.ecw-da-label-opportunity{ color: #7c3aed; }\n.ecw-da-label-risk       { color: #b91c1c; }\n\n.ecw-da-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.ecw-da-list-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 0.83rem;\n  color: var(--text-primary, #18181b);\n  line-height: 1.5;\n  padding: 6px 10px;\n  border-radius: 5px;\n}\n.ecw-da-list-item::before {\n  content: '';\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n  margin-top: 5px;\n}\n.ecw-da-relationship        { background: rgba(99, 102, 241, 0.06); }\n.ecw-da-relationship::before{ background: #6366f1; }\n.ecw-da-signal              { background: rgba(8, 145, 178, 0.06); }\n.ecw-da-signal::before      { background: #0891b2; }\n.ecw-da-opportunity         { background: rgba(124, 58, 237, 0.06); }\n.ecw-da-opportunity::before { background: #7c3aed; }\n.ecw-da-risk                { background: rgba(185, 28, 28, 0.06); }\n.ecw-da-risk::before        { background: #b91c1c; }\n.ecw-da-flag                { background: rgba(239, 68, 68, 0.06); }\n.ecw-da-flag::before        { background: #ef4444; }\n\n.ecw-da-rec-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  counter-reset: rec-counter;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.ecw-da-rec-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 0.85rem;\n  color: var(--text-primary, #18181b);\n  line-height: 1.55;\n  padding: 8px 10px;\n  background: rgba(37, 99, 235, 0.05);\n  border: 1px solid rgba(37, 99, 235, 0.12);\n  border-radius: 6px;\n  counter-increment: rec-counter;\n}\n.ecw-da-rec-item::before {\n  content: counter(rec-counter);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border-radius: 50%;\n  font-size: 0.68rem;\n  font-weight: 700;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.ecw-da-flags-section {\n  border-color: rgba(239, 68, 68, 0.3);\n  background: rgba(239, 68, 68, 0.03);\n}\n.ecw-da-flags-title       { color: #b91c1c !important; }\n.ecw-da-flags-title i     { color: #ef4444 !important; }\n\n.ecw-da-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-color, #e4e4e7);\n  margin-top: 4px;\n}\n.ecw-da-footer-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.ecw-da-regen-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  background: none;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  font-size: 0.8rem;\n  color: var(--text-secondary, #71717a);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.ecw-da-regen-btn:hover:not(:disabled) {\n  border-color: var(--accent, #2563eb);\n  color: var(--accent, #2563eb);\n}\n.ecw-da-regen-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.ecw-da-tokens {\n  font-size: 0.72rem;\n  color: var(--text-secondary, #71717a);\n  opacity: 0.65;\n}\n\n/* Dark overrides for ecw-da-* */\n[data-theme=\"dark\"] .ecw-da-overview   { background: var(--bg-secondary); border-color: var(--border-color); }\n[data-theme=\"dark\"] .ecw-da-section    { background: var(--bg-secondary); border-color: var(--border-color); }\n[data-theme=\"dark\"] .ecw-da-table      { border-color: var(--border-color); }\n[data-theme=\"dark\"] .ecw-da-row        { border-bottom-color: var(--border-color); }\n[data-theme=\"dark\"] .ecw-da-flags-section { background: rgba(239, 68, 68, 0.06); }\n[data-theme=\"dark\"] .ecw-da-rec-item   { background: rgba(37, 99, 235, 0.1); border-color: rgba(37, 99, 235, 0.2); }\n\n/* =============================================================================\n   13. Dark Theme Overrides — EntityContextWindow\n   ============================================================================= */\n[data-theme=\"dark\"] .ecw-modal {\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);\n}\n[data-theme=\"dark\"] .ecw-stats-bar  { background: var(--bg-tertiary); }\n[data-theme=\"dark\"] .ecw-tab.active { background: transparent; }\n[data-theme=\"dark\"] .ecw-body       { background: var(--bg-primary); }\n[data-theme=\"dark\"] .ecw-rel-group,\n[data-theme=\"dark\"] .ecw-evidence-row,\n[data-theme=\"dark\"] .ecw-similar-row,\n[data-theme=\"dark\"] .ecw-props-table { background: var(--bg-secondary); border-color: var(--border-color); }\n[data-theme=\"dark\"] .ecw-rel-group-toggle:hover { background: var(--bg-tertiary); }\n[data-theme=\"dark\"] .ecw-rel-entity-row { border-bottom-color: var(--border-color); }\n[data-theme=\"dark\"] .ecw-similar-bar  { background: var(--bg-tertiary); }\n[data-theme=\"dark\"] .ecw-prop-row     { border-bottom-color: var(--border-color); }\n[data-theme=\"dark\"] .ecw-rel-count-badge { background: var(--bg-tertiary); }\n\n/* =============================================================================\n   12. Dark Theme Overrides\n   Patches for components that still use hardcoded colours in light-mode styles\n   ============================================================================= */\n[data-theme=\"dark\"] {\n\n  /* ── Shared ──────────────────────────────────────────────────────────────── */\n  mark { background: rgba(250,204,21,.25); }\n\n  /* ── Rating badges ──────────────────────────────────────────────────────── */\n  .rating-high { background: rgba(16,185,129,.2); color: #34d399; }\n  .rating-med  { background: rgba(245,158,11,.2);  color: #fbbf24; }\n  .rating-low  { background: rgba(156,163,175,.2); color: #9ca3af; }\n\n  /* ── KGP page ────────────────────────────────────────────────────────────── */\n  .kgp-search-row,\n  .kgp-subtabs { background: var(--bg-secondary); }\n\n  /* ── Community cards ─────────────────────────────────────────────────────── */\n  .community-card:hover { box-shadow: 0 6px 20px rgba(0,0,0,.4); }\n  .community-error-state { background: rgba(239,68,68,.1); }\n\n  /* ── CommunityDetailPanel ───────────────────────────────────────────────── */\n  .cdp-back-btn:hover,\n  .cdp-node-item:hover,\n  .cdp-node-item.highlighted { background: var(--bg-tertiary); }\n  .cdp-edge-tooltip { box-shadow: 0 4px 16px rgba(0,0,0,.5); }\n\n  /* ── EntityTreeViewer ───────────────────────────────────────────────────── */\n  .etv-controls { background: var(--bg-tertiary); }\n  .etv-seg-btn.active { background: var(--bg-secondary); }\n\n  /* ── Search results ─────────────────────────────────────────────────────── */\n  .sr-panel { box-shadow: 0 10px 30px rgba(0,0,0,.5); }\n  .sr-evidence-quote { background: var(--bg-tertiary); border-left-color: var(--border-color); }\n  .sr-entity-tag { background: rgba(59,130,246,.15); }\n\n  /* ── LatentConnectionPanel ───────────────────────────────────────────────── */\n  .lcp-seed-info { background: rgba(37,99,235,.15); border-bottom-color: rgba(37,99,235,.3); color: #93c5fd; }\n  .lcp-tabs { background: var(--bg-secondary); }\n  .lcp-tab.active { background: var(--bg-tertiary); }\n  .lcp-tab-count { background: var(--bg-tertiary); color: var(--text-secondary); }\n  .lcp-tab-content { background: var(--bg-primary); }\n  .lcp-conn-row { background: var(--bg-secondary); }\n  .lcp-conn-row:hover { background: var(--bg-tertiary); }\n  .lcp-bridge-row { background: var(--bg-secondary); }\n  .lcp-comm-pill { background: var(--bg-tertiary); border-color: var(--border-color); }\n  .lcp-conf-bar { background: var(--bg-tertiary); }\n  .conf-strong { background: rgba(16,185,129,.2); color: #34d399; }\n  .conf-mod    { background: rgba(245,158,11,.2);  color: #fbbf24; }\n  .conf-weak   { background: var(--bg-tertiary);   color: var(--text-secondary); }\n  .lcp-reason-attr { background: rgba(194,65,12,.15); color: #fb923c; border-color: rgba(194,65,12,.3); }\n  .lcp-reason-cooc { background: rgba(29,78,216,.15);  color: #60a5fa; border-color: rgba(29,78,216,.3); }\n  .lcp-suggestions { background: var(--bg-secondary); }\n\n  /* ── DocumentDNAList ─────────────────────────────────────────────────────── */\n  .dna-row:hover { box-shadow: 0 4px 16px rgba(0,0,0,.35); }\n  .dna-row-failed { border-left-color: #f87171; }\n  .dna-status-badge.dna-status-ok      { background: rgba(16,185,129,.2); color: #34d399; }\n  .dna-status-badge.dna-status-pending { background: rgba(245,158,11,.2);  color: #fbbf24; }\n  .dna-status-badge.dna-status-fail    { background: rgba(239,68,68,.2);   color: #f87171; }\n  .dna-failed-notice { background: rgba(239,68,68,.15); color: #f87171; border-color: rgba(239,68,68,.3); }\n  /* status icon colours in dark mode */\n  .dna-status-ok   { color: #34d399; }\n  .dna-status-pending { color: #fbbf24; }\n  .dna-status-fail { color: #f87171; }\n\n  /* ── DocumentNetworkGraph ───────────────────────────────────────────────── */\n  .dng-graph-area { background: var(--bg-primary); }\n  .dng-sidebar-wrap { background: var(--bg-secondary); }\n  .dng-conn-row { border-bottom-color: var(--border-color); }\n  .dng-edge-docs { background: var(--bg-primary); }\n  .dng-entity-tag { background: var(--bg-secondary); }\n  .dng-entity-tag:hover { background: rgba(59,130,246,.1); }\n  .dng-shared-count { background: rgba(99,102,241,.2); color: #818cf8; }\n\n  /* ── KnowledgeTimelineChart ─────────────────────────────────────────────── */\n  .ktc-view-btn.active { background: var(--bg-tertiary); }\n  .ktc-summary { background: var(--bg-secondary); }\n  .ktc-major-notice { background: rgba(245,158,11,.15); color: #fbbf24; border-color: rgba(245,158,11,.3); }\n  .ktc-table th { background: var(--bg-tertiary); }\n  .ktc-sortable:hover { background: var(--bg-secondary); }\n  .ktc-table-row { border-bottom-color: var(--border-color); }\n  .ktc-table-row:hover { background: var(--bg-tertiary); }\n\n  /* ── DocumentNetworkGraph: enhanced sidebar dark overrides ──────────────── */\n  .dng-doc-meta { border-bottom-color: var(--border-color); }\n  .dng-doc-description { border-bottom-color: var(--border-color); }\n  .dng-sidebar-actions { border-top-color: var(--border-color); }\n  .dng-open-doc-btn { background: var(--bg-secondary); border-color: var(--border-color); }\n  .dng-open-doc-btn:hover { background: var(--accent); }\n  .dng-status-processed, .dng-status-completed, .dng-status-indexed { background: rgba(16,185,129,.18); color: #34d399; }\n  .dng-status-pending, .dng-status-queued, .dng-status-processing { background: rgba(245,158,11,.18); color: #fbbf24; }\n  .dng-status-failed, .dng-status-error { background: rgba(239,68,68,.18); color: #f87171; }\n  .dng-conn-list .dng-conn-row { border-bottom-color: var(--border-color); }\n\n  /* ── DocumentDNAList: description dark overrides ────────────────────────── */\n  .dna-detail-description { background: var(--bg-secondary); border-color: var(--border-color); }\n\n  /* ── DocumentBridgePanel ────────────────────────────────────────────────── */\n  .dbp-selectors { background: var(--bg-tertiary); }\n  .dbp-selector { background: var(--bg-secondary); color: var(--text-primary); }\n  .dbp-vs-divider { background: var(--bg-tertiary); color: var(--text-secondary); }\n  .dbp-stats-row { background: var(--bg-secondary); border-bottom-color: var(--border-color); }\n  .dbp-entity-row { background: var(--bg-secondary); }\n  .dbp-entity-list { background: var(--bg-primary); }\n  .dbp-entity-name:hover { color: var(--accent); }\n  .dbp-hint { background: rgba(194,65,12,.15); color: #fb923c; }\n  .dbp-graph-title { background: rgba(24,24,27,.8); color: var(--text-secondary); }\n  .dbp-graph-canvas { background: var(--bg-secondary); }\n  .dbp-edge-tooltip { box-shadow: 0 4px 12px rgba(0,0,0,.5); }\n\n  /* ── DocumentBridgePanel: card compare dark overrides ───────────────────── */\n  .dbp-card-compare { background: var(--bg-primary); }\n  .dbp-doc-card { background: var(--bg-secondary); border-color: var(--border-color); box-shadow: 0 2px 8px rgba(0,0,0,.3); }\n  .dbp-doc-card-link { border-top-color: var(--border-color); }\n  .dbp-card-compare-line { background: var(--border-color); }\n  .dbp-card-compare-badge { background: var(--bg-secondary); box-shadow: 0 2px 8px rgba(37,99,235,.2); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
